// GENERATED by `pnpm sfx:lock` (apps/client/scripts/sfx/lock.mjs) from content/audio/sfx.banks.json
// and the generated story-cue and music banks (content/audio/sfx.cues.banks.json, sfx.music.banks.json; tools/sfx-index).
// Do not edit: change the banks file and re-run the lock.

export const SFX_VERSION = 189476673;

export type SfxKey =
  | 'amb.birds'
  | 'amb.bog'
  | 'amb.cave'
  | 'amb.creak'
  | 'amb.crickets'
  | 'amb.crypt'
  | 'amb.drip'
  | 'amb.dunes'
  | 'amb.ember'
  | 'amb.frogs'
  | 'amb.ghost'
  | 'amb.hall'
  | 'amb.highland'
  | 'amb.ice'
  | 'amb.rumble'
  | 'amb.snowland'
  | 'amb.wood'
  | 'announce.annihilation'
  | 'announce.capture_the_flag'
  | 'announce.dominating'
  | 'announce.double_kill'
  | 'announce.elimination'
  | 'announce.enemy_eliminated'
  | 'announce.eradication'
  | 'announce.final_stand'
  | 'announce.first_blood'
  | 'announce.game_over'
  | 'announce.headshot'
  | 'announce.killshot'
  | 'announce.last_man_standing'
  | 'announce.mission_accomplished'
  | 'announce.mission_failed'
  | 'announce.objective_completed'
  | 'announce.payback'
  | 'announce.payload_delivered'
  | 'announce.precision_kill'
  | 'announce.rampage'
  | 'announce.revenge_kill'
  | 'announce.round_winner'
  | 'announce.start'
  | 'announce.tango_down'
  | 'announce.target_locked'
  | 'announce.target_secured'
  | 'announce.team_deathmatch'
  | 'announce.triple_kill'
  | 'announce.unstoppable'
  | 'arrow.fly'
  | 'arrow.hit'
  | 'arrow.hit_armour'
  | 'arrow.volley'
  | 'bark.bard_attack'
  | 'bark.bard_downed'
  | 'bark.bard_item'
  | 'bark.bard_level'
  | 'bark.bard_ready'
  | 'bark.bard_victory'
  | 'bark.cleric_attack'
  | 'bark.cleric_downed'
  | 'bark.cleric_item'
  | 'bark.cleric_level'
  | 'bark.cleric_ready'
  | 'bark.cleric_victory'
  | 'bark.druid_attack'
  | 'bark.druid_downed'
  | 'bark.druid_item'
  | 'bark.druid_level'
  | 'bark.druid_ready'
  | 'bark.druid_victory'
  | 'bark.fighter_attack'
  | 'bark.fighter_downed'
  | 'bark.fighter_item'
  | 'bark.fighter_level'
  | 'bark.fighter_ready'
  | 'bark.fighter_victory'
  | 'bark.paladin_attack'
  | 'bark.paladin_downed'
  | 'bark.paladin_item'
  | 'bark.paladin_level'
  | 'bark.paladin_ready'
  | 'bark.paladin_victory'
  | 'bark.ranger_attack'
  | 'bark.ranger_downed'
  | 'bark.ranger_item'
  | 'bark.ranger_level'
  | 'bark.ranger_ready'
  | 'bark.ranger_victory'
  | 'bark.rogue_attack'
  | 'bark.rogue_downed'
  | 'bark.rogue_item'
  | 'bark.rogue_level'
  | 'bark.rogue_ready'
  | 'bark.rogue_victory'
  | 'bark.wizard_attack'
  | 'bark.wizard_downed'
  | 'bark.wizard_item'
  | 'bark.wizard_level'
  | 'bark.wizard_ready'
  | 'bark.wizard_victory'
  | 'body.bones'
  | 'body.fall'
  | 'body.fall_big'
  | 'body.splat'
  | 'bow.crossbow'
  | 'bow.draw'
  | 'bow.release'
  | 'cine.born'
  | 'cine.chapter'
  | 'cine.cry'
  | 'cine.defeat'
  | 'cine.escape'
  | 'cine.glitch'
  | 'cine.line'
  | 'cine.name'
  | 'cine.objective'
  | 'cine.page'
  | 'cine.reveal'
  | 'cine.rise'
  | 'cine.saga'
  | 'cine.shimmer'
  | 'cine.tick'
  | 'cine.title'
  | 'cine.victory'
  | 'cine.writing'
  | 'cue.acid_hiss'
  | 'cue.arena_bed'
  | 'cue.armor_buckle'
  | 'cue.armor_clank'
  | 'cue.arrow_fly'
  | 'cue.bat_wings'
  | 'cue.battle_far'
  | 'cue.bear_roar'
  | 'cue.beast_burrow'
  | 'cue.bell_small'
  | 'cue.bell_toll'
  | 'cue.big_cat_roar'
  | 'cue.birds_flee'
  | 'cue.birdsong'
  | 'cue.blessing_buff'
  | 'cue.boat_oars'
  | 'cue.bone_crack'
  | 'cue.bones_rattle'
  | 'cue.book_slam'
  | 'cue.braam'
  | 'cue.braam_dark'
  | 'cue.braam_epic'
  | 'cue.branch_snap'
  | 'cue.bubbling'
  | 'cue.candle_out'
  | 'cue.cart_wheels'
  | 'cue.cat_meow'
  | 'cue.cave_bed'
  | 'cue.cave_echo'
  | 'cue.chains'
  | 'cue.chant'
  | 'cue.child_cry'
  | 'cue.clock_tick'
  | 'cue.cloth_flutter'
  | 'cue.coin_bag'
  | 'cue.coins'
  | 'cue.crafting'
  | 'cue.creak'
  | 'cue.crow_caw'
  | 'cue.crowd_cheer'
  | 'cue.crowd_panic'
  | 'cue.deep_drone'
  | 'cue.desert_bed'
  | 'cue.dig'
  | 'cue.dog_bark'
  | 'cue.door_creak'
  | 'cue.door_knock'
  | 'cue.door_slam'
  | 'cue.dragon_roar'
  | 'cue.dungeon_bed'
  | 'cue.earth_magic'
  | 'cue.earthquake'
  | 'cue.eating'
  | 'cue.eerie_drone'
  | 'cue.electric_crackle'
  | 'cue.enchanted_blade'
  | 'cue.energy_hum'
  | 'cue.explosion'
  | 'cue.farm_animals'
  | 'cue.fire_bed'
  | 'cue.fire_crackle'
  | 'cue.fire_spell'
  | 'cue.fire_whoosh'
  | 'cue.footsteps'
  | 'cue.footsteps_run'
  | 'cue.forest_bed'
  | 'cue.frogs'
  | 'cue.gasp'
  | 'cue.gate_iron'
  | 'cue.ghost_moan'
  | 'cue.glass_break'
  | 'cue.glitch'
  | 'cue.glow_hum'
  | 'cue.goblin_cackle'
  | 'cue.goblin_shout'
  | 'cue.gore'
  | 'cue.hail'
  | 'cue.hammer_anvil'
  | 'cue.heartbeat'
  | 'cue.heartfelt_sting'
  | 'cue.hell_bed'
  | 'cue.hoofbeats'
  | 'cue.horde_roar'
  | 'cue.horn_call'
  | 'cue.horror_bed'
  | 'cue.horse_neigh'
  | 'cue.ice_crack'
  | 'cue.ice_magic'
  | 'cue.impact_deep'
  | 'cue.impact_earth'
  | 'cue.impact_far'
  | 'cue.impact_magic'
  | 'cue.impact_metal'
  | 'cue.inner_voice'
  | 'cue.insect_swarm'
  | 'cue.insects_night'
  | 'cue.jump_scare'
  | 'cue.laugh_evil'
  | 'cue.lightning'
  | 'cue.lock_click'
  | 'cue.magic_cast'
  | 'cue.magic_dark'
  | 'cue.magic_holy'
  | 'cue.magic_sparkle'
  | 'cue.market'
  | 'cue.mechanism'
  | 'cue.mine_bed'
  | 'cue.monster_appear'
  | 'cue.monster_growl'
  | 'cue.monster_roar'
  | 'cue.music_box'
  | 'cue.night_bed'
  | 'cue.ocean_bed'
  | 'cue.paper'
  | 'cue.piano_dissonant'
  | 'cue.port_bed'
  | 'cue.portal'
  | 'cue.potion_pour'
  | 'cue.power_up'
  | 'cue.pulse_ping'
  | 'cue.punch'
  | 'cue.quill'
  | 'cue.rain_bed'
  | 'cue.rain_burst'
  | 'cue.rat_squeak'
  | 'cue.relic_reveal'
  | 'cue.reverse_swell'
  | 'cue.riser'
  | 'cue.riser_bright'
  | 'cue.riser_dark'
  | 'cue.rockfall'
  | 'cue.rope_strain'
  | 'cue.rustle'
  | 'cue.scream'
  | 'cue.seagulls'
  | 'cue.shimmer'
  | 'cue.ship_bed'
  | 'cue.ship_creak'
  | 'cue.silence'
  | 'cue.slime_squelch'
  | 'cue.smithy_bed'
  | 'cue.smoke_puff'
  | 'cue.snake_hiss'
  | 'cue.spawn'
  | 'cue.splash'
  | 'cue.star_fall'
  | 'cue.static_whisper'
  | 'cue.sting_sad'
  | 'cue.sting_shock'
  | 'cue.sting_wonder'
  | 'cue.stinger_doom'
  | 'cue.stinger_mystery'
  | 'cue.stinger_triumph'
  | 'cue.stone_grind'
  | 'cue.storm_bed'
  | 'cue.stream'
  | 'cue.sub_drop'
  | 'cue.swamp_bed'
  | 'cue.sword_clash'
  | 'cue.sword_draw'
  | 'cue.sword_sheathe'
  | 'cue.tavern'
  | 'cue.teleport'
  | 'cue.tension_build'
  | 'cue.thud'
  | 'cue.thunder'
  | 'cue.thunder_far'
  | 'cue.thunder_spell'
  | 'cue.time_warp'
  | 'cue.torch_light'
  | 'cue.town_bed'
  | 'cue.trap_spring'
  | 'cue.tree_fall'
  | 'cue.undead_groan'
  | 'cue.village_bed'
  | 'cue.war_drums'
  | 'cue.war_shout'
  | 'cue.water_drip'
  | 'cue.water_rush'
  | 'cue.water_spell'
  | 'cue.waterfall_bed'
  | 'cue.waves'
  | 'cue.whip'
  | 'cue.whisper'
  | 'cue.whoosh'
  | 'cue.whoosh_air'
  | 'cue.whoosh_fire'
  | 'cue.whoosh_heavy'
  | 'cue.whoosh_magic'
  | 'cue.wind_bed'
  | 'cue.wind_gust'
  | 'cue.wind_magic'
  | 'cue.wind_moan'
  | 'cue.wind_night'
  | 'cue.wolf_howl'
  | 'cue.wood_break'
  | 'cue.wood_hit'
  | 'emote.angry'
  | 'emote.cant'
  | 'emote.come'
  | 'emote.crying'
  | 'emote.cute'
  | 'emote.dizzy'
  | 'emote.down'
  | 'emote.drooling'
  | 'emote.drumroll'
  | 'emote.eager'
  | 'emote.exclamation'
  | 'emote.fanfare'
  | 'emote.frustrated'
  | 'emote.headblown'
  | 'emote.idea'
  | 'emote.kissing'
  | 'emote.lament'
  | 'emote.laughing'
  | 'emote.left'
  | 'emote.lit'
  | 'emote.love'
  | 'emote.neutral'
  | 'emote.no'
  | 'emote.ok'
  | 'emote.omg'
  | 'emote.question'
  | 'emote.right'
  | 'emote.serenade'
  | 'emote.silence'
  | 'emote.sleepy'
  | 'emote.speechless'
  | 'emote.sweat'
  | 'emote.thinking'
  | 'emote.tongue'
  | 'emote.tune'
  | 'emote.up'
  | 'emote.yes'
  | 'enc.appear'
  | 'enc.begin'
  | 'enc.braam'
  | 'enc.defeat'
  | 'enc.fled'
  | 'enc.horn'
  | 'enc.melee'
  | 'enc.victory'
  | 'event.card'
  | 'hazard.water'
  | 'hit.armour'
  | 'hit.blood'
  | 'hit.blunt'
  | 'hit.bone'
  | 'hit.claw'
  | 'hit.guard_break'
  | 'hit.heavy'
  | 'hit.parry'
  | 'hit.shield'
  | 'hit.slash'
  | 'hit.slime'
  | 'hit.stab'
  | 'huge.debris'
  | 'huge.fire_hit'
  | 'huge.reveal'
  | 'inn.applause'
  | 'inn.aww'
  | 'inn.bark'
  | 'inn.bell'
  | 'inn.candle'
  | 'inn.cards'
  | 'inn.cheers'
  | 'inn.chips'
  | 'inn.clap'
  | 'inn.clink'
  | 'inn.coin_flip'
  | 'inn.coins_pot'
  | 'inn.coins_win'
  | 'inn.dice_one'
  | 'inn.dice_settle'
  | 'inn.dice_throw'
  | 'inn.gasp'
  | 'inn.groan'
  | 'inn.laugh'
  | 'inn.mug'
  | 'inn.mug_slide'
  | 'inn.page'
  | 'inn.poke'
  | 'inn.pour'
  | 'inn.purr'
  | 'inn.quill'
  | 'inn.rooster'
  | 'inn.snore'
  | 'inn.stairs'
  | 'inn.stick'
  | 'inn.turn'
  | 'item.bell'
  | 'item.book'
  | 'item.buff'
  | 'item.cards'
  | 'item.chime'
  | 'item.coins'
  | 'item.crafting'
  | 'item.drink'
  | 'item.drink_magic'
  | 'item.drum'
  | 'item.eat'
  | 'item.eat_magic'
  | 'item.enchant'
  | 'item.equip_axe'
  | 'item.equip_boots'
  | 'item.equip_bow'
  | 'item.equip_chain'
  | 'item.equip_cloth'
  | 'item.equip_club'
  | 'item.equip_crossbow'
  | 'item.equip_dagger'
  | 'item.equip_flail'
  | 'item.equip_leather'
  | 'item.equip_mace'
  | 'item.equip_magic'
  | 'item.equip_plate'
  | 'item.equip_shield_metal'
  | 'item.equip_shield_wood'
  | 'item.equip_spear'
  | 'item.equip_staff'
  | 'item.equip_sword'
  | 'item.gems'
  | 'item.gold'
  | 'item.gore_slash'
  | 'item.harp'
  | 'item.horn'
  | 'item.keys'
  | 'item.lootbox'
  | 'item.magic_slash'
  | 'item.portal'
  | 'item.powder'
  | 'item.rattle'
  | 'item.scroll'
  | 'item.shards'
  | 'item.spawn'
  | 'item.uncork'
  | 'liquid.fire'
  | 'liquid.lava'
  | 'liquid.water'
  | 'mech.door'
  | 'mech.lever'
  | 'mech.trap'
  | 'move.abyss'
  | 'move.acid'
  | 'move.avalanche'
  | 'move.bellow'
  | 'move.blizzard'
  | 'move.blood'
  | 'move.bones'
  | 'move.boulder'
  | 'move.brood'
  | 'move.burrow'
  | 'move.cackle'
  | 'move.chill'
  | 'move.command'
  | 'move.dive'
  | 'move.drums'
  | 'move.engulf'
  | 'move.fire'
  | 'move.gaze'
  | 'move.gears'
  | 'move.glamour'
  | 'move.gore'
  | 'move.gulp'
  | 'move.hiss'
  | 'move.howl'
  | 'move.inferno'
  | 'move.ink'
  | 'move.lash'
  | 'move.leap'
  | 'move.mend'
  | 'move.necrotic'
  | 'move.net'
  | 'move.parry'
  | 'move.petrify'
  | 'move.quake'
  | 'move.roar'
  | 'move.runes'
  | 'move.screech'
  | 'move.shadow'
  | 'move.shadowflame'
  | 'move.shield_wall'
  | 'move.slime'
  | 'move.smash'
  | 'move.smoke'
  | 'move.snap'
  | 'move.spines'
  | 'move.splash_in'
  | 'move.splash_out'
  | 'move.surface'
  | 'move.swarm'
  | 'move.sweep'
  | 'move.tide'
  | 'move.timber'
  | 'move.trick'
  | 'move.trumpet'
  | 'move.upwell'
  | 'move.venom'
  | 'move.wail'
  | 'move.web'
  | 'move.whirl'
  | 'move.wings'
  | 'music.battle'
  | 'music.dread'
  | 'music.haven'
  | 'music.mystery'
  | 'music.playful'
  | 'music.sorrow'
  | 'music.tavern'
  | 'music.tension'
  | 'music.title'
  | 'music.triumph'
  | 'music.wander'
  | 'music.wonder'
  | 'objective.progress'
  | 'order.all_on_the_held_one.cultist.brute'
  | 'order.all_on_the_held_one.cultist.zealot'
  | 'order.all_on_the_held_one.demon.brute'
  | 'order.all_on_the_held_one.demon.zealot'
  | 'order.all_on_the_held_one.orc.brute'
  | 'order.all_on_the_held_one.orc.zealot'
  | 'order.all_on_the_held_one.zombie.brute'
  | 'order.all_on_the_held_one.zombie.zealot'
  | 'order.all_that_glitters.mimic.brute'
  | 'order.all_that_glitters.mimic.lurker'
  | 'order.arrows_for_the_offender.cultist.warlord'
  | 'order.arrows_for_the_offender.cultist.zealot'
  | 'order.arrows_for_the_offender.gnoll.warlord'
  | 'order.arrows_for_the_offender.gnoll.zealot'
  | 'order.arrows_for_the_offender.soldier.warlord'
  | 'order.arrows_for_the_offender.soldier.zealot'
  | 'order.await_their_coming.cultist.lurker'
  | 'order.await_their_coming.cultist.warlord'
  | 'order.await_their_coming.lizardfolk.lurker'
  | 'order.await_their_coming.lizardfolk.warlord'
  | 'order.await_their_coming.skeleton.lurker'
  | 'order.await_their_coming.skeleton.warlord'
  | 'order.back_to_the_den.beast.beastmaster'
  | 'order.back_to_the_den.beast.lurker'
  | 'order.back_to_the_den.spider.beastmaster'
  | 'order.back_to_the_den.spider.lurker'
  | 'order.back_to_the_den.wolf.beastmaster'
  | 'order.back_to_the_den.wolf.lurker'
  | 'order.bait_the_bull.dark_elf.schemer'
  | 'order.bait_the_bull.dark_elf.warlord'
  | 'order.bait_the_bull.demon.schemer'
  | 'order.bait_the_bull.goblin.schemer'
  | 'order.bait_the_bull.goblin.warlord'
  | 'order.bait_the_bull.minotaur.warlord'
  | 'order.bait_the_crossbows.bandit.schemer'
  | 'order.bait_the_crossbows.bandit.warlord'
  | 'order.bait_the_crossbows.dark_elf.schemer'
  | 'order.bait_the_crossbows.dark_elf.warlord'
  | 'order.bar_the_ice_pass.grim_giant.brute'
  | 'order.bar_the_ice_pass.grim_giant.hexer'
  | 'order.bar_the_ice_pass.grim_giant.warlord'
  | 'order.bar_the_ice_pass.winter_court.hexer'
  | 'order.beneath_the_dunes.sand_tentacles.lurker'
  | 'order.beneath_the_dunes.sandworm.brute'
  | 'order.beneath_the_dunes.sandworm.lurker'
  | 'order.beneath_the_dunes.vermin.brute'
  | 'order.beneath_the_dunes.vermin.lurker'
  | 'order.bleed_the_clock.bandit.schemer'
  | 'order.bleed_the_clock.bandit.warlord'
  | 'order.bleed_the_clock.dark_elf.schemer'
  | 'order.bleed_the_clock.dark_elf.warlord'
  | 'order.bleed_the_clock.goblin.schemer'
  | 'order.bleed_the_clock.goblin.warlord'
  | 'order.bleed_the_clock.golem.schemer'
  | 'order.bleed_the_clock.golem.warlord'
  | 'order.bleed_the_clock.winter_court.schemer'
  | 'order.blessing_of_the_charge.elemental.brute'
  | 'order.blessing_of_the_charge.elemental.hexer'
  | 'order.blessing_of_the_charge.orc.brute'
  | 'order.blessing_of_the_charge.orc.hexer'
  | 'order.blessing_of_the_charge.troll.brute'
  | 'order.blessing_of_the_charge.troll.hexer'
  | 'order.blood_for_the_chief.cultist.brute'
  | 'order.blood_for_the_chief.cultist.warlord'
  | 'order.blood_for_the_chief.cultist.zealot'
  | 'order.blood_for_the_chief.gnoll.brute'
  | 'order.blood_for_the_chief.gnoll.warlord'
  | 'order.blood_for_the_chief.gnoll.zealot'
  | 'order.blood_for_the_chief.orc.brute'
  | 'order.blood_for_the_chief.orc.warlord'
  | 'order.blood_for_the_chief.orc.zealot'
  | 'order.blood_frenzy.beast.brute'
  | 'order.blood_frenzy.demon.brute'
  | 'order.blood_frenzy.demon.zealot'
  | 'order.blood_frenzy.gnoll.brute'
  | 'order.blood_frenzy.gnoll.zealot'
  | 'order.blood_frenzy.orc.brute'
  | 'order.blood_frenzy.orc.zealot'
  | 'order.blood_frenzy.troll.brute'
  | 'order.blood_frenzy.troll.zealot'
  | 'order.blood_on_the_wind.beast.lurker'
  | 'order.blood_on_the_wind.fey.hexer'
  | 'order.blood_on_the_wind.fey.lurker'
  | 'order.blood_on_the_wind.gnoll.hexer'
  | 'order.blood_on_the_wind.gnoll.lurker'
  | 'order.blood_on_the_wind.wolf.hexer'
  | 'order.blood_on_the_wind.wolf.lurker'
  | 'order.blood_price.cultist.hexer'
  | 'order.blood_price.cultist.zealot'
  | 'order.blood_price.demon.hexer'
  | 'order.blood_price.demon.zealot'
  | 'order.blood_price.gnoll.hexer'
  | 'order.blood_price.gnoll.zealot'
  | 'order.blood_price.orc.hexer'
  | 'order.blood_price.orc.zealot'
  | 'order.blood_price.vampire.hexer'
  | 'order.boars_snout.grim_giant.brute'
  | 'order.boars_snout.grim_giant.hexer'
  | 'order.boars_snout.grim_giant.warlord'
  | 'order.bolts_and_bombs.bandit.schemer'
  | 'order.bolts_and_bombs.bandit.warlord'
  | 'order.bolts_and_bombs.duergar.schemer'
  | 'order.bolts_and_bombs.duergar.warlord'
  | 'order.bolts_and_bombs.goblin.schemer'
  | 'order.bolts_and_bombs.goblin.warlord'
  | 'order.bone_hounds.skeleton.beastmaster'
  | 'order.bone_hounds.skeleton.hexer'
  | 'order.bone_hounds.zombie.hexer'
  | 'order.bound_and_cover.bandit.schemer'
  | 'order.bound_and_cover.bandit.warlord'
  | 'order.bound_and_cover.skeleton.schemer'
  | 'order.bound_and_cover.skeleton.warlord'
  | 'order.bounding_overwatch.bandit.schemer'
  | 'order.bounding_overwatch.bandit.warlord'
  | 'order.bounding_overwatch.dark_elf.schemer'
  | 'order.bounding_overwatch.dark_elf.warlord'
  | 'order.bounding_overwatch.goblin.schemer'
  | 'order.bounding_overwatch.goblin.warlord'
  | 'order.bows_to_the_high_ground.bandit.lurker'
  | 'order.bows_to_the_high_ground.bandit.warlord'
  | 'order.bows_to_the_high_ground.dark_elf.lurker'
  | 'order.bows_to_the_high_ground.dark_elf.warlord'
  | 'order.bows_to_the_high_ground.skeleton.lurker'
  | 'order.bows_to_the_high_ground.skeleton.warlord'
  | 'order.bring_me_the_little_fly.spider_queen.beastmaster'
  | 'order.bring_me_the_little_fly.spider_queen.brute'
  | 'order.bring_me_the_little_fly.spider_queen.lurker'
  | 'order.buried_in_the_snow.winter_court.beastmaster'
  | 'order.buried_in_the_snow.yeti.beastmaster'
  | 'order.buried_in_the_snow.yeti.brute'
  | 'order.buried_in_the_snow.yeti.lurker'
  | 'order.burn_the_wounded.demon.brute'
  | 'order.burn_the_wounded.demon.schemer'
  | 'order.burn_the_wounded.djinn.brute'
  | 'order.burn_the_wounded.djinn.schemer'
  | 'order.burn_the_wounded.dragon.brute'
  | 'order.burn_the_wounded.dragon.schemer'
  | 'order.burn_the_wounded.dragon.warlord'
  | 'order.burn_the_wounded.drake.brute'
  | 'order.call_of_the_moon.elemental.hexer'
  | 'order.call_of_the_moon.gnoll.hexer'
  | 'order.call_of_the_moon.wolf.hexer'
  | 'order.carve_the_runes.grim_giant.brute'
  | 'order.carve_the_runes.grim_giant.hexer'
  | 'order.carve_the_runes.grim_giant.warlord'
  | 'order.carve_the_runes.winter_court.hexer'
  | 'order.charge_from_the_smoke.goblin.brute'
  | 'order.charge_from_the_smoke.goblin.lurker'
  | 'order.charge_from_the_smoke.orc.brute'
  | 'order.charge_from_the_smoke.orc.lurker'
  | 'order.circle_and_wear.beast.beastmaster'
  | 'order.circle_and_wear.beast.lurker'
  | 'order.circle_and_wear.drake.beastmaster'
  | 'order.circle_and_wear.gnoll.beastmaster'
  | 'order.circle_and_wear.gnoll.lurker'
  | 'order.circle_and_wear.vampire.beastmaster'
  | 'order.circle_and_wear.vampire.lurker'
  | 'order.circle_and_wear.wolf.beastmaster'
  | 'order.circle_and_wear.wolf.lurker'
  | 'order.circle_the_stray.beast.beastmaster'
  | 'order.circle_the_stray.beast.lurker'
  | 'order.circle_the_stray.goblin.beastmaster'
  | 'order.circle_the_stray.goblin.lurker'
  | 'order.circle_the_stray.wolf.beastmaster'
  | 'order.circle_the_stray.wolf.lurker'
  | 'order.clear_the_place.gnoll.brute'
  | 'order.clear_the_place.gnoll.warlord'
  | 'order.clear_the_place.goblin.brute'
  | 'order.clear_the_place.goblin.warlord'
  | 'order.clear_the_place.orc.brute'
  | 'order.clear_the_place.orc.warlord'
  | 'order.close_on_the_caught.mimic.brute'
  | 'order.close_on_the_caught.mimic.lurker'
  | 'order.close_on_the_caught.ooze.brute'
  | 'order.close_on_the_caught.ooze.lurker'
  | 'order.close_on_the_caught.spider.brute'
  | 'order.close_on_the_caught.spider.lurker'
  | 'order.close_on_the_caught.vermin.brute'
  | 'order.close_on_the_caught.vermin.lurker'
  | 'order.close_on_the_caught.zombie.brute'
  | 'order.close_on_the_caught.zombie.lurker'
  | 'order.close_the_jaws.dark_elf.warlord'
  | 'order.close_the_jaws.orc.brute'
  | 'order.close_the_jaws.orc.warlord'
  | 'order.close_the_jaws.troll.brute'
  | 'order.close_the_jaws.troll.warlord'
  | 'order.close_the_ring.gnoll.beastmaster'
  | 'order.close_the_ring.gnoll.brute'
  | 'order.close_the_ring.gnoll.warlord'
  | 'order.close_the_ring.goblin.beastmaster'
  | 'order.close_the_ring.goblin.brute'
  | 'order.close_the_ring.goblin.warlord'
  | 'order.close_the_ring.ooze.brute'
  | 'order.close_the_ring.wolf.beastmaster'
  | 'order.close_the_ring.wolf.brute'
  | 'order.close_the_ring.wolf.warlord'
  | 'order.come_and_get_it.bandit.brute'
  | 'order.come_and_get_it.bandit.schemer'
  | 'order.come_and_get_it.demon.brute'
  | 'order.come_and_get_it.demon.schemer'
  | 'order.come_and_get_it.djinn.brute'
  | 'order.come_and_get_it.djinn.schemer'
  | 'order.come_and_get_it.gnoll.brute'
  | 'order.come_and_get_it.gnoll.schemer'
  | 'order.come_and_get_it.goblin.brute'
  | 'order.come_and_get_it.goblin.schemer'
  | 'order.cover_the_hexers.cultist.hexer'
  | 'order.cover_the_hexers.cultist.zealot'
  | 'order.cover_the_hexers.dark_elf.hexer'
  | 'order.cover_the_hexers.dark_elf.zealot'
  | 'order.cover_the_hexers.golem.hexer'
  | 'order.cover_the_hexers.witch.hexer'
  | 'order.cover_the_hexers.witch.zealot'
  | 'order.crescent_moon.cultist.warlord'
  | 'order.crescent_moon.cultist.zealot'
  | 'order.crescent_moon.dark_elf.warlord'
  | 'order.crescent_moon.dark_elf.zealot'
  | 'order.crowd_the_line.goblin.brute'
  | 'order.crowd_the_line.goblin.warlord'
  | 'order.crowd_the_line.zombie.brute'
  | 'order.crowd_the_line.zombie.warlord'
  | 'order.curse_and_crowd.mummy.hexer'
  | 'order.curse_and_crowd.mummy.warlord'
  | 'order.curse_and_crowd.zombie.hexer'
  | 'order.curse_and_crowd.zombie.warlord'
  | 'order.curse_the_caster.dark_elf.hexer'
  | 'order.curse_the_caster.dark_elf.schemer'
  | 'order.curse_the_caster.demon.hexer'
  | 'order.curse_the_caster.demon.schemer'
  | 'order.curse_the_caster.djinn.hexer'
  | 'order.curse_the_caster.djinn.schemer'
  | 'order.curse_the_caster.goblin.hexer'
  | 'order.curse_the_caster.goblin.schemer'
  | 'order.curse_the_caster.vampire.hexer'
  | 'order.curse_the_caster.vampire.schemer'
  | 'order.curse_the_threshold.cultist.hexer'
  | 'order.curse_the_threshold.cultist.zealot'
  | 'order.curse_the_threshold.lizardfolk.hexer'
  | 'order.curse_the_threshold.lizardfolk.zealot'
  | 'order.curse_the_threshold.mummy.hexer'
  | 'order.curse_the_threshold.mummy.zealot'
  | 'order.curse_the_threshold.skeleton.hexer'
  | 'order.curse_the_threshold.skeleton.zealot'
  | 'order.curse_the_threshold.witch.hexer'
  | 'order.curse_the_threshold.witch.zealot'
  | 'order.cut_off_retreat.bandit.schemer'
  | 'order.cut_off_retreat.bandit.warlord'
  | 'order.cut_off_retreat.dark_elf.schemer'
  | 'order.cut_off_retreat.dark_elf.warlord'
  | 'order.cut_off_retreat.duergar.schemer'
  | 'order.cut_off_retreat.duergar.warlord'
  | 'order.cut_off_retreat.goblin.schemer'
  | 'order.cut_off_retreat.goblin.warlord'
  | 'order.cut_out_the_quarry.beast.beastmaster'
  | 'order.cut_out_the_quarry.beast.lurker'
  | 'order.cut_out_the_quarry.gnoll.beastmaster'
  | 'order.cut_out_the_quarry.gnoll.lurker'
  | 'order.cut_out_the_quarry.wolf.beastmaster'
  | 'order.cut_out_the_quarry.wolf.lurker'
  | 'order.cut_out_the_straggler.beast.beastmaster'
  | 'order.cut_out_the_straggler.beast.lurker'
  | 'order.cut_out_the_straggler.drake.beastmaster'
  | 'order.cut_out_the_straggler.gnoll.beastmaster'
  | 'order.cut_out_the_straggler.gnoll.lurker'
  | 'order.cut_out_the_straggler.gnoll.warlord'
  | 'order.cut_out_the_straggler.spider.beastmaster'
  | 'order.cut_out_the_straggler.spider.lurker'
  | 'order.cut_out_the_straggler.wolf.beastmaster'
  | 'order.cut_out_the_straggler.wolf.lurker'
  | 'order.cut_out_the_straggler.wolf.warlord'
  | 'order.darken_the_sky.cultist.warlord'
  | 'order.darken_the_sky.cultist.zealot'
  | 'order.darken_the_sky.goblin.warlord'
  | 'order.darken_the_sky.goblin.zealot'
  | 'order.darken_the_sky.orc.warlord'
  | 'order.darken_the_sky.orc.zealot'
  | 'order.darken_the_sky.soldier.warlord'
  | 'order.darken_the_sky.soldier.zealot'
  | 'order.darts_from_the_reeds.fey.hexer'
  | 'order.darts_from_the_reeds.fey.lurker'
  | 'order.darts_from_the_reeds.lizardfolk.hexer'
  | 'order.darts_from_the_reeds.lizardfolk.lurker'
  | 'order.darts_from_the_reeds.spider.hexer'
  | 'order.darts_from_the_reeds.spider.lurker'
  | 'order.death_ground.cultist.warlord'
  | 'order.death_ground.cultist.zealot'
  | 'order.death_ground.ghost.zealot'
  | 'order.death_ground.orc.warlord'
  | 'order.death_ground.orc.zealot'
  | 'order.death_ground.skeleton.warlord'
  | 'order.death_ground.skeleton.zealot'
  | 'order.death_ground.troll.warlord'
  | 'order.death_ground.troll.zealot'
  | 'order.defeat_in_detail.bandit.schemer'
  | 'order.defeat_in_detail.bandit.warlord'
  | 'order.defeat_in_detail.dark_elf.schemer'
  | 'order.defeat_in_detail.dark_elf.warlord'
  | 'order.defeat_in_detail.skeleton.schemer'
  | 'order.defeat_in_detail.skeleton.warlord'
  | 'order.defence_in_depth.bandit.schemer'
  | 'order.defence_in_depth.bandit.warlord'
  | 'order.defence_in_depth.dark_elf.schemer'
  | 'order.defence_in_depth.dark_elf.warlord'
  | 'order.defence_in_depth.duergar.schemer'
  | 'order.defence_in_depth.duergar.warlord'
  | 'order.defence_in_depth.golem.schemer'
  | 'order.defence_in_depth.golem.warlord'
  | 'order.defence_in_depth.skeleton.schemer'
  | 'order.defence_in_depth.skeleton.warlord'
  | 'order.die_for_the_master.cultist.hexer'
  | 'order.die_for_the_master.cultist.schemer'
  | 'order.die_for_the_master.cultist.zealot'
  | 'order.die_for_the_master.dark_elf.hexer'
  | 'order.die_for_the_master.dark_elf.schemer'
  | 'order.die_for_the_master.dark_elf.zealot'
  | 'order.die_for_the_master.soldier.zealot'
  | 'order.die_for_the_master.witch.hexer'
  | 'order.die_for_the_master.witch.schemer'
  | 'order.die_for_the_master.witch.zealot'
  | 'order.double_envelopment.bandit.schemer'
  | 'order.double_envelopment.bandit.warlord'
  | 'order.double_envelopment.dark_elf.schemer'
  | 'order.double_envelopment.dark_elf.warlord'
  | 'order.double_envelopment.gnoll.schemer'
  | 'order.double_envelopment.gnoll.warlord'
  | 'order.drag_down_the_caught.beast.brute'
  | 'order.drag_down_the_caught.beast.lurker'
  | 'order.drag_down_the_caught.mimic.brute'
  | 'order.drag_down_the_caught.mimic.lurker'
  | 'order.drag_down_the_caught.ooze.brute'
  | 'order.drag_down_the_caught.ooze.lurker'
  | 'order.drag_down_the_caught.spider.brute'
  | 'order.drag_down_the_caught.spider.lurker'
  | 'order.drag_down_the_caught.wolf.brute'
  | 'order.drag_down_the_caught.wolf.lurker'
  | 'order.drag_it_into_the_black.maw_of_the_deep.brute'
  | 'order.drag_it_into_the_black.maw_of_the_deep.lurker'
  | 'order.drag_them_to_the_god.basilisk.brute'
  | 'order.drag_them_to_the_god.basilisk.hexer'
  | 'order.drag_them_to_the_god.basilisk.lurker'
  | 'order.drag_them_to_the_god.gorgon.hexer'
  | 'order.drag_them_to_the_god.gorgon.lurker'
  | 'order.draw_the_champion.dark_elf.lurker'
  | 'order.draw_the_champion.dark_elf.schemer'
  | 'order.draw_the_champion.goblin.lurker'
  | 'order.draw_the_champion.goblin.schemer'
  | 'order.draw_the_champion.gorgon.lurker'
  | 'order.draw_the_champion.gorgon.schemer'
  | 'order.draw_the_champion.witch.schemer'
  | 'order.draw_them_off.bandit.schemer'
  | 'order.draw_them_off.dark_elf.schemer'
  | 'order.draw_them_off.djinn.schemer'
  | 'order.draw_them_off.fey.schemer'
  | 'order.draw_them_off.goblin.schemer'
  | 'order.dress_ranks.lizardfolk.warlord'
  | 'order.dress_ranks.mummy.warlord'
  | 'order.dress_ranks.skeleton.warlord'
  | 'order.dress_ranks.soldier.warlord'
  | 'order.drink_of_the_fallen.cultist.hexer'
  | 'order.drink_of_the_fallen.cultist.lurker'
  | 'order.drink_of_the_fallen.cultist.zealot'
  | 'order.drink_of_the_fallen.ghost.hexer'
  | 'order.drink_of_the_fallen.ghost.lurker'
  | 'order.drink_of_the_fallen.ghost.zealot'
  | 'order.drink_of_the_fallen.gnoll.hexer'
  | 'order.drink_of_the_fallen.gnoll.lurker'
  | 'order.drink_of_the_fallen.gnoll.zealot'
  | 'order.drink_of_the_fallen.spider.hexer'
  | 'order.drink_of_the_fallen.spider.lurker'
  | 'order.drink_of_the_fallen.vampire.hexer'
  | 'order.drink_of_the_fallen.vampire.lurker'
  | 'order.drive_into_the_open.great_eagle.beastmaster'
  | 'order.drive_into_the_open.great_eagle.brute'
  | 'order.drive_the_boars.beast.beastmaster'
  | 'order.drive_the_boars.beast.brute'
  | 'order.drive_the_boars.cyclops.beastmaster'
  | 'order.drive_the_boars.cyclops.brute'
  | 'order.drive_the_boars.orc.beastmaster'
  | 'order.drive_the_boars.orc.brute'
  | 'order.drive_the_boars.troll.beastmaster'
  | 'order.drive_the_boars.troll.brute'
  | 'order.drive_them_into_the_fire.demon.brute'
  | 'order.drive_them_into_the_fire.demon.schemer'
  | 'order.drive_them_into_the_fire.djinn.brute'
  | 'order.drive_them_into_the_fire.djinn.schemer'
  | 'order.drive_them_into_the_fire.dragon.brute'
  | 'order.drive_them_into_the_fire.dragon.schemer'
  | 'order.drive_them_into_the_fire.dragon.warlord'
  | 'order.drive_them_to_the_water.kraken.brute'
  | 'order.drive_them_to_the_water.kraken.lurker'
  | 'order.drive_them_to_the_water.kraken.zealot'
  | 'order.drop_from_the_canopy.spider_queen.beastmaster'
  | 'order.drop_from_the_canopy.spider_queen.brute'
  | 'order.drop_from_the_canopy.spider_queen.lurker'
  | 'order.drop_from_the_canopy.vermin.brute'
  | 'order.drop_from_the_canopy.vermin.lurker'
  | 'order.drown_in_numbers.bandit.warlord'
  | 'order.drown_in_numbers.bandit.zealot'
  | 'order.drown_in_numbers.zombie.warlord'
  | 'order.drown_in_numbers.zombie.zealot'
  | 'order.encircle_in_ash.black_dragon.brute'
  | 'order.encircle_in_ash.black_dragon.lurker'
  | 'order.encircle_in_ash.black_dragon.schemer'
  | 'order.endless_tide.cultist.brute'
  | 'order.endless_tide.cultist.zealot'
  | 'order.endless_tide.elemental.brute'
  | 'order.endless_tide.ghost.zealot'
  | 'order.endless_tide.skeleton.brute'
  | 'order.endless_tide.skeleton.zealot'
  | 'order.endless_tide.zombie.brute'
  | 'order.endless_tide.zombie.zealot'
  | 'order.engulf_the_weak.mimic.brute'
  | 'order.engulf_the_weak.mimic.lurker'
  | 'order.engulf_the_weak.ooze.brute'
  | 'order.engulf_the_weak.ooze.lurker'
  | 'order.engulf_the_weak.spider.brute'
  | 'order.engulf_the_weak.spider.lurker'
  | 'order.engulf_the_weak.vermin.brute'
  | 'order.engulf_the_weak.vermin.lurker'
  | 'order.engulf_the_weak.wolf.brute'
  | 'order.engulf_the_weak.wolf.lurker'
  | 'order.envelop_the_prize.bandit.schemer'
  | 'order.envelop_the_prize.bandit.warlord'
  | 'order.envelop_the_prize.dark_elf.schemer'
  | 'order.envelop_the_prize.dark_elf.warlord'
  | 'order.envelop_the_prize.goblin.schemer'
  | 'order.envelop_the_prize.goblin.warlord'
  | 'order.feed_the_beast.cultist.beastmaster'
  | 'order.feed_the_beast.cultist.zealot'
  | 'order.feed_the_beast.gnoll.beastmaster'
  | 'order.feed_the_beast.gnoll.zealot'
  | 'order.feigned_rout.bandit.schemer'
  | 'order.feigned_rout.bandit.warlord'
  | 'order.feigned_rout.dark_elf.schemer'
  | 'order.feigned_rout.dark_elf.warlord'
  | 'order.feigned_rout.djinn.schemer'
  | 'order.feigned_rout.fey.schemer'
  | 'order.feigned_rout.goblin.schemer'
  | 'order.feigned_rout.goblin.warlord'
  | 'order.fetch_me_that_one.cyclops.brute'
  | 'order.fetch_me_that_one.mountain_troll.brute'
  | 'order.fetch_me_that_one.mountain_troll.lurker'
  | 'order.fetch_me_that_one.mountain_troll.warlord'
  | 'order.fighting_withdrawal.bandit.schemer'
  | 'order.fighting_withdrawal.bandit.warlord'
  | 'order.fighting_withdrawal.dark_elf.schemer'
  | 'order.fighting_withdrawal.dark_elf.warlord'
  | 'order.fighting_withdrawal.goblin.schemer'
  | 'order.fighting_withdrawal.goblin.warlord'
  | 'order.fix_and_flank.bandit.schemer'
  | 'order.fix_and_flank.bandit.warlord'
  | 'order.fix_and_flank.dark_elf.schemer'
  | 'order.fix_and_flank.dark_elf.warlord'
  | 'order.fix_and_flank.orc.schemer'
  | 'order.fix_and_flank.orc.warlord'
  | 'order.flank.bandit.beastmaster'
  | 'order.flank.bandit.brute'
  | 'order.flank.bandit.schemer'
  | 'order.flank.bandit.warlord'
  | 'order.flank.dark_elf.beastmaster'
  | 'order.flank.dark_elf.schemer'
  | 'order.flank.dark_elf.warlord'
  | 'order.flank.gnoll.beastmaster'
  | 'order.flank.gnoll.brute'
  | 'order.flank.gnoll.schemer'
  | 'order.flank.gnoll.warlord'
  | 'order.flank.goblin.beastmaster'
  | 'order.flank.goblin.brute'
  | 'order.flank.goblin.schemer'
  | 'order.flank.goblin.warlord'
  | 'order.flank.orc.beastmaster'
  | 'order.flank.orc.brute'
  | 'order.flank.orc.schemer'
  | 'order.flank.orc.warlord'
  | 'order.flee_and_loose.bandit.beastmaster'
  | 'order.flee_and_loose.bandit.schemer'
  | 'order.flee_and_loose.beholder.schemer'
  | 'order.flee_and_loose.goblin.beastmaster'
  | 'order.flee_and_loose.goblin.schemer'
  | 'order.flee_the_trembling.sandworm.brute'
  | 'order.flee_the_trembling.sandworm.lurker'
  | 'order.flow_round.elemental.brute'
  | 'order.flow_round.ooze.brute'
  | 'order.flow_round.ooze.lurker'
  | 'order.flow_round.vermin.brute'
  | 'order.flow_round.vermin.lurker'
  | 'order.flow_round.zombie.brute'
  | 'order.flow_round.zombie.lurker'
  | 'order.follow_the_light.fey.hexer'
  | 'order.follow_the_light.fey.lurker'
  | 'order.follow_the_light.fey.schemer'
  | 'order.from_the_hedgerows.bandit.lurker'
  | 'order.from_the_hedgerows.bandit.schemer'
  | 'order.from_the_hedgerows.goblin.lurker'
  | 'order.from_the_hedgerows.goblin.schemer'
  | 'order.from_the_hedgerows.lizardfolk.lurker'
  | 'order.from_the_hedgerows.lizardfolk.schemer'
  | 'order.from_the_still_water.basilisk.brute'
  | 'order.from_the_still_water.basilisk.hexer'
  | 'order.from_the_still_water.basilisk.lurker'
  | 'order.from_the_still_water.gorgon.hexer'
  | 'order.from_the_still_water.gorgon.lurker'
  | 'order.from_the_still_water.tentacles.lurker'
  | 'order.fury_of_the_peaks.yeti.beastmaster'
  | 'order.fury_of_the_peaks.yeti.brute'
  | 'order.fury_of_the_peaks.yeti.lurker'
  | 'order.fury_of_the_sacred_grove.ent.brute'
  | 'order.fury_of_the_sacred_grove.ent.lurker'
  | 'order.fury_of_the_sacred_grove.ent.zealot'
  | 'order.ghost_host.cultist.hexer'
  | 'order.ghost_host.cultist.schemer'
  | 'order.ghost_host.dark_elf.hexer'
  | 'order.ghost_host.dark_elf.schemer'
  | 'order.ghost_host.djinn.hexer'
  | 'order.ghost_host.djinn.schemer'
  | 'order.ghost_host.fey.hexer'
  | 'order.ghost_host.fey.schemer'
  | 'order.ghost_host.ghost.hexer'
  | 'order.ghosts_in_the_snow.dark_elf.hexer'
  | 'order.ghosts_in_the_snow.dark_elf.lurker'
  | 'order.ghosts_in_the_snow.ghost.hexer'
  | 'order.ghosts_in_the_snow.ghost.lurker'
  | 'order.ghosts_in_the_snow.winter_court.hexer'
  | 'order.ghosts_in_the_snow.wolf.hexer'
  | 'order.ghosts_in_the_snow.wolf.lurker'
  | 'order.guard_from_hiding.cultist.hexer'
  | 'order.guard_from_hiding.cultist.lurker'
  | 'order.guard_from_hiding.duergar.lurker'
  | 'order.guard_from_hiding.fey.hexer'
  | 'order.guard_from_hiding.fey.lurker'
  | 'order.guard_from_hiding.lizardfolk.hexer'
  | 'order.guard_from_hiding.lizardfolk.lurker'
  | 'order.guard_from_hiding.spider.hexer'
  | 'order.guard_from_hiding.spider.lurker'
  | 'order.guard_the_egg_sacs.spider_queen.beastmaster'
  | 'order.guard_the_egg_sacs.spider_queen.brute'
  | 'order.guard_the_egg_sacs.spider_queen.lurker'
  | 'order.guard_the_hoard.dragon.brute'
  | 'order.guard_the_hoard.dragon.schemer'
  | 'order.guard_the_hoard.dragon.warlord'
  | 'order.guard_the_hoard.drake.brute'
  | 'order.guard_the_hoard.mimic.brute'
  | 'order.guard_the_little_hoard.drake.beastmaster'
  | 'order.guard_the_little_hoard.drake.brute'
  | 'order.guard_the_place.cultist.brute'
  | 'order.guard_the_place.cultist.warlord'
  | 'order.guard_the_place.cultist.zealot'
  | 'order.guard_the_place.lizardfolk.brute'
  | 'order.guard_the_place.lizardfolk.warlord'
  | 'order.guard_the_place.lizardfolk.zealot'
  | 'order.guard_the_place.mummy.warlord'
  | 'order.guard_the_place.mummy.zealot'
  | 'order.guard_the_place.skeleton.brute'
  | 'order.guard_the_place.skeleton.warlord'
  | 'order.guard_the_place.skeleton.zealot'
  | 'order.hammer_and_anvil.orc.brute'
  | 'order.hammer_and_anvil.orc.warlord'
  | 'order.hammer_and_anvil.skeleton.brute'
  | 'order.hammer_and_anvil.skeleton.warlord'
  | 'order.harry.bandit.beastmaster'
  | 'order.harry.bandit.hexer'
  | 'order.harry.bandit.lurker'
  | 'order.harry.bandit.schemer'
  | 'order.harry.dark_elf.beastmaster'
  | 'order.harry.dark_elf.hexer'
  | 'order.harry.dark_elf.lurker'
  | 'order.harry.dark_elf.schemer'
  | 'order.harry.gnoll.beastmaster'
  | 'order.harry.gnoll.hexer'
  | 'order.harry.gnoll.lurker'
  | 'order.harry.gnoll.schemer'
  | 'order.harry.goblin.beastmaster'
  | 'order.harry.goblin.hexer'
  | 'order.harry.goblin.lurker'
  | 'order.harry.goblin.schemer'
  | 'order.harry.lizardfolk.beastmaster'
  | 'order.harry.lizardfolk.hexer'
  | 'order.harry.lizardfolk.lurker'
  | 'order.harry.lizardfolk.schemer'
  | 'order.hedgehog.golem.warlord'
  | 'order.hedgehog.orc.brute'
  | 'order.hedgehog.orc.warlord'
  | 'order.hedgehog.skeleton.brute'
  | 'order.hedgehog.skeleton.warlord'
  | 'order.hedgehog.troll.brute'
  | 'order.hedgehog.troll.warlord'
  | 'order.herd_the_meal_to_its_jaws.maw_of_the_deep.brute'
  | 'order.herd_the_meal_to_its_jaws.maw_of_the_deep.lurker'
  | 'order.hex_the_champion.cultist.hexer'
  | 'order.hex_the_champion.cultist.zealot'
  | 'order.hex_the_champion.dark_elf.hexer'
  | 'order.hex_the_champion.dark_elf.zealot'
  | 'order.hex_the_champion.demon.hexer'
  | 'order.hex_the_champion.demon.zealot'
  | 'order.hex_the_champion.elemental.hexer'
  | 'order.hex_the_champion.goblin.hexer'
  | 'order.hex_the_champion.goblin.zealot'
  | 'order.hit_the_baggage.bandit.lurker'
  | 'order.hit_the_baggage.bandit.schemer'
  | 'order.hit_the_baggage.orc.lurker'
  | 'order.hit_the_baggage.orc.schemer'
  | 'order.hold_for_the_working.cultist.hexer'
  | 'order.hold_for_the_working.cultist.warlord'
  | 'order.hold_for_the_working.golem.hexer'
  | 'order.hold_for_the_working.golem.warlord'
  | 'order.hold_for_the_working.lizardfolk.hexer'
  | 'order.hold_for_the_working.lizardfolk.warlord'
  | 'order.hold_for_the_working.mummy.hexer'
  | 'order.hold_for_the_working.mummy.warlord'
  | 'order.hold_for_the_working.troll.hexer'
  | 'order.hold_for_the_working.troll.warlord'
  | 'order.hold_the_bridge.golem.warlord'
  | 'order.hold_the_bridge.orc.beastmaster'
  | 'order.hold_the_bridge.orc.brute'
  | 'order.hold_the_bridge.orc.warlord'
  | 'order.hold_the_bridge.skeleton.beastmaster'
  | 'order.hold_the_bridge.skeleton.brute'
  | 'order.hold_the_bridge.skeleton.warlord'
  | 'order.hold_the_bridge.troll.beastmaster'
  | 'order.hold_the_bridge.troll.brute'
  | 'order.hold_the_bridge.troll.warlord'
  | 'order.hold_the_eyrie.great_eagle.beastmaster'
  | 'order.hold_the_eyrie.great_eagle.brute'
  | 'order.hold_the_ford.lizardfolk.brute'
  | 'order.hold_the_ford.lizardfolk.lurker'
  | 'order.hold_the_ford.troll.brute'
  | 'order.hold_the_ford.troll.lurker'
  | 'order.hold_the_grove.ent.brute'
  | 'order.hold_the_grove.ent.lurker'
  | 'order.hold_the_grove.ent.zealot'
  | 'order.hold_the_hill.bandit.brute'
  | 'order.hold_the_hill.bandit.schemer'
  | 'order.hold_the_hill.bandit.warlord'
  | 'order.hold_the_hill.goblin.brute'
  | 'order.hold_the_hill.goblin.schemer'
  | 'order.hold_the_hill.goblin.warlord'
  | 'order.hold_the_hill.orc.brute'
  | 'order.hold_the_hill.orc.schemer'
  | 'order.hold_the_hill.orc.warlord'
  | 'order.hold_the_narrows.bandit.lurker'
  | 'order.hold_the_narrows.bandit.warlord'
  | 'order.hold_the_narrows.duergar.lurker'
  | 'order.hold_the_narrows.duergar.warlord'
  | 'order.hold_the_narrows.lizardfolk.lurker'
  | 'order.hold_the_narrows.lizardfolk.warlord'
  | 'order.hold_the_narrows.minotaur.warlord'
  | 'order.hold_the_narrows.skeleton.lurker'
  | 'order.hold_the_narrows.skeleton.warlord'
  | 'order.hold_the_pass.cyclops.brute'
  | 'order.hold_the_pass.duergar.lurker'
  | 'order.hold_the_pass.duergar.warlord'
  | 'order.hold_the_pass.mountain_troll.brute'
  | 'order.hold_the_pass.mountain_troll.lurker'
  | 'order.hold_the_pass.mountain_troll.warlord'
  | 'order.hold_the_shallows.kraken.brute'
  | 'order.hold_the_shallows.kraken.lurker'
  | 'order.hold_the_shallows.kraken.zealot'
  | 'order.hold_them_in_its_gaze.basilisk.brute'
  | 'order.hold_them_in_its_gaze.basilisk.hexer'
  | 'order.hold_them_in_its_gaze.basilisk.lurker'
  | 'order.hold_them_in_its_gaze.beholder.hexer'
  | 'order.hold_them_in_its_gaze.gorgon.hexer'
  | 'order.hold_them_in_its_gaze.gorgon.lurker'
  | 'order.hold_till_the_bell.orc.brute'
  | 'order.hold_till_the_bell.orc.warlord'
  | 'order.hold_till_the_bell.skeleton.brute'
  | 'order.hold_till_the_bell.skeleton.warlord'
  | 'order.horns_of_the_bull.gnoll.brute'
  | 'order.horns_of_the_bull.gnoll.warlord'
  | 'order.horns_of_the_bull.goblin.brute'
  | 'order.horns_of_the_bull.goblin.warlord'
  | 'order.horns_of_the_bull.minotaur.brute'
  | 'order.horns_of_the_bull.minotaur.warlord'
  | 'order.horns_of_the_bull.orc.brute'
  | 'order.horns_of_the_bull.orc.warlord'
  | 'order.hounds_at_the_healer.beast.beastmaster'
  | 'order.hounds_at_the_healer.beast.lurker'
  | 'order.hounds_at_the_healer.dark_elf.beastmaster'
  | 'order.hounds_at_the_healer.dark_elf.lurker'
  | 'order.hounds_at_the_healer.vampire.beastmaster'
  | 'order.hounds_at_the_healer.vampire.lurker'
  | 'order.hounds_at_the_healer.wolf.beastmaster'
  | 'order.hounds_at_the_healer.wolf.lurker'
  | 'order.hounds_before_the_shields.cultist.beastmaster'
  | 'order.hounds_before_the_shields.cyclops.beastmaster'
  | 'order.hounds_before_the_shields.skeleton.beastmaster'
  | 'order.hounds_before_the_shields.troll.beastmaster'
  | 'order.hounds_drive_bows_kill.beast.beastmaster'
  | 'order.hounds_drive_bows_kill.gnoll.beastmaster'
  | 'order.howl_of_dread.djinn.brute'
  | 'order.howl_of_dread.djinn.hexer'
  | 'order.howl_of_dread.elemental.brute'
  | 'order.howl_of_dread.elemental.hexer'
  | 'order.howl_of_dread.gnoll.brute'
  | 'order.howl_of_dread.gnoll.hexer'
  | 'order.howl_of_dread.wolf.brute'
  | 'order.howl_of_dread.wolf.hexer'
  | 'order.hunting_ring.gnoll.beastmaster'
  | 'order.hunting_ring.gnoll.lurker'
  | 'order.hunting_ring.gnoll.warlord'
  | 'order.hunting_ring.lizardfolk.beastmaster'
  | 'order.hunting_ring.lizardfolk.lurker'
  | 'order.hunting_ring.lizardfolk.warlord'
  | 'order.hunting_ring.wolf.beastmaster'
  | 'order.hunting_ring.wolf.lurker'
  | 'order.hunting_ring.wolf.warlord'
  | 'order.huscarls_shield_wall.duergar.warlord'
  | 'order.huscarls_shield_wall.grim_giant.brute'
  | 'order.huscarls_shield_wall.grim_giant.hexer'
  | 'order.huscarls_shield_wall.grim_giant.warlord'
  | 'order.hymn_of_the_hollow.cultist.hexer'
  | 'order.hymn_of_the_hollow.cultist.zealot'
  | 'order.hymn_of_the_hollow.lizardfolk.hexer'
  | 'order.hymn_of_the_hollow.lizardfolk.zealot'
  | 'order.hymn_of_the_hollow.mummy.hexer'
  | 'order.hymn_of_the_hollow.mummy.zealot'
  | 'order.into_the_cauldron.witch.hexer'
  | 'order.into_the_cauldron.witch.schemer'
  | 'order.into_the_cauldron.witch.zealot'
  | 'order.into_the_gullet.dark_elf.schemer'
  | 'order.into_the_gullet.dark_elf.warlord'
  | 'order.into_the_gullet.golem.schemer'
  | 'order.into_the_gullet.golem.warlord'
  | 'order.into_the_gullet.lizardfolk.schemer'
  | 'order.into_the_gullet.lizardfolk.warlord'
  | 'order.into_the_gullet.minotaur.warlord'
  | 'order.into_the_murk.cultist.hexer'
  | 'order.into_the_murk.cultist.lurker'
  | 'order.into_the_murk.dark_elf.hexer'
  | 'order.into_the_murk.dark_elf.lurker'
  | 'order.into_the_murk.ghost.hexer'
  | 'order.into_the_murk.ghost.lurker'
  | 'order.into_the_murk.lizardfolk.hexer'
  | 'order.into_the_murk.lizardfolk.lurker'
  | 'order.into_the_murk.vampire.hexer'
  | 'order.into_the_murk.vampire.lurker'
  | 'order.into_the_whiteout.winter_court.beastmaster'
  | 'order.into_the_whiteout.yeti.beastmaster'
  | 'order.into_the_whiteout.yeti.brute'
  | 'order.into_the_whiteout.yeti.lurker'
  | 'order.javelins_then_steel.cultist.brute'
  | 'order.javelins_then_steel.cultist.warlord'
  | 'order.javelins_then_steel.cultist.zealot'
  | 'order.javelins_then_steel.orc.brute'
  | 'order.javelins_then_steel.orc.warlord'
  | 'order.javelins_then_steel.orc.zealot'
  | 'order.keep_their_heads_down.beholder.hexer'
  | 'order.keep_their_heads_down.cultist.hexer'
  | 'order.keep_their_heads_down.cultist.warlord'
  | 'order.keep_their_heads_down.skeleton.hexer'
  | 'order.keep_their_heads_down.skeleton.warlord'
  | 'order.kill_the_mender_first.bandit.hexer'
  | 'order.kill_the_mender_first.bandit.lurker'
  | 'order.kill_the_mender_first.bandit.schemer'
  | 'order.kill_the_mender_first.dark_elf.hexer'
  | 'order.kill_the_mender_first.dark_elf.lurker'
  | 'order.kill_the_mender_first.dark_elf.schemer'
  | 'order.kill_the_mender_first.gnoll.hexer'
  | 'order.kill_the_mender_first.gnoll.lurker'
  | 'order.kill_the_mender_first.gnoll.schemer'
  | 'order.kill_the_mender_first.vampire.hexer'
  | 'order.kill_the_mender_first.vampire.lurker'
  | 'order.kill_the_mender_first.vampire.schemer'
  | 'order.kill_the_mender_first.witch.hexer'
  | 'order.kill_the_mender_first.witch.schemer'
  | 'order.kneel_before_the_wyrm.dragon.brute'
  | 'order.kneel_before_the_wyrm.dragon.schemer'
  | 'order.kneel_before_the_wyrm.dragon.warlord'
  | 'order.lead_from_the_front.minotaur.brute'
  | 'order.lead_from_the_front.minotaur.warlord'
  | 'order.lead_from_the_front.orc.brute'
  | 'order.lead_from_the_front.orc.warlord'
  | 'order.lead_from_the_front.troll.brute'
  | 'order.lead_from_the_front.troll.warlord'
  | 'order.let_none_leave_the_trees.ent.brute'
  | 'order.let_none_leave_the_trees.ent.lurker'
  | 'order.let_none_leave_the_trees.ent.zealot'
  | 'order.let_none_leave_the_trees.fey.lurker'
  | 'order.let_them_choke.black_dragon.brute'
  | 'order.let_them_choke.black_dragon.lurker'
  | 'order.let_them_choke.black_dragon.schemer'
  | 'order.lie_like_stones.mimic.brute'
  | 'order.lie_like_stones.mimic.lurker'
  | 'order.lie_like_stones.mountain_troll.brute'
  | 'order.lie_like_stones.mountain_troll.lurker'
  | 'order.lie_like_stones.mountain_troll.warlord'
  | 'order.lie_still_in_the_deep.maw_of_the_deep.brute'
  | 'order.lie_still_in_the_deep.maw_of_the_deep.lurker'
  | 'order.loose_and_slip_away.bandit.lurker'
  | 'order.loose_and_slip_away.bandit.schemer'
  | 'order.loose_and_slip_away.beholder.schemer'
  | 'order.loose_and_slip_away.fey.lurker'
  | 'order.loose_and_slip_away.fey.schemer'
  | 'order.loose_and_slip_away.goblin.lurker'
  | 'order.loose_and_slip_away.goblin.schemer'
  | 'order.loose_and_slip_away.lizardfolk.lurker'
  | 'order.loose_and_slip_away.lizardfolk.schemer'
  | 'order.loose_the_hounds.cyclops.beastmaster'
  | 'order.loose_the_hounds.gnoll.beastmaster'
  | 'order.loose_the_hounds.goblin.beastmaster'
  | 'order.loose_the_hounds.orc.beastmaster'
  | 'order.loose_the_hounds.wolf.beastmaster'
  | 'order.loose_together.bandit.schemer'
  | 'order.loose_together.bandit.warlord'
  | 'order.loose_together.goblin.schemer'
  | 'order.loose_together.goblin.warlord'
  | 'order.loose_together.skeleton.schemer'
  | 'order.loose_together.skeleton.warlord'
  | 'order.loose_together.soldier.warlord'
  | 'order.many_arms.sand_tentacles.lurker'
  | 'order.many_arms.tentacles.lurker'
  | 'order.mark_for_the_pack.gnoll.beastmaster'
  | 'order.mark_for_the_pack.gnoll.hexer'
  | 'order.mark_for_the_pack.spider.beastmaster'
  | 'order.mark_for_the_pack.spider.hexer'
  | 'order.mark_for_the_pack.vampire.beastmaster'
  | 'order.mark_for_the_pack.vampire.hexer'
  | 'order.martyrs_price.cultist.hexer'
  | 'order.martyrs_price.cultist.zealot'
  | 'order.martyrs_price.ghost.hexer'
  | 'order.martyrs_price.ghost.zealot'
  | 'order.martyrs_price.orc.hexer'
  | 'order.martyrs_price.orc.zealot'
  | 'order.martyrs_ward.cultist.hexer'
  | 'order.martyrs_ward.cultist.zealot'
  | 'order.martyrs_ward.goblin.hexer'
  | 'order.martyrs_ward.goblin.zealot'
  | 'order.martyrs_ward.mummy.hexer'
  | 'order.martyrs_ward.mummy.zealot'
  | 'order.mend_the_line.cultist.hexer'
  | 'order.mend_the_line.cultist.zealot'
  | 'order.mend_the_line.golem.hexer'
  | 'order.mend_the_line.lizardfolk.hexer'
  | 'order.mend_the_line.lizardfolk.zealot'
  | 'order.mend_the_line.troll.hexer'
  | 'order.mend_the_line.troll.zealot'
  | 'order.mend_the_line.witch.hexer'
  | 'order.mend_the_line.witch.zealot'
  | 'order.mothers_wrath.spider_queen.beastmaster'
  | 'order.mothers_wrath.spider_queen.brute'
  | 'order.mothers_wrath.spider_queen.lurker'
  | 'order.never_give_battle.bandit.schemer'
  | 'order.never_give_battle.bandit.warlord'
  | 'order.never_give_battle.beholder.schemer'
  | 'order.never_give_battle.dark_elf.schemer'
  | 'order.never_give_battle.dark_elf.warlord'
  | 'order.never_give_battle.golem.schemer'
  | 'order.never_give_battle.golem.warlord'
  | 'order.never_give_battle.winter_court.schemer'
  | 'order.never_meet_its_eyes.basilisk.brute'
  | 'order.never_meet_its_eyes.basilisk.hexer'
  | 'order.never_meet_its_eyes.basilisk.lurker'
  | 'order.never_meet_its_eyes.beholder.hexer'
  | 'order.never_meet_its_eyes.gorgon.hexer'
  | 'order.never_meet_its_eyes.gorgon.lurker'
  | 'order.night_knives.dark_elf.hexer'
  | 'order.night_knives.dark_elf.lurker'
  | 'order.night_knives.ghost.hexer'
  | 'order.night_knives.ghost.lurker'
  | 'order.night_knives.goblin.hexer'
  | 'order.night_knives.goblin.lurker'
  | 'order.night_knives.spider.hexer'
  | 'order.night_knives.spider.lurker'
  | 'order.night_knives.vampire.hexer'
  | 'order.night_knives.vampire.lurker'
  | 'order.night_raid.gnoll.lurker'
  | 'order.night_raid.goblin.lurker'
  | 'order.night_raid.orc.lurker'
  | 'order.no_one_rises.black_dragon.brute'
  | 'order.no_one_rises.black_dragon.lurker'
  | 'order.no_one_rises.black_dragon.schemer'
  | 'order.no_quarter.demon.brute'
  | 'order.no_quarter.gnoll.brute'
  | 'order.no_quarter.gnoll.warlord'
  | 'order.no_quarter.goblin.brute'
  | 'order.no_quarter.goblin.warlord'
  | 'order.no_quarter.minotaur.brute'
  | 'order.no_quarter.minotaur.warlord'
  | 'order.no_quarter.orc.brute'
  | 'order.no_quarter.orc.warlord'
  | 'order.nobody_crosses.skeleton.brute'
  | 'order.nobody_crosses.skeleton.lurker'
  | 'order.nobody_crosses.skeleton.warlord'
  | 'order.nobody_crosses.troll.brute'
  | 'order.nobody_crosses.troll.lurker'
  | 'order.nobody_crosses.troll.warlord'
  | 'order.none_shall_pass.cultist.brute'
  | 'order.none_shall_pass.cultist.hexer'
  | 'order.none_shall_pass.cultist.zealot'
  | 'order.none_shall_pass.lizardfolk.brute'
  | 'order.none_shall_pass.lizardfolk.hexer'
  | 'order.none_shall_pass.lizardfolk.zealot'
  | 'order.none_shall_pass.troll.brute'
  | 'order.none_shall_pass.troll.hexer'
  | 'order.none_shall_pass.troll.zealot'
  | 'order.not_one_escapes.cultist.warlord'
  | 'order.not_one_escapes.cultist.zealot'
  | 'order.not_one_escapes.ghost.zealot'
  | 'order.not_one_escapes.gnoll.warlord'
  | 'order.not_one_escapes.gnoll.zealot'
  | 'order.not_one_escapes.mummy.warlord'
  | 'order.not_one_escapes.mummy.zealot'
  | 'order.not_one_escapes.orc.warlord'
  | 'order.not_one_escapes.orc.zealot'
  | 'order.oath_bound_charge.grim_giant.brute'
  | 'order.oath_bound_charge.grim_giant.hexer'
  | 'order.oath_bound_charge.grim_giant.warlord'
  | 'order.oblique_order.dark_elf.warlord'
  | 'order.oblique_order.skeleton.warlord'
  | 'order.oblique_order.soldier.warlord'
  | 'order.offer_it_the_wounded.kraken.brute'
  | 'order.offer_it_the_wounded.kraken.lurker'
  | 'order.offer_it_the_wounded.kraken.zealot'
  | 'order.on_my_signal.cultist.brute'
  | 'order.on_my_signal.cultist.warlord'
  | 'order.on_my_signal.cultist.zealot'
  | 'order.on_my_signal.goblin.brute'
  | 'order.on_my_signal.goblin.warlord'
  | 'order.on_my_signal.goblin.zealot'
  | 'order.on_my_signal.orc.brute'
  | 'order.on_my_signal.orc.warlord'
  | 'order.on_my_signal.orc.zealot'
  | 'order.one_last_throw.cultist.hexer'
  | 'order.one_last_throw.cultist.schemer'
  | 'order.one_last_throw.dark_elf.hexer'
  | 'order.one_last_throw.dark_elf.schemer'
  | 'order.one_last_throw.demon.hexer'
  | 'order.one_last_throw.demon.schemer'
  | 'order.one_last_throw.djinn.hexer'
  | 'order.one_last_throw.djinn.schemer'
  | 'order.one_last_throw.goblin.hexer'
  | 'order.one_last_throw.goblin.schemer'
  | 'order.one_target_all_arrows.beholder.hexer'
  | 'order.one_target_all_arrows.dark_elf.hexer'
  | 'order.one_target_all_arrows.dark_elf.warlord'
  | 'order.one_target_all_arrows.skeleton.hexer'
  | 'order.one_target_all_arrows.skeleton.warlord'
  | 'order.onto_the_open_sand.sandworm.brute'
  | 'order.onto_the_open_sand.sandworm.lurker'
  | 'order.open_order.elemental.brute'
  | 'order.open_order.gnoll.brute'
  | 'order.open_order.gnoll.schemer'
  | 'order.open_order.goblin.brute'
  | 'order.open_order.goblin.schemer'
  | 'order.open_order.orc.brute'
  | 'order.open_order.orc.schemer'
  | 'order.open_the_pit.demon.brute'
  | 'order.open_the_pit.demon.hexer'
  | 'order.open_the_pit.demon.zealot'
  | 'order.out_of_the_dark.black_dragon.brute'
  | 'order.out_of_the_dark.black_dragon.lurker'
  | 'order.out_of_the_dark.black_dragon.schemer'
  | 'order.out_of_the_sun.drake.beastmaster'
  | 'order.out_of_the_sun.drake.brute'
  | 'order.out_of_the_sun.great_eagle.beastmaster'
  | 'order.out_of_the_sun.great_eagle.brute'
  | 'order.overwatch.dark_elf.lurker'
  | 'order.overwatch.dark_elf.warlord'
  | 'order.overwatch.lizardfolk.lurker'
  | 'order.overwatch.lizardfolk.warlord'
  | 'order.overwatch.skeleton.lurker'
  | 'order.overwatch.skeleton.warlord'
  | 'order.pepper_the_laggard.bandit.beastmaster'
  | 'order.pepper_the_laggard.bandit.schemer'
  | 'order.pepper_the_laggard.beholder.schemer'
  | 'order.pepper_the_laggard.gnoll.beastmaster'
  | 'order.pepper_the_laggard.gnoll.schemer'
  | 'order.pepper_the_laggard.goblin.beastmaster'
  | 'order.pepper_the_laggard.goblin.schemer'
  | 'order.pepper_the_laggard.winter_court.beastmaster'
  | 'order.pepper_the_laggard.winter_court.schemer'
  | 'order.phalanx_advance.golem.warlord'
  | 'order.phalanx_advance.orc.brute'
  | 'order.phalanx_advance.orc.warlord'
  | 'order.phalanx_advance.skeleton.brute'
  | 'order.phalanx_advance.skeleton.warlord'
  | 'order.pickets_out.bandit.lurker'
  | 'order.pickets_out.bandit.schemer'
  | 'order.pickets_out.duergar.lurker'
  | 'order.pickets_out.duergar.schemer'
  | 'order.pickets_out.gnoll.lurker'
  | 'order.pickets_out.gnoll.schemer'
  | 'order.pike_and_shot.soldier.warlord'
  | 'order.pike_and_shot.soldier.zealot'
  | 'order.protect_the_maker.golem.hexer'
  | 'order.protect_the_maker.golem.schemer'
  | 'order.protect_the_maker.golem.warlord'
  | 'order.pull_them_under.sand_tentacles.lurker'
  | 'order.pull_them_under.sandworm.brute'
  | 'order.pull_them_under.sandworm.lurker'
  | 'order.pull_them_under.tentacles.lurker'
  | 'order.pull_them_under.vermin.brute'
  | 'order.pull_them_under.vermin.lurker'
  | 'order.rally_on_the_colours.bandit.warlord'
  | 'order.rally_on_the_colours.bandit.zealot'
  | 'order.rally_on_the_colours.goblin.warlord'
  | 'order.rally_on_the_colours.goblin.zealot'
  | 'order.rally_on_the_colours.skeleton.warlord'
  | 'order.rally_on_the_colours.skeleton.zealot'
  | 'order.rally_on_the_colours.soldier.warlord'
  | 'order.rally_on_the_colours.soldier.zealot'
  | 'order.rallying_howl.beast.beastmaster'
  | 'order.rallying_howl.beast.brute'
  | 'order.rallying_howl.cyclops.beastmaster'
  | 'order.rallying_howl.cyclops.brute'
  | 'order.rallying_howl.gnoll.beastmaster'
  | 'order.rallying_howl.gnoll.brute'
  | 'order.rallying_howl.wolf.beastmaster'
  | 'order.rallying_howl.wolf.brute'
  | 'order.rearguard.bandit.schemer'
  | 'order.rearguard.bandit.warlord'
  | 'order.rearguard.dark_elf.schemer'
  | 'order.rearguard.dark_elf.warlord'
  | 'order.rearguard.duergar.schemer'
  | 'order.rearguard.duergar.warlord'
  | 'order.rearguard.goblin.schemer'
  | 'order.rearguard.goblin.warlord'
  | 'order.rearguard.golem.schemer'
  | 'order.rearguard.golem.warlord'
  | 'order.reed_ring.bandit.lurker'
  | 'order.reed_ring.bandit.schemer'
  | 'order.reed_ring.gorgon.lurker'
  | 'order.reed_ring.gorgon.schemer'
  | 'order.reed_ring.lizardfolk.lurker'
  | 'order.reed_ring.lizardfolk.schemer'
  | 'order.refused_flank.dark_elf.schemer'
  | 'order.refused_flank.dark_elf.warlord'
  | 'order.relieve_the_front_rank.cultist.hexer'
  | 'order.relieve_the_front_rank.cultist.warlord'
  | 'order.relieve_the_front_rank.golem.hexer'
  | 'order.relieve_the_front_rank.golem.warlord'
  | 'order.relieve_the_front_rank.lizardfolk.hexer'
  | 'order.relieve_the_front_rank.lizardfolk.warlord'
  | 'order.relieve_the_front_rank.skeleton.hexer'
  | 'order.relieve_the_front_rank.skeleton.warlord'
  | 'order.relieve_the_front_rank.soldier.warlord'
  | 'order.ring_of_shadows.dark_elf.lurker'
  | 'order.ring_of_shadows.dark_elf.schemer'
  | 'order.ring_of_shadows.goblin.lurker'
  | 'order.ring_of_shadows.goblin.schemer'
  | 'order.ring_of_shadows.spider.lurker'
  | 'order.ring_of_shadows.spider.schemer'
  | 'order.ring_of_shadows.vampire.lurker'
  | 'order.ring_of_shadows.vampire.schemer'
  | 'order.ring_the_prize.gnoll.beastmaster'
  | 'order.ring_the_prize.gnoll.brute'
  | 'order.ring_the_prize.orc.beastmaster'
  | 'order.ring_the_prize.orc.brute'
  | 'order.ring_them_against_the_bank.kraken.brute'
  | 'order.ring_them_against_the_bank.kraken.lurker'
  | 'order.ring_them_against_the_bank.kraken.zealot'
  | 'order.rocks_and_ruin.cyclops.brute'
  | 'order.rocks_and_ruin.mountain_troll.brute'
  | 'order.rocks_and_ruin.mountain_troll.lurker'
  | 'order.rocks_and_ruin.mountain_troll.warlord'
  | 'order.rockslide_rush.cyclops.brute'
  | 'order.rockslide_rush.minotaur.brute'
  | 'order.rockslide_rush.minotaur.warlord'
  | 'order.rockslide_rush.mountain_troll.brute'
  | 'order.rockslide_rush.mountain_troll.lurker'
  | 'order.rockslide_rush.mountain_troll.warlord'
  | 'order.roots_and_thorns.ent.brute'
  | 'order.roots_and_thorns.ent.lurker'
  | 'order.roots_and_thorns.ent.zealot'
  | 'order.roots_and_thorns.fey.lurker'
  | 'order.run_down_the_wounded.beast.beastmaster'
  | 'order.run_down_the_wounded.beast.brute'
  | 'order.run_down_the_wounded.cyclops.beastmaster'
  | 'order.run_down_the_wounded.cyclops.brute'
  | 'order.run_down_the_wounded.gnoll.beastmaster'
  | 'order.run_down_the_wounded.gnoll.brute'
  | 'order.run_down_the_wounded.vampire.beastmaster'
  | 'order.run_down_the_wounded.wolf.beastmaster'
  | 'order.run_down_the_wounded.wolf.brute'
  | 'order.sacred_beasts.cultist.beastmaster'
  | 'order.sacred_beasts.cultist.zealot'
  | 'order.sacred_beasts.skeleton.beastmaster'
  | 'order.sacred_beasts.skeleton.zealot'
  | 'order.scatter_before_the_flame.demon.brute'
  | 'order.scatter_before_the_flame.demon.schemer'
  | 'order.scatter_before_the_flame.djinn.brute'
  | 'order.scatter_before_the_flame.djinn.schemer'
  | 'order.scatter_before_the_flame.dragon.brute'
  | 'order.scatter_before_the_flame.dragon.schemer'
  | 'order.scatter_before_the_flame.dragon.warlord'
  | 'order.scatter_before_the_flame.drake.brute'
  | 'order.scatter_for_the_maw.sandworm.brute'
  | 'order.scatter_for_the_maw.sandworm.lurker'
  | 'order.scatter_from_the_shadow.drake.beastmaster'
  | 'order.scatter_from_the_shadow.drake.brute'
  | 'order.scatter_from_the_shadow.great_eagle.beastmaster'
  | 'order.scatter_from_the_shadow.great_eagle.brute'
  | 'order.schiltron.bandit.warlord'
  | 'order.schiltron.bandit.zealot'
  | 'order.schiltron.cultist.warlord'
  | 'order.schiltron.cultist.zealot'
  | 'order.schiltron.mummy.warlord'
  | 'order.schiltron.mummy.zealot'
  | 'order.schiltron.skeleton.warlord'
  | 'order.schiltron.skeleton.zealot'
  | 'order.schiltron.soldier.warlord'
  | 'order.schiltron.soldier.zealot'
  | 'order.screen.bandit.brute'
  | 'order.screen.bandit.hexer'
  | 'order.screen.bandit.schemer'
  | 'order.screen.bandit.warlord'
  | 'order.screen.bandit.zealot'
  | 'order.screen.cultist.brute'
  | 'order.screen.cultist.hexer'
  | 'order.screen.cultist.schemer'
  | 'order.screen.cultist.warlord'
  | 'order.screen.cultist.zealot'
  | 'order.screen.goblin.brute'
  | 'order.screen.goblin.hexer'
  | 'order.screen.goblin.schemer'
  | 'order.screen.goblin.warlord'
  | 'order.screen.goblin.zealot'
  | 'order.screen.orc.brute'
  | 'order.screen.orc.hexer'
  | 'order.screen.orc.schemer'
  | 'order.screen.orc.warlord'
  | 'order.screen.orc.zealot'
  | 'order.screen.skeleton.brute'
  | 'order.screen.skeleton.hexer'
  | 'order.screen.skeleton.schemer'
  | 'order.screen.skeleton.warlord'
  | 'order.screen.skeleton.zealot'
  | 'order.seal_the_tomb.mummy.hexer'
  | 'order.seal_the_tomb.mummy.warlord'
  | 'order.seal_the_tomb.mummy.zealot'
  | 'order.shadow_the_flanks.gnoll.beastmaster'
  | 'order.shadow_the_flanks.gnoll.lurker'
  | 'order.shadow_the_flanks.wolf.beastmaster'
  | 'order.shadow_the_flanks.wolf.lurker'
  | 'order.shed_the_skin.basilisk.brute'
  | 'order.shed_the_skin.basilisk.hexer'
  | 'order.shed_the_skin.basilisk.lurker'
  | 'order.shed_the_skin.gorgon.hexer'
  | 'order.shed_the_skin.gorgon.lurker'
  | 'order.shield_and_spear.bandit.brute'
  | 'order.shield_and_spear.bandit.warlord'
  | 'order.shield_and_spear.orc.brute'
  | 'order.shield_and_spear.orc.warlord'
  | 'order.shield_and_spear.troll.brute'
  | 'order.shield_and_spear.troll.warlord'
  | 'order.shield_wall.bandit.brute'
  | 'order.shield_wall.bandit.warlord'
  | 'order.shield_wall.orc.brute'
  | 'order.shield_wall.orc.warlord'
  | 'order.shield_wall.skeleton.brute'
  | 'order.shield_wall.skeleton.warlord'
  | 'order.shield_wall.soldier.warlord'
  | 'order.shoot_from_the_hedges.bandit.lurker'
  | 'order.shoot_from_the_hedges.bandit.schemer'
  | 'order.shoot_from_the_hedges.goblin.lurker'
  | 'order.shoot_from_the_hedges.goblin.schemer'
  | 'order.shoot_from_the_hedges.gorgon.lurker'
  | 'order.shoot_from_the_hedges.gorgon.schemer'
  | 'order.shoot_from_the_hedges.lizardfolk.lurker'
  | 'order.shoot_from_the_hedges.lizardfolk.schemer'
  | 'order.shoot_in_the_dark.beholder.hexer'
  | 'order.shoot_in_the_dark.dark_elf.hexer'
  | 'order.shoot_in_the_dark.dark_elf.lurker'
  | 'order.shoot_in_the_dark.ghost.hexer'
  | 'order.shoot_in_the_dark.ghost.lurker'
  | 'order.shoot_in_the_dark.goblin.hexer'
  | 'order.shoot_in_the_dark.goblin.lurker'
  | 'order.shoot_in_the_dark.lizardfolk.hexer'
  | 'order.shoot_in_the_dark.lizardfolk.lurker'
  | 'order.silence_the_chanter.cultist.hexer'
  | 'order.silence_the_chanter.cultist.zealot'
  | 'order.silence_the_chanter.dark_elf.hexer'
  | 'order.silence_the_chanter.dark_elf.zealot'
  | 'order.silence_the_chanter.lizardfolk.hexer'
  | 'order.silence_the_chanter.lizardfolk.zealot'
  | 'order.skirmish_screen.bandit.schemer'
  | 'order.skirmish_screen.bandit.warlord'
  | 'order.skirmish_screen.dark_elf.schemer'
  | 'order.skirmish_screen.dark_elf.warlord'
  | 'order.skirmish_screen.goblin.schemer'
  | 'order.skirmish_screen.goblin.warlord'
  | 'order.slink_to_the_lair.beast.beastmaster'
  | 'order.slink_to_the_lair.beast.lurker'
  | 'order.spend_their_daylight.cultist.brute'
  | 'order.spend_their_daylight.cultist.warlord'
  | 'order.spend_their_daylight.cultist.zealot'
  | 'order.spend_their_daylight.orc.brute'
  | 'order.spend_their_daylight.orc.warlord'
  | 'order.spend_their_daylight.orc.zealot'
  | 'order.spend_their_daylight.zombie.brute'
  | 'order.spend_their_daylight.zombie.warlord'
  | 'order.spend_their_daylight.zombie.zealot'
  | 'order.spit_and_snare.dark_elf.beastmaster'
  | 'order.spit_and_snare.dark_elf.lurker'
  | 'order.spit_and_snare.gorgon.lurker'
  | 'order.spit_and_snare.spider.beastmaster'
  | 'order.spit_and_snare.spider.lurker'
  | 'order.spring_the_trap.bandit.lurker'
  | 'order.spring_the_trap.bandit.schemer'
  | 'order.spring_the_trap.gnoll.lurker'
  | 'order.spring_the_trap.gnoll.schemer'
  | 'order.spring_the_trap.goblin.lurker'
  | 'order.spring_the_trap.goblin.schemer'
  | 'order.spring_the_trap.lizardfolk.lurker'
  | 'order.spring_the_trap.lizardfolk.schemer'
  | 'order.spring_the_trap.mimic.lurker'
  | 'order.staked_goat.bandit.lurker'
  | 'order.staked_goat.bandit.schemer'
  | 'order.staked_goat.fey.lurker'
  | 'order.staked_goat.fey.schemer'
  | 'order.staked_goat.goblin.lurker'
  | 'order.staked_goat.goblin.schemer'
  | 'order.staked_goat.gorgon.lurker'
  | 'order.staked_goat.gorgon.schemer'
  | 'order.staked_goat.witch.schemer'
  | 'order.stamp_the_little_ones.cyclops.beastmaster'
  | 'order.stamp_the_little_ones.cyclops.brute'
  | 'order.stand_in_the_reeds.beast.beastmaster'
  | 'order.stand_in_the_reeds.beast.lurker'
  | 'order.stand_in_the_reeds.lizardfolk.beastmaster'
  | 'order.stand_in_the_reeds.lizardfolk.lurker'
  | 'order.stand_like_the_mountain.cyclops.brute'
  | 'order.stand_like_the_mountain.mountain_troll.brute'
  | 'order.stand_like_the_mountain.mountain_troll.lurker'
  | 'order.stand_like_the_mountain.mountain_troll.warlord'
  | 'order.stand_on_the_stones.cultist.brute'
  | 'order.stand_on_the_stones.cultist.warlord'
  | 'order.stand_on_the_stones.cultist.zealot'
  | 'order.stand_on_the_stones.mummy.warlord'
  | 'order.stand_on_the_stones.mummy.zealot'
  | 'order.stand_on_the_stones.skeleton.brute'
  | 'order.stand_on_the_stones.skeleton.warlord'
  | 'order.stand_on_the_stones.skeleton.zealot'
  | 'order.stand_on_the_stones.zombie.brute'
  | 'order.stand_on_the_stones.zombie.warlord'
  | 'order.stand_on_the_stones.zombie.zealot'
  | 'order.steady_the_line.bandit.warlord'
  | 'order.steady_the_line.orc.warlord'
  | 'order.steady_the_line.skeleton.warlord'
  | 'order.steady_the_line.soldier.warlord'
  | 'order.steppe_wheel.gnoll.beastmaster'
  | 'order.steppe_wheel.gnoll.warlord'
  | 'order.steppe_wheel.goblin.beastmaster'
  | 'order.steppe_wheel.goblin.warlord'
  | 'order.still_as_old_wood.ent.brute'
  | 'order.still_as_old_wood.ent.lurker'
  | 'order.still_as_old_wood.ent.zealot'
  | 'order.still_as_old_wood.fey.lurker'
  | 'order.still_as_old_wood.mimic.brute'
  | 'order.still_as_old_wood.mimic.lurker'
  | 'order.still_as_the_floor.mimic.lurker'
  | 'order.still_as_the_floor.ooze.lurker'
  | 'order.still_as_the_floor.sand_tentacles.lurker'
  | 'order.still_as_the_floor.spider.lurker'
  | 'order.still_as_the_floor.spider.schemer'
  | 'order.still_as_the_floor.tentacles.lurker'
  | 'order.still_water.beast.lurker'
  | 'order.still_water.ghost.hexer'
  | 'order.still_water.ghost.lurker'
  | 'order.still_water.lizardfolk.hexer'
  | 'order.still_water.lizardfolk.lurker'
  | 'order.still_water.spider.hexer'
  | 'order.still_water.spider.lurker'
  | 'order.still_water.zombie.hexer'
  | 'order.still_water.zombie.lurker'
  | 'order.strike_and_fade.black_dragon.brute'
  | 'order.strike_and_fade.black_dragon.lurker'
  | 'order.strike_and_fade.black_dragon.schemer'
  | 'order.strike_and_vanish.bandit.lurker'
  | 'order.strike_and_vanish.bandit.schemer'
  | 'order.strike_and_vanish.fey.lurker'
  | 'order.strike_and_vanish.fey.schemer'
  | 'order.strike_and_vanish.goblin.lurker'
  | 'order.strike_and_vanish.goblin.schemer'
  | 'order.strike_and_vanish.lizardfolk.lurker'
  | 'order.strike_and_vanish.lizardfolk.schemer'
  | 'order.strike_and_vanish.vampire.lurker'
  | 'order.strike_and_vanish.vampire.schemer'
  | 'order.swarm.elemental.brute'
  | 'order.swarm.gnoll.brute'
  | 'order.swarm.gnoll.warlord'
  | 'order.swarm.goblin.brute'
  | 'order.swarm.goblin.warlord'
  | 'order.swarm.vermin.brute'
  | 'order.swarm.zombie.brute'
  | 'order.swarm.zombie.warlord'
  | 'order.swarm_the_bleeding_one.maw_of_the_deep.brute'
  | 'order.swarm_the_bleeding_one.maw_of_the_deep.lurker'
  | 'order.swarm_the_cocooned.spider_queen.beastmaster'
  | 'order.swarm_the_cocooned.spider_queen.brute'
  | 'order.swarm_the_cocooned.spider_queen.lurker'
  | 'order.swarm_the_cocooned.vermin.brute'
  | 'order.swarm_the_cocooned.vermin.lurker'
  | 'order.take_the_heights.bandit.schemer'
  | 'order.take_the_heights.bandit.warlord'
  | 'order.take_the_heights.dark_elf.schemer'
  | 'order.take_the_heights.dark_elf.warlord'
  | 'order.take_the_heights.gnoll.schemer'
  | 'order.take_the_heights.gnoll.warlord'
  | 'order.take_the_heights.goblin.schemer'
  | 'order.take_the_heights.goblin.warlord'
  | 'order.take_the_one_who_strays.drake.beastmaster'
  | 'order.take_the_one_who_strays.drake.brute'
  | 'order.take_the_one_who_strays.great_eagle.beastmaster'
  | 'order.take_the_one_who_strays.great_eagle.brute'
  | 'order.take_the_rear.dark_elf.lurker'
  | 'order.take_the_rear.dark_elf.schemer'
  | 'order.take_the_rear.duergar.lurker'
  | 'order.take_the_rear.duergar.schemer'
  | 'order.take_the_rear.goblin.lurker'
  | 'order.take_the_rear.goblin.schemer'
  | 'order.take_the_rear.lizardfolk.lurker'
  | 'order.take_the_rear.lizardfolk.schemer'
  | 'order.take_the_straggler.winter_court.beastmaster'
  | 'order.take_the_straggler.yeti.beastmaster'
  | 'order.take_the_straggler.yeti.brute'
  | 'order.take_the_straggler.yeti.lurker'
  | 'order.the_alphas_charge.beast.beastmaster'
  | 'order.the_alphas_charge.beast.brute'
  | 'order.the_alphas_charge.minotaur.brute'
  | 'order.the_alphas_charge.orc.beastmaster'
  | 'order.the_alphas_charge.orc.brute'
  | 'order.the_alphas_charge.troll.beastmaster'
  | 'order.the_alphas_charge.troll.brute'
  | 'order.the_alphas_charge.wolf.beastmaster'
  | 'order.the_alphas_charge.wolf.brute'
  | 'order.the_blood_feast.vampire.beastmaster'
  | 'order.the_blood_feast.vampire.lurker'
  | 'order.the_blood_feast.vampire.schemer'
  | 'order.the_brood_swarms.beast.brute'
  | 'order.the_brood_swarms.beast.lurker'
  | 'order.the_brood_swarms.elemental.brute'
  | 'order.the_brood_swarms.ooze.brute'
  | 'order.the_brood_swarms.ooze.lurker'
  | 'order.the_brood_swarms.spider.brute'
  | 'order.the_brood_swarms.spider.lurker'
  | 'order.the_brood_swarms.zombie.brute'
  | 'order.the_brood_swarms.zombie.lurker'
  | 'order.the_circle_holds.cultist.hexer'
  | 'order.the_circle_holds.cultist.zealot'
  | 'order.the_circle_holds.skeleton.hexer'
  | 'order.the_circle_holds.skeleton.zealot'
  | 'order.the_circle_holds.witch.hexer'
  | 'order.the_circle_holds.witch.zealot'
  | 'order.the_cold_takes_the_weak.winter_court.beastmaster'
  | 'order.the_cold_takes_the_weak.yeti.beastmaster'
  | 'order.the_cold_takes_the_weak.yeti.brute'
  | 'order.the_cold_takes_the_weak.yeti.lurker'
  | 'order.the_drowned_rite.kraken.brute'
  | 'order.the_drowned_rite.kraken.lurker'
  | 'order.the_drowned_rite.kraken.zealot'
  | 'order.the_eye_sees_all.beholder.hexer'
  | 'order.the_eye_sees_all.beholder.schemer'
  | 'order.the_grave_calls.ghost.hexer'
  | 'order.the_grave_calls.ghost.zealot'
  | 'order.the_grave_calls.mummy.hexer'
  | 'order.the_grave_calls.mummy.zealot'
  | 'order.the_grave_calls.skeleton.hexer'
  | 'order.the_grave_calls.skeleton.zealot'
  | 'order.the_grave_calls.zombie.hexer'
  | 'order.the_grave_calls.zombie.zealot'
  | 'order.the_grudge_is_paid.duergar.lurker'
  | 'order.the_grudge_is_paid.duergar.schemer'
  | 'order.the_grudge_is_paid.duergar.warlord'
  | 'order.the_haunting.ghost.hexer'
  | 'order.the_haunting.ghost.lurker'
  | 'order.the_haunting.ghost.zealot'
  | 'order.the_hunger_rises.sandworm.brute'
  | 'order.the_hunger_rises.sandworm.lurker'
  | 'order.the_hunger_rises.vermin.brute'
  | 'order.the_hunger_rises.vermin.lurker'
  | 'order.the_hunger_wakes.maw_of_the_deep.brute'
  | 'order.the_hunger_wakes.maw_of_the_deep.lurker'
  | 'order.the_hungry_press.beast.brute'
  | 'order.the_hungry_press.elemental.brute'
  | 'order.the_hungry_press.ooze.brute'
  | 'order.the_hungry_press.zombie.brute'
  | 'order.the_kings_challenge.grim_giant.brute'
  | 'order.the_kings_challenge.grim_giant.hexer'
  | 'order.the_kings_challenge.grim_giant.warlord'
  | 'order.the_kings_challenge.minotaur.brute'
  | 'order.the_kings_challenge.minotaur.warlord'
  | 'order.the_long_hall.minotaur.brute'
  | 'order.the_long_hall.minotaur.warlord'
  | 'order.the_long_night.winter_court.beastmaster'
  | 'order.the_long_night.winter_court.hexer'
  | 'order.the_long_night.winter_court.schemer'
  | 'order.the_maelstrom.elemental.brute'
  | 'order.the_maelstrom.elemental.hexer'
  | 'order.the_many_eyes_watch.maw_of_the_deep.brute'
  | 'order.the_many_eyes_watch.maw_of_the_deep.lurker'
  | 'order.the_pack_drives.winter_court.beastmaster'
  | 'order.the_pack_drives.yeti.beastmaster'
  | 'order.the_pack_drives.yeti.brute'
  | 'order.the_pack_drives.yeti.lurker'
  | 'order.the_procession.cultist.beastmaster'
  | 'order.the_procession.cultist.zealot'
  | 'order.the_procession.skeleton.beastmaster'
  | 'order.the_procession.skeleton.zealot'
  | 'order.the_rearguard.duergar.warlord'
  | 'order.the_rearguard.lizardfolk.brute'
  | 'order.the_rearguard.lizardfolk.warlord'
  | 'order.the_rearguard.skeleton.brute'
  | 'order.the_rearguard.skeleton.warlord'
  | 'order.the_rearguard.troll.brute'
  | 'order.the_rearguard.troll.warlord'
  | 'order.the_ring_hunt.bandit.beastmaster'
  | 'order.the_ring_hunt.bandit.warlord'
  | 'order.the_ring_hunt.gnoll.beastmaster'
  | 'order.the_ring_hunt.gnoll.warlord'
  | 'order.the_ring_hunt.goblin.beastmaster'
  | 'order.the_ring_hunt.goblin.warlord'
  | 'order.the_ring_hunt.wolf.beastmaster'
  | 'order.the_ring_hunt.wolf.warlord'
  | 'order.the_shrouding.dark_elf.hexer'
  | 'order.the_shrouding.dark_elf.lurker'
  | 'order.the_shrouding.elemental.hexer'
  | 'order.the_shrouding.ghost.hexer'
  | 'order.the_shrouding.ghost.lurker'
  | 'order.the_shrouding.spider.hexer'
  | 'order.the_shrouding.spider.lurker'
  | 'order.the_shrouding.witch.hexer'
  | 'order.the_statue_garden.gorgon.hexer'
  | 'order.the_statue_garden.gorgon.lurker'
  | 'order.the_statue_garden.gorgon.schemer'
  | 'order.the_stone_curse.basilisk.brute'
  | 'order.the_stone_curse.basilisk.hexer'
  | 'order.the_stone_curse.basilisk.lurker'
  | 'order.the_stone_curse.beholder.hexer'
  | 'order.the_stone_curse.gorgon.hexer'
  | 'order.the_stone_curse.gorgon.lurker'
  | 'order.the_swarm_rises.vermin.brute'
  | 'order.the_swarm_rises.vermin.lurker'
  | 'order.the_trap_shuts.gnoll.beastmaster'
  | 'order.the_trap_shuts.gnoll.schemer'
  | 'order.the_trap_shuts.wolf.beastmaster'
  | 'order.the_twisted_wish.djinn.brute'
  | 'order.the_twisted_wish.djinn.hexer'
  | 'order.the_twisted_wish.djinn.schemer'
  | 'order.the_web_waits.beast.beastmaster'
  | 'order.the_web_waits.beast.lurker'
  | 'order.the_web_waits.lizardfolk.beastmaster'
  | 'order.the_web_waits.lizardfolk.lurker'
  | 'order.the_web_waits.spider.beastmaster'
  | 'order.the_web_waits.spider.lurker'
  | 'order.the_woods_close_in.ent.brute'
  | 'order.the_woods_close_in.ent.lurker'
  | 'order.the_woods_close_in.ent.zealot'
  | 'order.the_woods_close_in.fey.lurker'
  | 'order.tortoise.cultist.warlord'
  | 'order.tortoise.cultist.zealot'
  | 'order.tortoise.mummy.warlord'
  | 'order.tortoise.mummy.zealot'
  | 'order.tortoise.skeleton.warlord'
  | 'order.tortoise.skeleton.zealot'
  | 'order.tortoise.soldier.warlord'
  | 'order.tortoise.soldier.zealot'
  | 'order.troll_is_hungry.troll.hexer'
  | 'order.troll_is_hungry.troll.lurker'
  | 'order.tug_the_thread.beast.beastmaster'
  | 'order.tug_the_thread.beast.lurker'
  | 'order.tug_the_thread.spider.beastmaster'
  | 'order.tug_the_thread.spider.lurker'
  | 'order.tug_the_thread.spider.schemer'
  | 'order.turn_and_loose.beholder.schemer'
  | 'order.turn_and_loose.dark_elf.lurker'
  | 'order.turn_and_loose.dark_elf.schemer'
  | 'order.turn_and_loose.goblin.lurker'
  | 'order.turn_and_loose.goblin.schemer'
  | 'order.turn_the_champion.beast.beastmaster'
  | 'order.turn_the_champion.beast.brute'
  | 'order.turn_the_champion.cyclops.beastmaster'
  | 'order.turn_the_champion.cyclops.brute'
  | 'order.turn_the_champion.minotaur.brute'
  | 'order.turn_the_champion.troll.beastmaster'
  | 'order.turn_the_champion.troll.brute'
  | 'order.tusks_in_the_grass.orc.lurker'
  | 'order.tusks_in_the_grass.orc.warlord'
  | 'order.under_the_bridge.troll.beastmaster'
  | 'order.under_the_bridge.troll.lurker'
  | 'order.vanish_into_the_smoke.black_dragon.brute'
  | 'order.vanish_into_the_smoke.black_dragon.lurker'
  | 'order.vanish_into_the_smoke.black_dragon.schemer'
  | 'order.wait_beneath_the_surface.kraken.brute'
  | 'order.wait_beneath_the_surface.kraken.lurker'
  | 'order.wait_beneath_the_surface.kraken.zealot'
  | 'order.wait_on.great_eagle.beastmaster'
  | 'order.wait_on.great_eagle.brute'
  | 'order.wall_of_the_faithful.cultist.hexer'
  | 'order.wall_of_the_faithful.cultist.schemer'
  | 'order.wall_of_the_faithful.cultist.zealot'
  | 'order.wall_of_the_faithful.goblin.hexer'
  | 'order.wall_of_the_faithful.goblin.schemer'
  | 'order.wall_of_the_faithful.goblin.zealot'
  | 'order.wall_of_the_faithful.witch.hexer'
  | 'order.wall_of_the_faithful.witch.schemer'
  | 'order.wall_of_the_faithful.witch.zealot'
  | 'order.ward_the_front_rank.cultist.hexer'
  | 'order.ward_the_front_rank.cultist.warlord'
  | 'order.ward_the_front_rank.golem.hexer'
  | 'order.ward_the_front_rank.golem.warlord'
  | 'order.ward_the_front_rank.lizardfolk.hexer'
  | 'order.ward_the_front_rank.lizardfolk.warlord'
  | 'order.ward_the_front_rank.skeleton.hexer'
  | 'order.ward_the_front_rank.skeleton.warlord'
  | 'order.web_the_doorway.dark_elf.beastmaster'
  | 'order.web_the_doorway.dark_elf.lurker'
  | 'order.web_the_doorway.dark_elf.schemer'
  | 'order.web_the_doorway.spider.beastmaster'
  | 'order.web_the_doorway.spider.lurker'
  | 'order.web_the_doorway.spider.schemer'
  | 'order.web_the_ways.spider_queen.beastmaster'
  | 'order.web_the_ways.spider_queen.brute'
  | 'order.web_the_ways.spider_queen.lurker'
  | 'order.wings_over_the_field.dragon.brute'
  | 'order.wings_over_the_field.dragon.schemer'
  | 'order.wings_over_the_field.dragon.warlord'
  | 'order.wings_over_the_field.drake.brute'
  | 'order.witch_fire_volley.bandit.hexer'
  | 'order.witch_fire_volley.bandit.warlord'
  | 'order.witch_fire_volley.dark_elf.hexer'
  | 'order.witch_fire_volley.dark_elf.warlord'
  | 'order.witch_fire_volley.demon.hexer'
  | 'order.witch_fire_volley.elemental.hexer'
  | 'order.witch_fire_volley.goblin.hexer'
  | 'order.witch_fire_volley.goblin.warlord'
  | 'pet.bear_alert'
  | 'pet.bear_comfort'
  | 'pet.bear_happy'
  | 'pet.bear_play'
  | 'pet.bird_alert'
  | 'pet.bird_comfort'
  | 'pet.bird_happy'
  | 'pet.bird_play'
  | 'pet.cat_alert'
  | 'pet.cat_comfort'
  | 'pet.cat_happy'
  | 'pet.cat_play'
  | 'pet.critter_alert'
  | 'pet.critter_comfort'
  | 'pet.critter_happy'
  | 'pet.critter_play'
  | 'pet.splash'
  | 'pet.wolf_alert'
  | 'pet.wolf_comfort'
  | 'pet.wolf_happy'
  | 'pet.wolf_play'
  | 'ping.danger'
  | 'ping.go'
  | 'ping.help'
  | 'ping.hold'
  | 'ping.look'
  | 'place.camp'
  | 'place.fire'
  | 'place.shop'
  | 'place.smithy'
  | 'place.study'
  | 'place.tavern'
  | 'place.title'
  | 'place.town'
  | 'plan.clear'
  | 'plan.commit'
  | 'plan.place'
  | 'plan.select'
  | 'plan.struck'
  | 'plan.tick'
  | 'pulse.lock'
  | 'pulse.open'
  | 'pulse.pause'
  | 'pulse.ready'
  | 'pulse.resume'
  | 'pulse.unready'
  | 'push.bump'
  | 'push.impact'
  | 'song.cast'
  | 'song.dissonant'
  | 'song.finale'
  | 'song.mockery'
  | 'song.mockery_hit'
  | 'spell.acid_burst'
  | 'spell.acid_cast'
  | 'spell.acid_hit'
  | 'spell.acid_shoot'
  | 'spell.arcane_cast'
  | 'spell.arcane_hit'
  | 'spell.arcane_shoot'
  | 'spell.barkskin'
  | 'spell.blink'
  | 'spell.buff'
  | 'spell.burrow'
  | 'spell.consecrate'
  | 'spell.debuff'
  | 'spell.earth_burst'
  | 'spell.earth_cast'
  | 'spell.earth_hit'
  | 'spell.fire_burst'
  | 'spell.fire_cast'
  | 'spell.fire_hit'
  | 'spell.fire_shoot'
  | 'spell.force_dart'
  | 'spell.force_hit'
  | 'spell.frost_burst'
  | 'spell.frost_cast'
  | 'spell.frost_hit'
  | 'spell.frost_shoot'
  | 'spell.gale'
  | 'spell.heal'
  | 'spell.holy_cast'
  | 'spell.holy_chime'
  | 'spell.holy_hit'
  | 'spell.judgement'
  | 'spell.lightning_bolt'
  | 'spell.lightning_cast'
  | 'spell.lightning_hit'
  | 'spell.mark'
  | 'spell.nature'
  | 'spell.nature_cast'
  | 'spell.nature_hit'
  | 'spell.nature_shoot'
  | 'spell.necrotic_cast'
  | 'spell.necrotic_hit'
  | 'spell.overgrowth'
  | 'spell.paladin_radiance'
  | 'spell.paladin_steel'
  | 'spell.poison'
  | 'spell.potion'
  | 'spell.quagmire'
  | 'spell.radiant_bolt'
  | 'spell.radiant_burst'
  | 'spell.revive'
  | 'spell.shadow'
  | 'spell.smoke'
  | 'spell.summon'
  | 'spell.thunder_burst'
  | 'spell.thunder_cast'
  | 'spell.thunder_hit'
  | 'spell.upheaval'
  | 'spell.ward'
  | 'spell.web'
  | 'spell.wind_cast'
  | 'spell.wind_hit'
  | 'spell.wither'
  | 'stash.gold'
  | 'stash.open'
  | 'status.bleeding'
  | 'status.burning'
  | 'status.extinguish'
  | 'status.floundering'
  | 'status.freed'
  | 'status.guarded'
  | 'status.hidden'
  | 'status.rooted'
  | 'step.bones'
  | 'step.chain'
  | 'step.deep'
  | 'step.dirt'
  | 'step.ember'
  | 'step.grass'
  | 'step.gravel'
  | 'step.ice'
  | 'step.land_heavy'
  | 'step.leaves'
  | 'step.mud'
  | 'step.plate'
  | 'step.sand'
  | 'step.shallow'
  | 'step.slime'
  | 'step.snow'
  | 'step.stomp'
  | 'step.stone'
  | 'step.swim'
  | 'step.wood'
  | 'strike.backstab'
  | 'strike.backstab_glint'
  | 'swing.blade'
  | 'swing.heavy'
  | 'swing.light'
  | 'tentacle.burst'
  | 'tentacle.rumble'
  | 'tentacle.sand'
  | 'tentacle.sink'
  | 'throw.whoosh'
  | 'trap.alarm'
  | 'trap.blade'
  | 'trap.buzz'
  | 'trap.cackle'
  | 'trap.cage'
  | 'trap.chime'
  | 'trap.clang'
  | 'trap.click'
  | 'trap.crackle'
  | 'trap.crash'
  | 'trap.creak'
  | 'trap.crumble'
  | 'trap.darts'
  | 'trap.disarm'
  | 'trap.drain'
  | 'trap.found'
  | 'trap.gong'
  | 'trap.grind'
  | 'trap.hiss'
  | 'trap.laugh'
  | 'trap.lava'
  | 'trap.net'
  | 'trap.polymorph'
  | 'trap.pop'
  | 'trap.roar'
  | 'trap.roll'
  | 'trap.rumble'
  | 'trap.rush'
  | 'trap.spikes'
  | 'trap.splash'
  | 'trap.squawk'
  | 'trap.thunder'
  | 'trap.walls'
  | 'trap.warp'
  | 'trap.water_rise'
  | 'trap.whoosh'
  | 'ui.back'
  | 'ui.chat'
  | 'ui.chest'
  | 'ui.click'
  | 'ui.close'
  | 'ui.coins'
  | 'ui.coins_big'
  | 'ui.confirm'
  | 'ui.dice'
  | 'ui.equip_armour'
  | 'ui.equip_trinket'
  | 'ui.equip_weapon'
  | 'ui.error'
  | 'ui.forge'
  | 'ui.forged'
  | 'ui.gems'
  | 'ui.hover'
  | 'ui.item'
  | 'ui.leaves'
  | 'ui.levelup'
  | 'ui.loot'
  | 'ui.loot_rare'
  | 'ui.open'
  | 'ui.page'
  | 'ui.points'
  | 'ui.potion'
  | 'ui.retro'
  | 'ui.scroll'
  | 'ui.tab'
  | 'ui.title'
  | 'ui.toast'
  | 'ui.toggle'
  | 'ui.trade'
  | 'ui.transition'
  | 'ui.type'
  | 'ui.world_begins'
  | 'voice.basilisk_attack'
  | 'voice.basilisk_death'
  | 'voice.basilisk_hurt'
  | 'voice.basilisk_taunt'
  | 'voice.beast_attack'
  | 'voice.beast_death'
  | 'voice.beast_hurt'
  | 'voice.beast_taunt'
  | 'voice.bird_attack'
  | 'voice.bird_death'
  | 'voice.bird_hurt'
  | 'voice.bird_taunt'
  | 'voice.broodmother_attack'
  | 'voice.broodmother_death'
  | 'voice.broodmother_hurt'
  | 'voice.broodmother_taunt'
  | 'voice.brute_attack'
  | 'voice.brute_death'
  | 'voice.brute_hurt'
  | 'voice.brute_taunt'
  | 'voice.bull_attack'
  | 'voice.bull_death'
  | 'voice.bull_hurt'
  | 'voice.bull_taunt'
  | 'voice.cat_attack'
  | 'voice.cat_death'
  | 'voice.cat_hurt'
  | 'voice.cat_taunt'
  | 'voice.chest_attack'
  | 'voice.chest_death'
  | 'voice.chest_hurt'
  | 'voice.chest_taunt'
  | 'voice.construct_attack'
  | 'voice.construct_death'
  | 'voice.construct_hurt'
  | 'voice.construct_taunt'
  | 'voice.critter_attack'
  | 'voice.critter_death'
  | 'voice.critter_hurt'
  | 'voice.critter_taunt'
  | 'voice.dragon_attack'
  | 'voice.dragon_death'
  | 'voice.dragon_hurt'
  | 'voice.dragon_taunt'
  | 'voice.eagle_attack'
  | 'voice.eagle_death'
  | 'voice.eagle_hurt'
  | 'voice.eagle_taunt'
  | 'voice.fiend_attack'
  | 'voice.fiend_death'
  | 'voice.fiend_hurt'
  | 'voice.fiend_taunt'
  | 'voice.giant_attack'
  | 'voice.giant_death'
  | 'voice.giant_hurt'
  | 'voice.giant_taunt'
  | 'voice.hag_attack'
  | 'voice.hag_death'
  | 'voice.hag_hurt'
  | 'voice.hag_taunt'
  | 'voice.hound_attack'
  | 'voice.hound_death'
  | 'voice.hound_hurt'
  | 'voice.hound_taunt'
  | 'voice.insect_attack'
  | 'voice.insect_death'
  | 'voice.insect_hurt'
  | 'voice.insect_taunt'
  | 'voice.jotun_attack'
  | 'voice.jotun_death'
  | 'voice.jotun_hurt'
  | 'voice.jotun_taunt'
  | 'voice.kraken_attack'
  | 'voice.kraken_death'
  | 'voice.kraken_hurt'
  | 'voice.kraken_taunt'
  | 'voice.man_attack'
  | 'voice.man_death'
  | 'voice.man_exert'
  | 'voice.man_hurt'
  | 'voice.man_taunt'
  | 'voice.maw_attack'
  | 'voice.maw_death'
  | 'voice.maw_hurt'
  | 'voice.maw_taunt'
  | 'voice.orc_attack'
  | 'voice.orc_death'
  | 'voice.orc_hurt'
  | 'voice.orc_taunt'
  | 'voice.reptile_attack'
  | 'voice.reptile_death'
  | 'voice.reptile_hurt'
  | 'voice.reptile_taunt'
  | 'voice.slime_attack'
  | 'voice.slime_death'
  | 'voice.slime_hurt'
  | 'voice.slime_taunt'
  | 'voice.small_attack'
  | 'voice.small_death'
  | 'voice.small_hurt'
  | 'voice.small_taunt'
  | 'voice.spirit_attack'
  | 'voice.spirit_death'
  | 'voice.spirit_hurt'
  | 'voice.spirit_taunt'
  | 'voice.tentacle_attack'
  | 'voice.tentacle_death'
  | 'voice.tentacle_hurt'
  | 'voice.tentacle_taunt'
  | 'voice.treant_attack'
  | 'voice.treant_death'
  | 'voice.treant_hurt'
  | 'voice.treant_taunt'
  | 'voice.undead_attack'
  | 'voice.undead_death'
  | 'voice.undead_hurt'
  | 'voice.undead_taunt'
  | 'voice.vampire_attack'
  | 'voice.vampire_death'
  | 'voice.vampire_hurt'
  | 'voice.vampire_taunt'
  | 'voice.woman_attack'
  | 'voice.woman_death'
  | 'voice.woman_exert'
  | 'voice.woman_hurt'
  | 'voice.woman_taunt'
  | 'voice.worm_attack'
  | 'voice.worm_death'
  | 'voice.worm_hurt'
  | 'voice.worm_taunt'
  | 'voice.wyrm_attack'
  | 'voice.wyrm_death'
  | 'voice.wyrm_hurt'
  | 'voice.wyrm_taunt'
  | 'voice.yeti_attack'
  | 'voice.yeti_death'
  | 'voice.yeti_hurt'
  | 'voice.yeti_taunt'
  | 'voice.zombie_attack'
  | 'voice.zombie_death'
  | 'voice.zombie_hurt'
  | 'voice.zombie_taunt'
  | 'wild.bat'
  | 'wild.critter'
  | 'wild.crow'
  | 'wild.frog'
  | 'wild.hawk'
  | 'wild.insect'
  | 'wild.mouse'
  | 'wild.songbird'
  | 'wild.swallow'
  | 'wild.wings'
  | 'wx.blizzard'
  | 'wx.fog'
  | 'wx.gust'
  | 'wx.rain'
  | 'wx.storm'
  | 'wx.thunder'
  | 'wx.wind';

export const SFX_KEYS: readonly SfxKey[] = [
  'amb.birds',
  'amb.bog',
  'amb.cave',
  'amb.creak',
  'amb.crickets',
  'amb.crypt',
  'amb.drip',
  'amb.dunes',
  'amb.ember',
  'amb.frogs',
  'amb.ghost',
  'amb.hall',
  'amb.highland',
  'amb.ice',
  'amb.rumble',
  'amb.snowland',
  'amb.wood',
  'announce.annihilation',
  'announce.capture_the_flag',
  'announce.dominating',
  'announce.double_kill',
  'announce.elimination',
  'announce.enemy_eliminated',
  'announce.eradication',
  'announce.final_stand',
  'announce.first_blood',
  'announce.game_over',
  'announce.headshot',
  'announce.killshot',
  'announce.last_man_standing',
  'announce.mission_accomplished',
  'announce.mission_failed',
  'announce.objective_completed',
  'announce.payback',
  'announce.payload_delivered',
  'announce.precision_kill',
  'announce.rampage',
  'announce.revenge_kill',
  'announce.round_winner',
  'announce.start',
  'announce.tango_down',
  'announce.target_locked',
  'announce.target_secured',
  'announce.team_deathmatch',
  'announce.triple_kill',
  'announce.unstoppable',
  'arrow.fly',
  'arrow.hit',
  'arrow.hit_armour',
  'arrow.volley',
  'bark.bard_attack',
  'bark.bard_downed',
  'bark.bard_item',
  'bark.bard_level',
  'bark.bard_ready',
  'bark.bard_victory',
  'bark.cleric_attack',
  'bark.cleric_downed',
  'bark.cleric_item',
  'bark.cleric_level',
  'bark.cleric_ready',
  'bark.cleric_victory',
  'bark.druid_attack',
  'bark.druid_downed',
  'bark.druid_item',
  'bark.druid_level',
  'bark.druid_ready',
  'bark.druid_victory',
  'bark.fighter_attack',
  'bark.fighter_downed',
  'bark.fighter_item',
  'bark.fighter_level',
  'bark.fighter_ready',
  'bark.fighter_victory',
  'bark.paladin_attack',
  'bark.paladin_downed',
  'bark.paladin_item',
  'bark.paladin_level',
  'bark.paladin_ready',
  'bark.paladin_victory',
  'bark.ranger_attack',
  'bark.ranger_downed',
  'bark.ranger_item',
  'bark.ranger_level',
  'bark.ranger_ready',
  'bark.ranger_victory',
  'bark.rogue_attack',
  'bark.rogue_downed',
  'bark.rogue_item',
  'bark.rogue_level',
  'bark.rogue_ready',
  'bark.rogue_victory',
  'bark.wizard_attack',
  'bark.wizard_downed',
  'bark.wizard_item',
  'bark.wizard_level',
  'bark.wizard_ready',
  'bark.wizard_victory',
  'body.bones',
  'body.fall',
  'body.fall_big',
  'body.splat',
  'bow.crossbow',
  'bow.draw',
  'bow.release',
  'cine.born',
  'cine.chapter',
  'cine.cry',
  'cine.defeat',
  'cine.escape',
  'cine.glitch',
  'cine.line',
  'cine.name',
  'cine.objective',
  'cine.page',
  'cine.reveal',
  'cine.rise',
  'cine.saga',
  'cine.shimmer',
  'cine.tick',
  'cine.title',
  'cine.victory',
  'cine.writing',
  'cue.acid_hiss',
  'cue.arena_bed',
  'cue.armor_buckle',
  'cue.armor_clank',
  'cue.arrow_fly',
  'cue.bat_wings',
  'cue.battle_far',
  'cue.bear_roar',
  'cue.beast_burrow',
  'cue.bell_small',
  'cue.bell_toll',
  'cue.big_cat_roar',
  'cue.birds_flee',
  'cue.birdsong',
  'cue.blessing_buff',
  'cue.boat_oars',
  'cue.bone_crack',
  'cue.bones_rattle',
  'cue.book_slam',
  'cue.braam',
  'cue.braam_dark',
  'cue.braam_epic',
  'cue.branch_snap',
  'cue.bubbling',
  'cue.candle_out',
  'cue.cart_wheels',
  'cue.cat_meow',
  'cue.cave_bed',
  'cue.cave_echo',
  'cue.chains',
  'cue.chant',
  'cue.child_cry',
  'cue.clock_tick',
  'cue.cloth_flutter',
  'cue.coin_bag',
  'cue.coins',
  'cue.crafting',
  'cue.creak',
  'cue.crow_caw',
  'cue.crowd_cheer',
  'cue.crowd_panic',
  'cue.deep_drone',
  'cue.desert_bed',
  'cue.dig',
  'cue.dog_bark',
  'cue.door_creak',
  'cue.door_knock',
  'cue.door_slam',
  'cue.dragon_roar',
  'cue.dungeon_bed',
  'cue.earth_magic',
  'cue.earthquake',
  'cue.eating',
  'cue.eerie_drone',
  'cue.electric_crackle',
  'cue.enchanted_blade',
  'cue.energy_hum',
  'cue.explosion',
  'cue.farm_animals',
  'cue.fire_bed',
  'cue.fire_crackle',
  'cue.fire_spell',
  'cue.fire_whoosh',
  'cue.footsteps',
  'cue.footsteps_run',
  'cue.forest_bed',
  'cue.frogs',
  'cue.gasp',
  'cue.gate_iron',
  'cue.ghost_moan',
  'cue.glass_break',
  'cue.glitch',
  'cue.glow_hum',
  'cue.goblin_cackle',
  'cue.goblin_shout',
  'cue.gore',
  'cue.hail',
  'cue.hammer_anvil',
  'cue.heartbeat',
  'cue.heartfelt_sting',
  'cue.hell_bed',
  'cue.hoofbeats',
  'cue.horde_roar',
  'cue.horn_call',
  'cue.horror_bed',
  'cue.horse_neigh',
  'cue.ice_crack',
  'cue.ice_magic',
  'cue.impact_deep',
  'cue.impact_earth',
  'cue.impact_far',
  'cue.impact_magic',
  'cue.impact_metal',
  'cue.inner_voice',
  'cue.insect_swarm',
  'cue.insects_night',
  'cue.jump_scare',
  'cue.laugh_evil',
  'cue.lightning',
  'cue.lock_click',
  'cue.magic_cast',
  'cue.magic_dark',
  'cue.magic_holy',
  'cue.magic_sparkle',
  'cue.market',
  'cue.mechanism',
  'cue.mine_bed',
  'cue.monster_appear',
  'cue.monster_growl',
  'cue.monster_roar',
  'cue.music_box',
  'cue.night_bed',
  'cue.ocean_bed',
  'cue.paper',
  'cue.piano_dissonant',
  'cue.port_bed',
  'cue.portal',
  'cue.potion_pour',
  'cue.power_up',
  'cue.pulse_ping',
  'cue.punch',
  'cue.quill',
  'cue.rain_bed',
  'cue.rain_burst',
  'cue.rat_squeak',
  'cue.relic_reveal',
  'cue.reverse_swell',
  'cue.riser',
  'cue.riser_bright',
  'cue.riser_dark',
  'cue.rockfall',
  'cue.rope_strain',
  'cue.rustle',
  'cue.scream',
  'cue.seagulls',
  'cue.shimmer',
  'cue.ship_bed',
  'cue.ship_creak',
  'cue.silence',
  'cue.slime_squelch',
  'cue.smithy_bed',
  'cue.smoke_puff',
  'cue.snake_hiss',
  'cue.spawn',
  'cue.splash',
  'cue.star_fall',
  'cue.static_whisper',
  'cue.sting_sad',
  'cue.sting_shock',
  'cue.sting_wonder',
  'cue.stinger_doom',
  'cue.stinger_mystery',
  'cue.stinger_triumph',
  'cue.stone_grind',
  'cue.storm_bed',
  'cue.stream',
  'cue.sub_drop',
  'cue.swamp_bed',
  'cue.sword_clash',
  'cue.sword_draw',
  'cue.sword_sheathe',
  'cue.tavern',
  'cue.teleport',
  'cue.tension_build',
  'cue.thud',
  'cue.thunder',
  'cue.thunder_far',
  'cue.thunder_spell',
  'cue.time_warp',
  'cue.torch_light',
  'cue.town_bed',
  'cue.trap_spring',
  'cue.tree_fall',
  'cue.undead_groan',
  'cue.village_bed',
  'cue.war_drums',
  'cue.war_shout',
  'cue.water_drip',
  'cue.water_rush',
  'cue.water_spell',
  'cue.waterfall_bed',
  'cue.waves',
  'cue.whip',
  'cue.whisper',
  'cue.whoosh',
  'cue.whoosh_air',
  'cue.whoosh_fire',
  'cue.whoosh_heavy',
  'cue.whoosh_magic',
  'cue.wind_bed',
  'cue.wind_gust',
  'cue.wind_magic',
  'cue.wind_moan',
  'cue.wind_night',
  'cue.wolf_howl',
  'cue.wood_break',
  'cue.wood_hit',
  'emote.angry',
  'emote.cant',
  'emote.come',
  'emote.crying',
  'emote.cute',
  'emote.dizzy',
  'emote.down',
  'emote.drooling',
  'emote.drumroll',
  'emote.eager',
  'emote.exclamation',
  'emote.fanfare',
  'emote.frustrated',
  'emote.headblown',
  'emote.idea',
  'emote.kissing',
  'emote.lament',
  'emote.laughing',
  'emote.left',
  'emote.lit',
  'emote.love',
  'emote.neutral',
  'emote.no',
  'emote.ok',
  'emote.omg',
  'emote.question',
  'emote.right',
  'emote.serenade',
  'emote.silence',
  'emote.sleepy',
  'emote.speechless',
  'emote.sweat',
  'emote.thinking',
  'emote.tongue',
  'emote.tune',
  'emote.up',
  'emote.yes',
  'enc.appear',
  'enc.begin',
  'enc.braam',
  'enc.defeat',
  'enc.fled',
  'enc.horn',
  'enc.melee',
  'enc.victory',
  'event.card',
  'hazard.water',
  'hit.armour',
  'hit.blood',
  'hit.blunt',
  'hit.bone',
  'hit.claw',
  'hit.guard_break',
  'hit.heavy',
  'hit.parry',
  'hit.shield',
  'hit.slash',
  'hit.slime',
  'hit.stab',
  'huge.debris',
  'huge.fire_hit',
  'huge.reveal',
  'inn.applause',
  'inn.aww',
  'inn.bark',
  'inn.bell',
  'inn.candle',
  'inn.cards',
  'inn.cheers',
  'inn.chips',
  'inn.clap',
  'inn.clink',
  'inn.coin_flip',
  'inn.coins_pot',
  'inn.coins_win',
  'inn.dice_one',
  'inn.dice_settle',
  'inn.dice_throw',
  'inn.gasp',
  'inn.groan',
  'inn.laugh',
  'inn.mug',
  'inn.mug_slide',
  'inn.page',
  'inn.poke',
  'inn.pour',
  'inn.purr',
  'inn.quill',
  'inn.rooster',
  'inn.snore',
  'inn.stairs',
  'inn.stick',
  'inn.turn',
  'item.bell',
  'item.book',
  'item.buff',
  'item.cards',
  'item.chime',
  'item.coins',
  'item.crafting',
  'item.drink',
  'item.drink_magic',
  'item.drum',
  'item.eat',
  'item.eat_magic',
  'item.enchant',
  'item.equip_axe',
  'item.equip_boots',
  'item.equip_bow',
  'item.equip_chain',
  'item.equip_cloth',
  'item.equip_club',
  'item.equip_crossbow',
  'item.equip_dagger',
  'item.equip_flail',
  'item.equip_leather',
  'item.equip_mace',
  'item.equip_magic',
  'item.equip_plate',
  'item.equip_shield_metal',
  'item.equip_shield_wood',
  'item.equip_spear',
  'item.equip_staff',
  'item.equip_sword',
  'item.gems',
  'item.gold',
  'item.gore_slash',
  'item.harp',
  'item.horn',
  'item.keys',
  'item.lootbox',
  'item.magic_slash',
  'item.portal',
  'item.powder',
  'item.rattle',
  'item.scroll',
  'item.shards',
  'item.spawn',
  'item.uncork',
  'liquid.fire',
  'liquid.lava',
  'liquid.water',
  'mech.door',
  'mech.lever',
  'mech.trap',
  'move.abyss',
  'move.acid',
  'move.avalanche',
  'move.bellow',
  'move.blizzard',
  'move.blood',
  'move.bones',
  'move.boulder',
  'move.brood',
  'move.burrow',
  'move.cackle',
  'move.chill',
  'move.command',
  'move.dive',
  'move.drums',
  'move.engulf',
  'move.fire',
  'move.gaze',
  'move.gears',
  'move.glamour',
  'move.gore',
  'move.gulp',
  'move.hiss',
  'move.howl',
  'move.inferno',
  'move.ink',
  'move.lash',
  'move.leap',
  'move.mend',
  'move.necrotic',
  'move.net',
  'move.parry',
  'move.petrify',
  'move.quake',
  'move.roar',
  'move.runes',
  'move.screech',
  'move.shadow',
  'move.shadowflame',
  'move.shield_wall',
  'move.slime',
  'move.smash',
  'move.smoke',
  'move.snap',
  'move.spines',
  'move.splash_in',
  'move.splash_out',
  'move.surface',
  'move.swarm',
  'move.sweep',
  'move.tide',
  'move.timber',
  'move.trick',
  'move.trumpet',
  'move.upwell',
  'move.venom',
  'move.wail',
  'move.web',
  'move.whirl',
  'move.wings',
  'music.battle',
  'music.dread',
  'music.haven',
  'music.mystery',
  'music.playful',
  'music.sorrow',
  'music.tavern',
  'music.tension',
  'music.title',
  'music.triumph',
  'music.wander',
  'music.wonder',
  'objective.progress',
  'order.all_on_the_held_one.cultist.brute',
  'order.all_on_the_held_one.cultist.zealot',
  'order.all_on_the_held_one.demon.brute',
  'order.all_on_the_held_one.demon.zealot',
  'order.all_on_the_held_one.orc.brute',
  'order.all_on_the_held_one.orc.zealot',
  'order.all_on_the_held_one.zombie.brute',
  'order.all_on_the_held_one.zombie.zealot',
  'order.all_that_glitters.mimic.brute',
  'order.all_that_glitters.mimic.lurker',
  'order.arrows_for_the_offender.cultist.warlord',
  'order.arrows_for_the_offender.cultist.zealot',
  'order.arrows_for_the_offender.gnoll.warlord',
  'order.arrows_for_the_offender.gnoll.zealot',
  'order.arrows_for_the_offender.soldier.warlord',
  'order.arrows_for_the_offender.soldier.zealot',
  'order.await_their_coming.cultist.lurker',
  'order.await_their_coming.cultist.warlord',
  'order.await_their_coming.lizardfolk.lurker',
  'order.await_their_coming.lizardfolk.warlord',
  'order.await_their_coming.skeleton.lurker',
  'order.await_their_coming.skeleton.warlord',
  'order.back_to_the_den.beast.beastmaster',
  'order.back_to_the_den.beast.lurker',
  'order.back_to_the_den.spider.beastmaster',
  'order.back_to_the_den.spider.lurker',
  'order.back_to_the_den.wolf.beastmaster',
  'order.back_to_the_den.wolf.lurker',
  'order.bait_the_bull.dark_elf.schemer',
  'order.bait_the_bull.dark_elf.warlord',
  'order.bait_the_bull.demon.schemer',
  'order.bait_the_bull.goblin.schemer',
  'order.bait_the_bull.goblin.warlord',
  'order.bait_the_bull.minotaur.warlord',
  'order.bait_the_crossbows.bandit.schemer',
  'order.bait_the_crossbows.bandit.warlord',
  'order.bait_the_crossbows.dark_elf.schemer',
  'order.bait_the_crossbows.dark_elf.warlord',
  'order.bar_the_ice_pass.grim_giant.brute',
  'order.bar_the_ice_pass.grim_giant.hexer',
  'order.bar_the_ice_pass.grim_giant.warlord',
  'order.bar_the_ice_pass.winter_court.hexer',
  'order.beneath_the_dunes.sand_tentacles.lurker',
  'order.beneath_the_dunes.sandworm.brute',
  'order.beneath_the_dunes.sandworm.lurker',
  'order.beneath_the_dunes.vermin.brute',
  'order.beneath_the_dunes.vermin.lurker',
  'order.bleed_the_clock.bandit.schemer',
  'order.bleed_the_clock.bandit.warlord',
  'order.bleed_the_clock.dark_elf.schemer',
  'order.bleed_the_clock.dark_elf.warlord',
  'order.bleed_the_clock.goblin.schemer',
  'order.bleed_the_clock.goblin.warlord',
  'order.bleed_the_clock.golem.schemer',
  'order.bleed_the_clock.golem.warlord',
  'order.bleed_the_clock.winter_court.schemer',
  'order.blessing_of_the_charge.elemental.brute',
  'order.blessing_of_the_charge.elemental.hexer',
  'order.blessing_of_the_charge.orc.brute',
  'order.blessing_of_the_charge.orc.hexer',
  'order.blessing_of_the_charge.troll.brute',
  'order.blessing_of_the_charge.troll.hexer',
  'order.blood_for_the_chief.cultist.brute',
  'order.blood_for_the_chief.cultist.warlord',
  'order.blood_for_the_chief.cultist.zealot',
  'order.blood_for_the_chief.gnoll.brute',
  'order.blood_for_the_chief.gnoll.warlord',
  'order.blood_for_the_chief.gnoll.zealot',
  'order.blood_for_the_chief.orc.brute',
  'order.blood_for_the_chief.orc.warlord',
  'order.blood_for_the_chief.orc.zealot',
  'order.blood_frenzy.beast.brute',
  'order.blood_frenzy.demon.brute',
  'order.blood_frenzy.demon.zealot',
  'order.blood_frenzy.gnoll.brute',
  'order.blood_frenzy.gnoll.zealot',
  'order.blood_frenzy.orc.brute',
  'order.blood_frenzy.orc.zealot',
  'order.blood_frenzy.troll.brute',
  'order.blood_frenzy.troll.zealot',
  'order.blood_on_the_wind.beast.lurker',
  'order.blood_on_the_wind.fey.hexer',
  'order.blood_on_the_wind.fey.lurker',
  'order.blood_on_the_wind.gnoll.hexer',
  'order.blood_on_the_wind.gnoll.lurker',
  'order.blood_on_the_wind.wolf.hexer',
  'order.blood_on_the_wind.wolf.lurker',
  'order.blood_price.cultist.hexer',
  'order.blood_price.cultist.zealot',
  'order.blood_price.demon.hexer',
  'order.blood_price.demon.zealot',
  'order.blood_price.gnoll.hexer',
  'order.blood_price.gnoll.zealot',
  'order.blood_price.orc.hexer',
  'order.blood_price.orc.zealot',
  'order.blood_price.vampire.hexer',
  'order.boars_snout.grim_giant.brute',
  'order.boars_snout.grim_giant.hexer',
  'order.boars_snout.grim_giant.warlord',
  'order.bolts_and_bombs.bandit.schemer',
  'order.bolts_and_bombs.bandit.warlord',
  'order.bolts_and_bombs.duergar.schemer',
  'order.bolts_and_bombs.duergar.warlord',
  'order.bolts_and_bombs.goblin.schemer',
  'order.bolts_and_bombs.goblin.warlord',
  'order.bone_hounds.skeleton.beastmaster',
  'order.bone_hounds.skeleton.hexer',
  'order.bone_hounds.zombie.hexer',
  'order.bound_and_cover.bandit.schemer',
  'order.bound_and_cover.bandit.warlord',
  'order.bound_and_cover.skeleton.schemer',
  'order.bound_and_cover.skeleton.warlord',
  'order.bounding_overwatch.bandit.schemer',
  'order.bounding_overwatch.bandit.warlord',
  'order.bounding_overwatch.dark_elf.schemer',
  'order.bounding_overwatch.dark_elf.warlord',
  'order.bounding_overwatch.goblin.schemer',
  'order.bounding_overwatch.goblin.warlord',
  'order.bows_to_the_high_ground.bandit.lurker',
  'order.bows_to_the_high_ground.bandit.warlord',
  'order.bows_to_the_high_ground.dark_elf.lurker',
  'order.bows_to_the_high_ground.dark_elf.warlord',
  'order.bows_to_the_high_ground.skeleton.lurker',
  'order.bows_to_the_high_ground.skeleton.warlord',
  'order.bring_me_the_little_fly.spider_queen.beastmaster',
  'order.bring_me_the_little_fly.spider_queen.brute',
  'order.bring_me_the_little_fly.spider_queen.lurker',
  'order.buried_in_the_snow.winter_court.beastmaster',
  'order.buried_in_the_snow.yeti.beastmaster',
  'order.buried_in_the_snow.yeti.brute',
  'order.buried_in_the_snow.yeti.lurker',
  'order.burn_the_wounded.demon.brute',
  'order.burn_the_wounded.demon.schemer',
  'order.burn_the_wounded.djinn.brute',
  'order.burn_the_wounded.djinn.schemer',
  'order.burn_the_wounded.dragon.brute',
  'order.burn_the_wounded.dragon.schemer',
  'order.burn_the_wounded.dragon.warlord',
  'order.burn_the_wounded.drake.brute',
  'order.call_of_the_moon.elemental.hexer',
  'order.call_of_the_moon.gnoll.hexer',
  'order.call_of_the_moon.wolf.hexer',
  'order.carve_the_runes.grim_giant.brute',
  'order.carve_the_runes.grim_giant.hexer',
  'order.carve_the_runes.grim_giant.warlord',
  'order.carve_the_runes.winter_court.hexer',
  'order.charge_from_the_smoke.goblin.brute',
  'order.charge_from_the_smoke.goblin.lurker',
  'order.charge_from_the_smoke.orc.brute',
  'order.charge_from_the_smoke.orc.lurker',
  'order.circle_and_wear.beast.beastmaster',
  'order.circle_and_wear.beast.lurker',
  'order.circle_and_wear.drake.beastmaster',
  'order.circle_and_wear.gnoll.beastmaster',
  'order.circle_and_wear.gnoll.lurker',
  'order.circle_and_wear.vampire.beastmaster',
  'order.circle_and_wear.vampire.lurker',
  'order.circle_and_wear.wolf.beastmaster',
  'order.circle_and_wear.wolf.lurker',
  'order.circle_the_stray.beast.beastmaster',
  'order.circle_the_stray.beast.lurker',
  'order.circle_the_stray.goblin.beastmaster',
  'order.circle_the_stray.goblin.lurker',
  'order.circle_the_stray.wolf.beastmaster',
  'order.circle_the_stray.wolf.lurker',
  'order.clear_the_place.gnoll.brute',
  'order.clear_the_place.gnoll.warlord',
  'order.clear_the_place.goblin.brute',
  'order.clear_the_place.goblin.warlord',
  'order.clear_the_place.orc.brute',
  'order.clear_the_place.orc.warlord',
  'order.close_on_the_caught.mimic.brute',
  'order.close_on_the_caught.mimic.lurker',
  'order.close_on_the_caught.ooze.brute',
  'order.close_on_the_caught.ooze.lurker',
  'order.close_on_the_caught.spider.brute',
  'order.close_on_the_caught.spider.lurker',
  'order.close_on_the_caught.vermin.brute',
  'order.close_on_the_caught.vermin.lurker',
  'order.close_on_the_caught.zombie.brute',
  'order.close_on_the_caught.zombie.lurker',
  'order.close_the_jaws.dark_elf.warlord',
  'order.close_the_jaws.orc.brute',
  'order.close_the_jaws.orc.warlord',
  'order.close_the_jaws.troll.brute',
  'order.close_the_jaws.troll.warlord',
  'order.close_the_ring.gnoll.beastmaster',
  'order.close_the_ring.gnoll.brute',
  'order.close_the_ring.gnoll.warlord',
  'order.close_the_ring.goblin.beastmaster',
  'order.close_the_ring.goblin.brute',
  'order.close_the_ring.goblin.warlord',
  'order.close_the_ring.ooze.brute',
  'order.close_the_ring.wolf.beastmaster',
  'order.close_the_ring.wolf.brute',
  'order.close_the_ring.wolf.warlord',
  'order.come_and_get_it.bandit.brute',
  'order.come_and_get_it.bandit.schemer',
  'order.come_and_get_it.demon.brute',
  'order.come_and_get_it.demon.schemer',
  'order.come_and_get_it.djinn.brute',
  'order.come_and_get_it.djinn.schemer',
  'order.come_and_get_it.gnoll.brute',
  'order.come_and_get_it.gnoll.schemer',
  'order.come_and_get_it.goblin.brute',
  'order.come_and_get_it.goblin.schemer',
  'order.cover_the_hexers.cultist.hexer',
  'order.cover_the_hexers.cultist.zealot',
  'order.cover_the_hexers.dark_elf.hexer',
  'order.cover_the_hexers.dark_elf.zealot',
  'order.cover_the_hexers.golem.hexer',
  'order.cover_the_hexers.witch.hexer',
  'order.cover_the_hexers.witch.zealot',
  'order.crescent_moon.cultist.warlord',
  'order.crescent_moon.cultist.zealot',
  'order.crescent_moon.dark_elf.warlord',
  'order.crescent_moon.dark_elf.zealot',
  'order.crowd_the_line.goblin.brute',
  'order.crowd_the_line.goblin.warlord',
  'order.crowd_the_line.zombie.brute',
  'order.crowd_the_line.zombie.warlord',
  'order.curse_and_crowd.mummy.hexer',
  'order.curse_and_crowd.mummy.warlord',
  'order.curse_and_crowd.zombie.hexer',
  'order.curse_and_crowd.zombie.warlord',
  'order.curse_the_caster.dark_elf.hexer',
  'order.curse_the_caster.dark_elf.schemer',
  'order.curse_the_caster.demon.hexer',
  'order.curse_the_caster.demon.schemer',
  'order.curse_the_caster.djinn.hexer',
  'order.curse_the_caster.djinn.schemer',
  'order.curse_the_caster.goblin.hexer',
  'order.curse_the_caster.goblin.schemer',
  'order.curse_the_caster.vampire.hexer',
  'order.curse_the_caster.vampire.schemer',
  'order.curse_the_threshold.cultist.hexer',
  'order.curse_the_threshold.cultist.zealot',
  'order.curse_the_threshold.lizardfolk.hexer',
  'order.curse_the_threshold.lizardfolk.zealot',
  'order.curse_the_threshold.mummy.hexer',
  'order.curse_the_threshold.mummy.zealot',
  'order.curse_the_threshold.skeleton.hexer',
  'order.curse_the_threshold.skeleton.zealot',
  'order.curse_the_threshold.witch.hexer',
  'order.curse_the_threshold.witch.zealot',
  'order.cut_off_retreat.bandit.schemer',
  'order.cut_off_retreat.bandit.warlord',
  'order.cut_off_retreat.dark_elf.schemer',
  'order.cut_off_retreat.dark_elf.warlord',
  'order.cut_off_retreat.duergar.schemer',
  'order.cut_off_retreat.duergar.warlord',
  'order.cut_off_retreat.goblin.schemer',
  'order.cut_off_retreat.goblin.warlord',
  'order.cut_out_the_quarry.beast.beastmaster',
  'order.cut_out_the_quarry.beast.lurker',
  'order.cut_out_the_quarry.gnoll.beastmaster',
  'order.cut_out_the_quarry.gnoll.lurker',
  'order.cut_out_the_quarry.wolf.beastmaster',
  'order.cut_out_the_quarry.wolf.lurker',
  'order.cut_out_the_straggler.beast.beastmaster',
  'order.cut_out_the_straggler.beast.lurker',
  'order.cut_out_the_straggler.drake.beastmaster',
  'order.cut_out_the_straggler.gnoll.beastmaster',
  'order.cut_out_the_straggler.gnoll.lurker',
  'order.cut_out_the_straggler.gnoll.warlord',
  'order.cut_out_the_straggler.spider.beastmaster',
  'order.cut_out_the_straggler.spider.lurker',
  'order.cut_out_the_straggler.wolf.beastmaster',
  'order.cut_out_the_straggler.wolf.lurker',
  'order.cut_out_the_straggler.wolf.warlord',
  'order.darken_the_sky.cultist.warlord',
  'order.darken_the_sky.cultist.zealot',
  'order.darken_the_sky.goblin.warlord',
  'order.darken_the_sky.goblin.zealot',
  'order.darken_the_sky.orc.warlord',
  'order.darken_the_sky.orc.zealot',
  'order.darken_the_sky.soldier.warlord',
  'order.darken_the_sky.soldier.zealot',
  'order.darts_from_the_reeds.fey.hexer',
  'order.darts_from_the_reeds.fey.lurker',
  'order.darts_from_the_reeds.lizardfolk.hexer',
  'order.darts_from_the_reeds.lizardfolk.lurker',
  'order.darts_from_the_reeds.spider.hexer',
  'order.darts_from_the_reeds.spider.lurker',
  'order.death_ground.cultist.warlord',
  'order.death_ground.cultist.zealot',
  'order.death_ground.ghost.zealot',
  'order.death_ground.orc.warlord',
  'order.death_ground.orc.zealot',
  'order.death_ground.skeleton.warlord',
  'order.death_ground.skeleton.zealot',
  'order.death_ground.troll.warlord',
  'order.death_ground.troll.zealot',
  'order.defeat_in_detail.bandit.schemer',
  'order.defeat_in_detail.bandit.warlord',
  'order.defeat_in_detail.dark_elf.schemer',
  'order.defeat_in_detail.dark_elf.warlord',
  'order.defeat_in_detail.skeleton.schemer',
  'order.defeat_in_detail.skeleton.warlord',
  'order.defence_in_depth.bandit.schemer',
  'order.defence_in_depth.bandit.warlord',
  'order.defence_in_depth.dark_elf.schemer',
  'order.defence_in_depth.dark_elf.warlord',
  'order.defence_in_depth.duergar.schemer',
  'order.defence_in_depth.duergar.warlord',
  'order.defence_in_depth.golem.schemer',
  'order.defence_in_depth.golem.warlord',
  'order.defence_in_depth.skeleton.schemer',
  'order.defence_in_depth.skeleton.warlord',
  'order.die_for_the_master.cultist.hexer',
  'order.die_for_the_master.cultist.schemer',
  'order.die_for_the_master.cultist.zealot',
  'order.die_for_the_master.dark_elf.hexer',
  'order.die_for_the_master.dark_elf.schemer',
  'order.die_for_the_master.dark_elf.zealot',
  'order.die_for_the_master.soldier.zealot',
  'order.die_for_the_master.witch.hexer',
  'order.die_for_the_master.witch.schemer',
  'order.die_for_the_master.witch.zealot',
  'order.double_envelopment.bandit.schemer',
  'order.double_envelopment.bandit.warlord',
  'order.double_envelopment.dark_elf.schemer',
  'order.double_envelopment.dark_elf.warlord',
  'order.double_envelopment.gnoll.schemer',
  'order.double_envelopment.gnoll.warlord',
  'order.drag_down_the_caught.beast.brute',
  'order.drag_down_the_caught.beast.lurker',
  'order.drag_down_the_caught.mimic.brute',
  'order.drag_down_the_caught.mimic.lurker',
  'order.drag_down_the_caught.ooze.brute',
  'order.drag_down_the_caught.ooze.lurker',
  'order.drag_down_the_caught.spider.brute',
  'order.drag_down_the_caught.spider.lurker',
  'order.drag_down_the_caught.wolf.brute',
  'order.drag_down_the_caught.wolf.lurker',
  'order.drag_it_into_the_black.maw_of_the_deep.brute',
  'order.drag_it_into_the_black.maw_of_the_deep.lurker',
  'order.drag_them_to_the_god.basilisk.brute',
  'order.drag_them_to_the_god.basilisk.hexer',
  'order.drag_them_to_the_god.basilisk.lurker',
  'order.drag_them_to_the_god.gorgon.hexer',
  'order.drag_them_to_the_god.gorgon.lurker',
  'order.draw_the_champion.dark_elf.lurker',
  'order.draw_the_champion.dark_elf.schemer',
  'order.draw_the_champion.goblin.lurker',
  'order.draw_the_champion.goblin.schemer',
  'order.draw_the_champion.gorgon.lurker',
  'order.draw_the_champion.gorgon.schemer',
  'order.draw_the_champion.witch.schemer',
  'order.draw_them_off.bandit.schemer',
  'order.draw_them_off.dark_elf.schemer',
  'order.draw_them_off.djinn.schemer',
  'order.draw_them_off.fey.schemer',
  'order.draw_them_off.goblin.schemer',
  'order.dress_ranks.lizardfolk.warlord',
  'order.dress_ranks.mummy.warlord',
  'order.dress_ranks.skeleton.warlord',
  'order.dress_ranks.soldier.warlord',
  'order.drink_of_the_fallen.cultist.hexer',
  'order.drink_of_the_fallen.cultist.lurker',
  'order.drink_of_the_fallen.cultist.zealot',
  'order.drink_of_the_fallen.ghost.hexer',
  'order.drink_of_the_fallen.ghost.lurker',
  'order.drink_of_the_fallen.ghost.zealot',
  'order.drink_of_the_fallen.gnoll.hexer',
  'order.drink_of_the_fallen.gnoll.lurker',
  'order.drink_of_the_fallen.gnoll.zealot',
  'order.drink_of_the_fallen.spider.hexer',
  'order.drink_of_the_fallen.spider.lurker',
  'order.drink_of_the_fallen.vampire.hexer',
  'order.drink_of_the_fallen.vampire.lurker',
  'order.drive_into_the_open.great_eagle.beastmaster',
  'order.drive_into_the_open.great_eagle.brute',
  'order.drive_the_boars.beast.beastmaster',
  'order.drive_the_boars.beast.brute',
  'order.drive_the_boars.cyclops.beastmaster',
  'order.drive_the_boars.cyclops.brute',
  'order.drive_the_boars.orc.beastmaster',
  'order.drive_the_boars.orc.brute',
  'order.drive_the_boars.troll.beastmaster',
  'order.drive_the_boars.troll.brute',
  'order.drive_them_into_the_fire.demon.brute',
  'order.drive_them_into_the_fire.demon.schemer',
  'order.drive_them_into_the_fire.djinn.brute',
  'order.drive_them_into_the_fire.djinn.schemer',
  'order.drive_them_into_the_fire.dragon.brute',
  'order.drive_them_into_the_fire.dragon.schemer',
  'order.drive_them_into_the_fire.dragon.warlord',
  'order.drive_them_to_the_water.kraken.brute',
  'order.drive_them_to_the_water.kraken.lurker',
  'order.drive_them_to_the_water.kraken.zealot',
  'order.drop_from_the_canopy.spider_queen.beastmaster',
  'order.drop_from_the_canopy.spider_queen.brute',
  'order.drop_from_the_canopy.spider_queen.lurker',
  'order.drop_from_the_canopy.vermin.brute',
  'order.drop_from_the_canopy.vermin.lurker',
  'order.drown_in_numbers.bandit.warlord',
  'order.drown_in_numbers.bandit.zealot',
  'order.drown_in_numbers.zombie.warlord',
  'order.drown_in_numbers.zombie.zealot',
  'order.encircle_in_ash.black_dragon.brute',
  'order.encircle_in_ash.black_dragon.lurker',
  'order.encircle_in_ash.black_dragon.schemer',
  'order.endless_tide.cultist.brute',
  'order.endless_tide.cultist.zealot',
  'order.endless_tide.elemental.brute',
  'order.endless_tide.ghost.zealot',
  'order.endless_tide.skeleton.brute',
  'order.endless_tide.skeleton.zealot',
  'order.endless_tide.zombie.brute',
  'order.endless_tide.zombie.zealot',
  'order.engulf_the_weak.mimic.brute',
  'order.engulf_the_weak.mimic.lurker',
  'order.engulf_the_weak.ooze.brute',
  'order.engulf_the_weak.ooze.lurker',
  'order.engulf_the_weak.spider.brute',
  'order.engulf_the_weak.spider.lurker',
  'order.engulf_the_weak.vermin.brute',
  'order.engulf_the_weak.vermin.lurker',
  'order.engulf_the_weak.wolf.brute',
  'order.engulf_the_weak.wolf.lurker',
  'order.envelop_the_prize.bandit.schemer',
  'order.envelop_the_prize.bandit.warlord',
  'order.envelop_the_prize.dark_elf.schemer',
  'order.envelop_the_prize.dark_elf.warlord',
  'order.envelop_the_prize.goblin.schemer',
  'order.envelop_the_prize.goblin.warlord',
  'order.feed_the_beast.cultist.beastmaster',
  'order.feed_the_beast.cultist.zealot',
  'order.feed_the_beast.gnoll.beastmaster',
  'order.feed_the_beast.gnoll.zealot',
  'order.feigned_rout.bandit.schemer',
  'order.feigned_rout.bandit.warlord',
  'order.feigned_rout.dark_elf.schemer',
  'order.feigned_rout.dark_elf.warlord',
  'order.feigned_rout.djinn.schemer',
  'order.feigned_rout.fey.schemer',
  'order.feigned_rout.goblin.schemer',
  'order.feigned_rout.goblin.warlord',
  'order.fetch_me_that_one.cyclops.brute',
  'order.fetch_me_that_one.mountain_troll.brute',
  'order.fetch_me_that_one.mountain_troll.lurker',
  'order.fetch_me_that_one.mountain_troll.warlord',
  'order.fighting_withdrawal.bandit.schemer',
  'order.fighting_withdrawal.bandit.warlord',
  'order.fighting_withdrawal.dark_elf.schemer',
  'order.fighting_withdrawal.dark_elf.warlord',
  'order.fighting_withdrawal.goblin.schemer',
  'order.fighting_withdrawal.goblin.warlord',
  'order.fix_and_flank.bandit.schemer',
  'order.fix_and_flank.bandit.warlord',
  'order.fix_and_flank.dark_elf.schemer',
  'order.fix_and_flank.dark_elf.warlord',
  'order.fix_and_flank.orc.schemer',
  'order.fix_and_flank.orc.warlord',
  'order.flank.bandit.beastmaster',
  'order.flank.bandit.brute',
  'order.flank.bandit.schemer',
  'order.flank.bandit.warlord',
  'order.flank.dark_elf.beastmaster',
  'order.flank.dark_elf.schemer',
  'order.flank.dark_elf.warlord',
  'order.flank.gnoll.beastmaster',
  'order.flank.gnoll.brute',
  'order.flank.gnoll.schemer',
  'order.flank.gnoll.warlord',
  'order.flank.goblin.beastmaster',
  'order.flank.goblin.brute',
  'order.flank.goblin.schemer',
  'order.flank.goblin.warlord',
  'order.flank.orc.beastmaster',
  'order.flank.orc.brute',
  'order.flank.orc.schemer',
  'order.flank.orc.warlord',
  'order.flee_and_loose.bandit.beastmaster',
  'order.flee_and_loose.bandit.schemer',
  'order.flee_and_loose.beholder.schemer',
  'order.flee_and_loose.goblin.beastmaster',
  'order.flee_and_loose.goblin.schemer',
  'order.flee_the_trembling.sandworm.brute',
  'order.flee_the_trembling.sandworm.lurker',
  'order.flow_round.elemental.brute',
  'order.flow_round.ooze.brute',
  'order.flow_round.ooze.lurker',
  'order.flow_round.vermin.brute',
  'order.flow_round.vermin.lurker',
  'order.flow_round.zombie.brute',
  'order.flow_round.zombie.lurker',
  'order.follow_the_light.fey.hexer',
  'order.follow_the_light.fey.lurker',
  'order.follow_the_light.fey.schemer',
  'order.from_the_hedgerows.bandit.lurker',
  'order.from_the_hedgerows.bandit.schemer',
  'order.from_the_hedgerows.goblin.lurker',
  'order.from_the_hedgerows.goblin.schemer',
  'order.from_the_hedgerows.lizardfolk.lurker',
  'order.from_the_hedgerows.lizardfolk.schemer',
  'order.from_the_still_water.basilisk.brute',
  'order.from_the_still_water.basilisk.hexer',
  'order.from_the_still_water.basilisk.lurker',
  'order.from_the_still_water.gorgon.hexer',
  'order.from_the_still_water.gorgon.lurker',
  'order.from_the_still_water.tentacles.lurker',
  'order.fury_of_the_peaks.yeti.beastmaster',
  'order.fury_of_the_peaks.yeti.brute',
  'order.fury_of_the_peaks.yeti.lurker',
  'order.fury_of_the_sacred_grove.ent.brute',
  'order.fury_of_the_sacred_grove.ent.lurker',
  'order.fury_of_the_sacred_grove.ent.zealot',
  'order.ghost_host.cultist.hexer',
  'order.ghost_host.cultist.schemer',
  'order.ghost_host.dark_elf.hexer',
  'order.ghost_host.dark_elf.schemer',
  'order.ghost_host.djinn.hexer',
  'order.ghost_host.djinn.schemer',
  'order.ghost_host.fey.hexer',
  'order.ghost_host.fey.schemer',
  'order.ghost_host.ghost.hexer',
  'order.ghosts_in_the_snow.dark_elf.hexer',
  'order.ghosts_in_the_snow.dark_elf.lurker',
  'order.ghosts_in_the_snow.ghost.hexer',
  'order.ghosts_in_the_snow.ghost.lurker',
  'order.ghosts_in_the_snow.winter_court.hexer',
  'order.ghosts_in_the_snow.wolf.hexer',
  'order.ghosts_in_the_snow.wolf.lurker',
  'order.guard_from_hiding.cultist.hexer',
  'order.guard_from_hiding.cultist.lurker',
  'order.guard_from_hiding.duergar.lurker',
  'order.guard_from_hiding.fey.hexer',
  'order.guard_from_hiding.fey.lurker',
  'order.guard_from_hiding.lizardfolk.hexer',
  'order.guard_from_hiding.lizardfolk.lurker',
  'order.guard_from_hiding.spider.hexer',
  'order.guard_from_hiding.spider.lurker',
  'order.guard_the_egg_sacs.spider_queen.beastmaster',
  'order.guard_the_egg_sacs.spider_queen.brute',
  'order.guard_the_egg_sacs.spider_queen.lurker',
  'order.guard_the_hoard.dragon.brute',
  'order.guard_the_hoard.dragon.schemer',
  'order.guard_the_hoard.dragon.warlord',
  'order.guard_the_hoard.drake.brute',
  'order.guard_the_hoard.mimic.brute',
  'order.guard_the_little_hoard.drake.beastmaster',
  'order.guard_the_little_hoard.drake.brute',
  'order.guard_the_place.cultist.brute',
  'order.guard_the_place.cultist.warlord',
  'order.guard_the_place.cultist.zealot',
  'order.guard_the_place.lizardfolk.brute',
  'order.guard_the_place.lizardfolk.warlord',
  'order.guard_the_place.lizardfolk.zealot',
  'order.guard_the_place.mummy.warlord',
  'order.guard_the_place.mummy.zealot',
  'order.guard_the_place.skeleton.brute',
  'order.guard_the_place.skeleton.warlord',
  'order.guard_the_place.skeleton.zealot',
  'order.hammer_and_anvil.orc.brute',
  'order.hammer_and_anvil.orc.warlord',
  'order.hammer_and_anvil.skeleton.brute',
  'order.hammer_and_anvil.skeleton.warlord',
  'order.harry.bandit.beastmaster',
  'order.harry.bandit.hexer',
  'order.harry.bandit.lurker',
  'order.harry.bandit.schemer',
  'order.harry.dark_elf.beastmaster',
  'order.harry.dark_elf.hexer',
  'order.harry.dark_elf.lurker',
  'order.harry.dark_elf.schemer',
  'order.harry.gnoll.beastmaster',
  'order.harry.gnoll.hexer',
  'order.harry.gnoll.lurker',
  'order.harry.gnoll.schemer',
  'order.harry.goblin.beastmaster',
  'order.harry.goblin.hexer',
  'order.harry.goblin.lurker',
  'order.harry.goblin.schemer',
  'order.harry.lizardfolk.beastmaster',
  'order.harry.lizardfolk.hexer',
  'order.harry.lizardfolk.lurker',
  'order.harry.lizardfolk.schemer',
  'order.hedgehog.golem.warlord',
  'order.hedgehog.orc.brute',
  'order.hedgehog.orc.warlord',
  'order.hedgehog.skeleton.brute',
  'order.hedgehog.skeleton.warlord',
  'order.hedgehog.troll.brute',
  'order.hedgehog.troll.warlord',
  'order.herd_the_meal_to_its_jaws.maw_of_the_deep.brute',
  'order.herd_the_meal_to_its_jaws.maw_of_the_deep.lurker',
  'order.hex_the_champion.cultist.hexer',
  'order.hex_the_champion.cultist.zealot',
  'order.hex_the_champion.dark_elf.hexer',
  'order.hex_the_champion.dark_elf.zealot',
  'order.hex_the_champion.demon.hexer',
  'order.hex_the_champion.demon.zealot',
  'order.hex_the_champion.elemental.hexer',
  'order.hex_the_champion.goblin.hexer',
  'order.hex_the_champion.goblin.zealot',
  'order.hit_the_baggage.bandit.lurker',
  'order.hit_the_baggage.bandit.schemer',
  'order.hit_the_baggage.orc.lurker',
  'order.hit_the_baggage.orc.schemer',
  'order.hold_for_the_working.cultist.hexer',
  'order.hold_for_the_working.cultist.warlord',
  'order.hold_for_the_working.golem.hexer',
  'order.hold_for_the_working.golem.warlord',
  'order.hold_for_the_working.lizardfolk.hexer',
  'order.hold_for_the_working.lizardfolk.warlord',
  'order.hold_for_the_working.mummy.hexer',
  'order.hold_for_the_working.mummy.warlord',
  'order.hold_for_the_working.troll.hexer',
  'order.hold_for_the_working.troll.warlord',
  'order.hold_the_bridge.golem.warlord',
  'order.hold_the_bridge.orc.beastmaster',
  'order.hold_the_bridge.orc.brute',
  'order.hold_the_bridge.orc.warlord',
  'order.hold_the_bridge.skeleton.beastmaster',
  'order.hold_the_bridge.skeleton.brute',
  'order.hold_the_bridge.skeleton.warlord',
  'order.hold_the_bridge.troll.beastmaster',
  'order.hold_the_bridge.troll.brute',
  'order.hold_the_bridge.troll.warlord',
  'order.hold_the_eyrie.great_eagle.beastmaster',
  'order.hold_the_eyrie.great_eagle.brute',
  'order.hold_the_ford.lizardfolk.brute',
  'order.hold_the_ford.lizardfolk.lurker',
  'order.hold_the_ford.troll.brute',
  'order.hold_the_ford.troll.lurker',
  'order.hold_the_grove.ent.brute',
  'order.hold_the_grove.ent.lurker',
  'order.hold_the_grove.ent.zealot',
  'order.hold_the_hill.bandit.brute',
  'order.hold_the_hill.bandit.schemer',
  'order.hold_the_hill.bandit.warlord',
  'order.hold_the_hill.goblin.brute',
  'order.hold_the_hill.goblin.schemer',
  'order.hold_the_hill.goblin.warlord',
  'order.hold_the_hill.orc.brute',
  'order.hold_the_hill.orc.schemer',
  'order.hold_the_hill.orc.warlord',
  'order.hold_the_narrows.bandit.lurker',
  'order.hold_the_narrows.bandit.warlord',
  'order.hold_the_narrows.duergar.lurker',
  'order.hold_the_narrows.duergar.warlord',
  'order.hold_the_narrows.lizardfolk.lurker',
  'order.hold_the_narrows.lizardfolk.warlord',
  'order.hold_the_narrows.minotaur.warlord',
  'order.hold_the_narrows.skeleton.lurker',
  'order.hold_the_narrows.skeleton.warlord',
  'order.hold_the_pass.cyclops.brute',
  'order.hold_the_pass.duergar.lurker',
  'order.hold_the_pass.duergar.warlord',
  'order.hold_the_pass.mountain_troll.brute',
  'order.hold_the_pass.mountain_troll.lurker',
  'order.hold_the_pass.mountain_troll.warlord',
  'order.hold_the_shallows.kraken.brute',
  'order.hold_the_shallows.kraken.lurker',
  'order.hold_the_shallows.kraken.zealot',
  'order.hold_them_in_its_gaze.basilisk.brute',
  'order.hold_them_in_its_gaze.basilisk.hexer',
  'order.hold_them_in_its_gaze.basilisk.lurker',
  'order.hold_them_in_its_gaze.beholder.hexer',
  'order.hold_them_in_its_gaze.gorgon.hexer',
  'order.hold_them_in_its_gaze.gorgon.lurker',
  'order.hold_till_the_bell.orc.brute',
  'order.hold_till_the_bell.orc.warlord',
  'order.hold_till_the_bell.skeleton.brute',
  'order.hold_till_the_bell.skeleton.warlord',
  'order.horns_of_the_bull.gnoll.brute',
  'order.horns_of_the_bull.gnoll.warlord',
  'order.horns_of_the_bull.goblin.brute',
  'order.horns_of_the_bull.goblin.warlord',
  'order.horns_of_the_bull.minotaur.brute',
  'order.horns_of_the_bull.minotaur.warlord',
  'order.horns_of_the_bull.orc.brute',
  'order.horns_of_the_bull.orc.warlord',
  'order.hounds_at_the_healer.beast.beastmaster',
  'order.hounds_at_the_healer.beast.lurker',
  'order.hounds_at_the_healer.dark_elf.beastmaster',
  'order.hounds_at_the_healer.dark_elf.lurker',
  'order.hounds_at_the_healer.vampire.beastmaster',
  'order.hounds_at_the_healer.vampire.lurker',
  'order.hounds_at_the_healer.wolf.beastmaster',
  'order.hounds_at_the_healer.wolf.lurker',
  'order.hounds_before_the_shields.cultist.beastmaster',
  'order.hounds_before_the_shields.cyclops.beastmaster',
  'order.hounds_before_the_shields.skeleton.beastmaster',
  'order.hounds_before_the_shields.troll.beastmaster',
  'order.hounds_drive_bows_kill.beast.beastmaster',
  'order.hounds_drive_bows_kill.gnoll.beastmaster',
  'order.howl_of_dread.djinn.brute',
  'order.howl_of_dread.djinn.hexer',
  'order.howl_of_dread.elemental.brute',
  'order.howl_of_dread.elemental.hexer',
  'order.howl_of_dread.gnoll.brute',
  'order.howl_of_dread.gnoll.hexer',
  'order.howl_of_dread.wolf.brute',
  'order.howl_of_dread.wolf.hexer',
  'order.hunting_ring.gnoll.beastmaster',
  'order.hunting_ring.gnoll.lurker',
  'order.hunting_ring.gnoll.warlord',
  'order.hunting_ring.lizardfolk.beastmaster',
  'order.hunting_ring.lizardfolk.lurker',
  'order.hunting_ring.lizardfolk.warlord',
  'order.hunting_ring.wolf.beastmaster',
  'order.hunting_ring.wolf.lurker',
  'order.hunting_ring.wolf.warlord',
  'order.huscarls_shield_wall.duergar.warlord',
  'order.huscarls_shield_wall.grim_giant.brute',
  'order.huscarls_shield_wall.grim_giant.hexer',
  'order.huscarls_shield_wall.grim_giant.warlord',
  'order.hymn_of_the_hollow.cultist.hexer',
  'order.hymn_of_the_hollow.cultist.zealot',
  'order.hymn_of_the_hollow.lizardfolk.hexer',
  'order.hymn_of_the_hollow.lizardfolk.zealot',
  'order.hymn_of_the_hollow.mummy.hexer',
  'order.hymn_of_the_hollow.mummy.zealot',
  'order.into_the_cauldron.witch.hexer',
  'order.into_the_cauldron.witch.schemer',
  'order.into_the_cauldron.witch.zealot',
  'order.into_the_gullet.dark_elf.schemer',
  'order.into_the_gullet.dark_elf.warlord',
  'order.into_the_gullet.golem.schemer',
  'order.into_the_gullet.golem.warlord',
  'order.into_the_gullet.lizardfolk.schemer',
  'order.into_the_gullet.lizardfolk.warlord',
  'order.into_the_gullet.minotaur.warlord',
  'order.into_the_murk.cultist.hexer',
  'order.into_the_murk.cultist.lurker',
  'order.into_the_murk.dark_elf.hexer',
  'order.into_the_murk.dark_elf.lurker',
  'order.into_the_murk.ghost.hexer',
  'order.into_the_murk.ghost.lurker',
  'order.into_the_murk.lizardfolk.hexer',
  'order.into_the_murk.lizardfolk.lurker',
  'order.into_the_murk.vampire.hexer',
  'order.into_the_murk.vampire.lurker',
  'order.into_the_whiteout.winter_court.beastmaster',
  'order.into_the_whiteout.yeti.beastmaster',
  'order.into_the_whiteout.yeti.brute',
  'order.into_the_whiteout.yeti.lurker',
  'order.javelins_then_steel.cultist.brute',
  'order.javelins_then_steel.cultist.warlord',
  'order.javelins_then_steel.cultist.zealot',
  'order.javelins_then_steel.orc.brute',
  'order.javelins_then_steel.orc.warlord',
  'order.javelins_then_steel.orc.zealot',
  'order.keep_their_heads_down.beholder.hexer',
  'order.keep_their_heads_down.cultist.hexer',
  'order.keep_their_heads_down.cultist.warlord',
  'order.keep_their_heads_down.skeleton.hexer',
  'order.keep_their_heads_down.skeleton.warlord',
  'order.kill_the_mender_first.bandit.hexer',
  'order.kill_the_mender_first.bandit.lurker',
  'order.kill_the_mender_first.bandit.schemer',
  'order.kill_the_mender_first.dark_elf.hexer',
  'order.kill_the_mender_first.dark_elf.lurker',
  'order.kill_the_mender_first.dark_elf.schemer',
  'order.kill_the_mender_first.gnoll.hexer',
  'order.kill_the_mender_first.gnoll.lurker',
  'order.kill_the_mender_first.gnoll.schemer',
  'order.kill_the_mender_first.vampire.hexer',
  'order.kill_the_mender_first.vampire.lurker',
  'order.kill_the_mender_first.vampire.schemer',
  'order.kill_the_mender_first.witch.hexer',
  'order.kill_the_mender_first.witch.schemer',
  'order.kneel_before_the_wyrm.dragon.brute',
  'order.kneel_before_the_wyrm.dragon.schemer',
  'order.kneel_before_the_wyrm.dragon.warlord',
  'order.lead_from_the_front.minotaur.brute',
  'order.lead_from_the_front.minotaur.warlord',
  'order.lead_from_the_front.orc.brute',
  'order.lead_from_the_front.orc.warlord',
  'order.lead_from_the_front.troll.brute',
  'order.lead_from_the_front.troll.warlord',
  'order.let_none_leave_the_trees.ent.brute',
  'order.let_none_leave_the_trees.ent.lurker',
  'order.let_none_leave_the_trees.ent.zealot',
  'order.let_none_leave_the_trees.fey.lurker',
  'order.let_them_choke.black_dragon.brute',
  'order.let_them_choke.black_dragon.lurker',
  'order.let_them_choke.black_dragon.schemer',
  'order.lie_like_stones.mimic.brute',
  'order.lie_like_stones.mimic.lurker',
  'order.lie_like_stones.mountain_troll.brute',
  'order.lie_like_stones.mountain_troll.lurker',
  'order.lie_like_stones.mountain_troll.warlord',
  'order.lie_still_in_the_deep.maw_of_the_deep.brute',
  'order.lie_still_in_the_deep.maw_of_the_deep.lurker',
  'order.loose_and_slip_away.bandit.lurker',
  'order.loose_and_slip_away.bandit.schemer',
  'order.loose_and_slip_away.beholder.schemer',
  'order.loose_and_slip_away.fey.lurker',
  'order.loose_and_slip_away.fey.schemer',
  'order.loose_and_slip_away.goblin.lurker',
  'order.loose_and_slip_away.goblin.schemer',
  'order.loose_and_slip_away.lizardfolk.lurker',
  'order.loose_and_slip_away.lizardfolk.schemer',
  'order.loose_the_hounds.cyclops.beastmaster',
  'order.loose_the_hounds.gnoll.beastmaster',
  'order.loose_the_hounds.goblin.beastmaster',
  'order.loose_the_hounds.orc.beastmaster',
  'order.loose_the_hounds.wolf.beastmaster',
  'order.loose_together.bandit.schemer',
  'order.loose_together.bandit.warlord',
  'order.loose_together.goblin.schemer',
  'order.loose_together.goblin.warlord',
  'order.loose_together.skeleton.schemer',
  'order.loose_together.skeleton.warlord',
  'order.loose_together.soldier.warlord',
  'order.many_arms.sand_tentacles.lurker',
  'order.many_arms.tentacles.lurker',
  'order.mark_for_the_pack.gnoll.beastmaster',
  'order.mark_for_the_pack.gnoll.hexer',
  'order.mark_for_the_pack.spider.beastmaster',
  'order.mark_for_the_pack.spider.hexer',
  'order.mark_for_the_pack.vampire.beastmaster',
  'order.mark_for_the_pack.vampire.hexer',
  'order.martyrs_price.cultist.hexer',
  'order.martyrs_price.cultist.zealot',
  'order.martyrs_price.ghost.hexer',
  'order.martyrs_price.ghost.zealot',
  'order.martyrs_price.orc.hexer',
  'order.martyrs_price.orc.zealot',
  'order.martyrs_ward.cultist.hexer',
  'order.martyrs_ward.cultist.zealot',
  'order.martyrs_ward.goblin.hexer',
  'order.martyrs_ward.goblin.zealot',
  'order.martyrs_ward.mummy.hexer',
  'order.martyrs_ward.mummy.zealot',
  'order.mend_the_line.cultist.hexer',
  'order.mend_the_line.cultist.zealot',
  'order.mend_the_line.golem.hexer',
  'order.mend_the_line.lizardfolk.hexer',
  'order.mend_the_line.lizardfolk.zealot',
  'order.mend_the_line.troll.hexer',
  'order.mend_the_line.troll.zealot',
  'order.mend_the_line.witch.hexer',
  'order.mend_the_line.witch.zealot',
  'order.mothers_wrath.spider_queen.beastmaster',
  'order.mothers_wrath.spider_queen.brute',
  'order.mothers_wrath.spider_queen.lurker',
  'order.never_give_battle.bandit.schemer',
  'order.never_give_battle.bandit.warlord',
  'order.never_give_battle.beholder.schemer',
  'order.never_give_battle.dark_elf.schemer',
  'order.never_give_battle.dark_elf.warlord',
  'order.never_give_battle.golem.schemer',
  'order.never_give_battle.golem.warlord',
  'order.never_give_battle.winter_court.schemer',
  'order.never_meet_its_eyes.basilisk.brute',
  'order.never_meet_its_eyes.basilisk.hexer',
  'order.never_meet_its_eyes.basilisk.lurker',
  'order.never_meet_its_eyes.beholder.hexer',
  'order.never_meet_its_eyes.gorgon.hexer',
  'order.never_meet_its_eyes.gorgon.lurker',
  'order.night_knives.dark_elf.hexer',
  'order.night_knives.dark_elf.lurker',
  'order.night_knives.ghost.hexer',
  'order.night_knives.ghost.lurker',
  'order.night_knives.goblin.hexer',
  'order.night_knives.goblin.lurker',
  'order.night_knives.spider.hexer',
  'order.night_knives.spider.lurker',
  'order.night_knives.vampire.hexer',
  'order.night_knives.vampire.lurker',
  'order.night_raid.gnoll.lurker',
  'order.night_raid.goblin.lurker',
  'order.night_raid.orc.lurker',
  'order.no_one_rises.black_dragon.brute',
  'order.no_one_rises.black_dragon.lurker',
  'order.no_one_rises.black_dragon.schemer',
  'order.no_quarter.demon.brute',
  'order.no_quarter.gnoll.brute',
  'order.no_quarter.gnoll.warlord',
  'order.no_quarter.goblin.brute',
  'order.no_quarter.goblin.warlord',
  'order.no_quarter.minotaur.brute',
  'order.no_quarter.minotaur.warlord',
  'order.no_quarter.orc.brute',
  'order.no_quarter.orc.warlord',
  'order.nobody_crosses.skeleton.brute',
  'order.nobody_crosses.skeleton.lurker',
  'order.nobody_crosses.skeleton.warlord',
  'order.nobody_crosses.troll.brute',
  'order.nobody_crosses.troll.lurker',
  'order.nobody_crosses.troll.warlord',
  'order.none_shall_pass.cultist.brute',
  'order.none_shall_pass.cultist.hexer',
  'order.none_shall_pass.cultist.zealot',
  'order.none_shall_pass.lizardfolk.brute',
  'order.none_shall_pass.lizardfolk.hexer',
  'order.none_shall_pass.lizardfolk.zealot',
  'order.none_shall_pass.troll.brute',
  'order.none_shall_pass.troll.hexer',
  'order.none_shall_pass.troll.zealot',
  'order.not_one_escapes.cultist.warlord',
  'order.not_one_escapes.cultist.zealot',
  'order.not_one_escapes.ghost.zealot',
  'order.not_one_escapes.gnoll.warlord',
  'order.not_one_escapes.gnoll.zealot',
  'order.not_one_escapes.mummy.warlord',
  'order.not_one_escapes.mummy.zealot',
  'order.not_one_escapes.orc.warlord',
  'order.not_one_escapes.orc.zealot',
  'order.oath_bound_charge.grim_giant.brute',
  'order.oath_bound_charge.grim_giant.hexer',
  'order.oath_bound_charge.grim_giant.warlord',
  'order.oblique_order.dark_elf.warlord',
  'order.oblique_order.skeleton.warlord',
  'order.oblique_order.soldier.warlord',
  'order.offer_it_the_wounded.kraken.brute',
  'order.offer_it_the_wounded.kraken.lurker',
  'order.offer_it_the_wounded.kraken.zealot',
  'order.on_my_signal.cultist.brute',
  'order.on_my_signal.cultist.warlord',
  'order.on_my_signal.cultist.zealot',
  'order.on_my_signal.goblin.brute',
  'order.on_my_signal.goblin.warlord',
  'order.on_my_signal.goblin.zealot',
  'order.on_my_signal.orc.brute',
  'order.on_my_signal.orc.warlord',
  'order.on_my_signal.orc.zealot',
  'order.one_last_throw.cultist.hexer',
  'order.one_last_throw.cultist.schemer',
  'order.one_last_throw.dark_elf.hexer',
  'order.one_last_throw.dark_elf.schemer',
  'order.one_last_throw.demon.hexer',
  'order.one_last_throw.demon.schemer',
  'order.one_last_throw.djinn.hexer',
  'order.one_last_throw.djinn.schemer',
  'order.one_last_throw.goblin.hexer',
  'order.one_last_throw.goblin.schemer',
  'order.one_target_all_arrows.beholder.hexer',
  'order.one_target_all_arrows.dark_elf.hexer',
  'order.one_target_all_arrows.dark_elf.warlord',
  'order.one_target_all_arrows.skeleton.hexer',
  'order.one_target_all_arrows.skeleton.warlord',
  'order.onto_the_open_sand.sandworm.brute',
  'order.onto_the_open_sand.sandworm.lurker',
  'order.open_order.elemental.brute',
  'order.open_order.gnoll.brute',
  'order.open_order.gnoll.schemer',
  'order.open_order.goblin.brute',
  'order.open_order.goblin.schemer',
  'order.open_order.orc.brute',
  'order.open_order.orc.schemer',
  'order.open_the_pit.demon.brute',
  'order.open_the_pit.demon.hexer',
  'order.open_the_pit.demon.zealot',
  'order.out_of_the_dark.black_dragon.brute',
  'order.out_of_the_dark.black_dragon.lurker',
  'order.out_of_the_dark.black_dragon.schemer',
  'order.out_of_the_sun.drake.beastmaster',
  'order.out_of_the_sun.drake.brute',
  'order.out_of_the_sun.great_eagle.beastmaster',
  'order.out_of_the_sun.great_eagle.brute',
  'order.overwatch.dark_elf.lurker',
  'order.overwatch.dark_elf.warlord',
  'order.overwatch.lizardfolk.lurker',
  'order.overwatch.lizardfolk.warlord',
  'order.overwatch.skeleton.lurker',
  'order.overwatch.skeleton.warlord',
  'order.pepper_the_laggard.bandit.beastmaster',
  'order.pepper_the_laggard.bandit.schemer',
  'order.pepper_the_laggard.beholder.schemer',
  'order.pepper_the_laggard.gnoll.beastmaster',
  'order.pepper_the_laggard.gnoll.schemer',
  'order.pepper_the_laggard.goblin.beastmaster',
  'order.pepper_the_laggard.goblin.schemer',
  'order.pepper_the_laggard.winter_court.beastmaster',
  'order.pepper_the_laggard.winter_court.schemer',
  'order.phalanx_advance.golem.warlord',
  'order.phalanx_advance.orc.brute',
  'order.phalanx_advance.orc.warlord',
  'order.phalanx_advance.skeleton.brute',
  'order.phalanx_advance.skeleton.warlord',
  'order.pickets_out.bandit.lurker',
  'order.pickets_out.bandit.schemer',
  'order.pickets_out.duergar.lurker',
  'order.pickets_out.duergar.schemer',
  'order.pickets_out.gnoll.lurker',
  'order.pickets_out.gnoll.schemer',
  'order.pike_and_shot.soldier.warlord',
  'order.pike_and_shot.soldier.zealot',
  'order.protect_the_maker.golem.hexer',
  'order.protect_the_maker.golem.schemer',
  'order.protect_the_maker.golem.warlord',
  'order.pull_them_under.sand_tentacles.lurker',
  'order.pull_them_under.sandworm.brute',
  'order.pull_them_under.sandworm.lurker',
  'order.pull_them_under.tentacles.lurker',
  'order.pull_them_under.vermin.brute',
  'order.pull_them_under.vermin.lurker',
  'order.rally_on_the_colours.bandit.warlord',
  'order.rally_on_the_colours.bandit.zealot',
  'order.rally_on_the_colours.goblin.warlord',
  'order.rally_on_the_colours.goblin.zealot',
  'order.rally_on_the_colours.skeleton.warlord',
  'order.rally_on_the_colours.skeleton.zealot',
  'order.rally_on_the_colours.soldier.warlord',
  'order.rally_on_the_colours.soldier.zealot',
  'order.rallying_howl.beast.beastmaster',
  'order.rallying_howl.beast.brute',
  'order.rallying_howl.cyclops.beastmaster',
  'order.rallying_howl.cyclops.brute',
  'order.rallying_howl.gnoll.beastmaster',
  'order.rallying_howl.gnoll.brute',
  'order.rallying_howl.wolf.beastmaster',
  'order.rallying_howl.wolf.brute',
  'order.rearguard.bandit.schemer',
  'order.rearguard.bandit.warlord',
  'order.rearguard.dark_elf.schemer',
  'order.rearguard.dark_elf.warlord',
  'order.rearguard.duergar.schemer',
  'order.rearguard.duergar.warlord',
  'order.rearguard.goblin.schemer',
  'order.rearguard.goblin.warlord',
  'order.rearguard.golem.schemer',
  'order.rearguard.golem.warlord',
  'order.reed_ring.bandit.lurker',
  'order.reed_ring.bandit.schemer',
  'order.reed_ring.gorgon.lurker',
  'order.reed_ring.gorgon.schemer',
  'order.reed_ring.lizardfolk.lurker',
  'order.reed_ring.lizardfolk.schemer',
  'order.refused_flank.dark_elf.schemer',
  'order.refused_flank.dark_elf.warlord',
  'order.relieve_the_front_rank.cultist.hexer',
  'order.relieve_the_front_rank.cultist.warlord',
  'order.relieve_the_front_rank.golem.hexer',
  'order.relieve_the_front_rank.golem.warlord',
  'order.relieve_the_front_rank.lizardfolk.hexer',
  'order.relieve_the_front_rank.lizardfolk.warlord',
  'order.relieve_the_front_rank.skeleton.hexer',
  'order.relieve_the_front_rank.skeleton.warlord',
  'order.relieve_the_front_rank.soldier.warlord',
  'order.ring_of_shadows.dark_elf.lurker',
  'order.ring_of_shadows.dark_elf.schemer',
  'order.ring_of_shadows.goblin.lurker',
  'order.ring_of_shadows.goblin.schemer',
  'order.ring_of_shadows.spider.lurker',
  'order.ring_of_shadows.spider.schemer',
  'order.ring_of_shadows.vampire.lurker',
  'order.ring_of_shadows.vampire.schemer',
  'order.ring_the_prize.gnoll.beastmaster',
  'order.ring_the_prize.gnoll.brute',
  'order.ring_the_prize.orc.beastmaster',
  'order.ring_the_prize.orc.brute',
  'order.ring_them_against_the_bank.kraken.brute',
  'order.ring_them_against_the_bank.kraken.lurker',
  'order.ring_them_against_the_bank.kraken.zealot',
  'order.rocks_and_ruin.cyclops.brute',
  'order.rocks_and_ruin.mountain_troll.brute',
  'order.rocks_and_ruin.mountain_troll.lurker',
  'order.rocks_and_ruin.mountain_troll.warlord',
  'order.rockslide_rush.cyclops.brute',
  'order.rockslide_rush.minotaur.brute',
  'order.rockslide_rush.minotaur.warlord',
  'order.rockslide_rush.mountain_troll.brute',
  'order.rockslide_rush.mountain_troll.lurker',
  'order.rockslide_rush.mountain_troll.warlord',
  'order.roots_and_thorns.ent.brute',
  'order.roots_and_thorns.ent.lurker',
  'order.roots_and_thorns.ent.zealot',
  'order.roots_and_thorns.fey.lurker',
  'order.run_down_the_wounded.beast.beastmaster',
  'order.run_down_the_wounded.beast.brute',
  'order.run_down_the_wounded.cyclops.beastmaster',
  'order.run_down_the_wounded.cyclops.brute',
  'order.run_down_the_wounded.gnoll.beastmaster',
  'order.run_down_the_wounded.gnoll.brute',
  'order.run_down_the_wounded.vampire.beastmaster',
  'order.run_down_the_wounded.wolf.beastmaster',
  'order.run_down_the_wounded.wolf.brute',
  'order.sacred_beasts.cultist.beastmaster',
  'order.sacred_beasts.cultist.zealot',
  'order.sacred_beasts.skeleton.beastmaster',
  'order.sacred_beasts.skeleton.zealot',
  'order.scatter_before_the_flame.demon.brute',
  'order.scatter_before_the_flame.demon.schemer',
  'order.scatter_before_the_flame.djinn.brute',
  'order.scatter_before_the_flame.djinn.schemer',
  'order.scatter_before_the_flame.dragon.brute',
  'order.scatter_before_the_flame.dragon.schemer',
  'order.scatter_before_the_flame.dragon.warlord',
  'order.scatter_before_the_flame.drake.brute',
  'order.scatter_for_the_maw.sandworm.brute',
  'order.scatter_for_the_maw.sandworm.lurker',
  'order.scatter_from_the_shadow.drake.beastmaster',
  'order.scatter_from_the_shadow.drake.brute',
  'order.scatter_from_the_shadow.great_eagle.beastmaster',
  'order.scatter_from_the_shadow.great_eagle.brute',
  'order.schiltron.bandit.warlord',
  'order.schiltron.bandit.zealot',
  'order.schiltron.cultist.warlord',
  'order.schiltron.cultist.zealot',
  'order.schiltron.mummy.warlord',
  'order.schiltron.mummy.zealot',
  'order.schiltron.skeleton.warlord',
  'order.schiltron.skeleton.zealot',
  'order.schiltron.soldier.warlord',
  'order.schiltron.soldier.zealot',
  'order.screen.bandit.brute',
  'order.screen.bandit.hexer',
  'order.screen.bandit.schemer',
  'order.screen.bandit.warlord',
  'order.screen.bandit.zealot',
  'order.screen.cultist.brute',
  'order.screen.cultist.hexer',
  'order.screen.cultist.schemer',
  'order.screen.cultist.warlord',
  'order.screen.cultist.zealot',
  'order.screen.goblin.brute',
  'order.screen.goblin.hexer',
  'order.screen.goblin.schemer',
  'order.screen.goblin.warlord',
  'order.screen.goblin.zealot',
  'order.screen.orc.brute',
  'order.screen.orc.hexer',
  'order.screen.orc.schemer',
  'order.screen.orc.warlord',
  'order.screen.orc.zealot',
  'order.screen.skeleton.brute',
  'order.screen.skeleton.hexer',
  'order.screen.skeleton.schemer',
  'order.screen.skeleton.warlord',
  'order.screen.skeleton.zealot',
  'order.seal_the_tomb.mummy.hexer',
  'order.seal_the_tomb.mummy.warlord',
  'order.seal_the_tomb.mummy.zealot',
  'order.shadow_the_flanks.gnoll.beastmaster',
  'order.shadow_the_flanks.gnoll.lurker',
  'order.shadow_the_flanks.wolf.beastmaster',
  'order.shadow_the_flanks.wolf.lurker',
  'order.shed_the_skin.basilisk.brute',
  'order.shed_the_skin.basilisk.hexer',
  'order.shed_the_skin.basilisk.lurker',
  'order.shed_the_skin.gorgon.hexer',
  'order.shed_the_skin.gorgon.lurker',
  'order.shield_and_spear.bandit.brute',
  'order.shield_and_spear.bandit.warlord',
  'order.shield_and_spear.orc.brute',
  'order.shield_and_spear.orc.warlord',
  'order.shield_and_spear.troll.brute',
  'order.shield_and_spear.troll.warlord',
  'order.shield_wall.bandit.brute',
  'order.shield_wall.bandit.warlord',
  'order.shield_wall.orc.brute',
  'order.shield_wall.orc.warlord',
  'order.shield_wall.skeleton.brute',
  'order.shield_wall.skeleton.warlord',
  'order.shield_wall.soldier.warlord',
  'order.shoot_from_the_hedges.bandit.lurker',
  'order.shoot_from_the_hedges.bandit.schemer',
  'order.shoot_from_the_hedges.goblin.lurker',
  'order.shoot_from_the_hedges.goblin.schemer',
  'order.shoot_from_the_hedges.gorgon.lurker',
  'order.shoot_from_the_hedges.gorgon.schemer',
  'order.shoot_from_the_hedges.lizardfolk.lurker',
  'order.shoot_from_the_hedges.lizardfolk.schemer',
  'order.shoot_in_the_dark.beholder.hexer',
  'order.shoot_in_the_dark.dark_elf.hexer',
  'order.shoot_in_the_dark.dark_elf.lurker',
  'order.shoot_in_the_dark.ghost.hexer',
  'order.shoot_in_the_dark.ghost.lurker',
  'order.shoot_in_the_dark.goblin.hexer',
  'order.shoot_in_the_dark.goblin.lurker',
  'order.shoot_in_the_dark.lizardfolk.hexer',
  'order.shoot_in_the_dark.lizardfolk.lurker',
  'order.silence_the_chanter.cultist.hexer',
  'order.silence_the_chanter.cultist.zealot',
  'order.silence_the_chanter.dark_elf.hexer',
  'order.silence_the_chanter.dark_elf.zealot',
  'order.silence_the_chanter.lizardfolk.hexer',
  'order.silence_the_chanter.lizardfolk.zealot',
  'order.skirmish_screen.bandit.schemer',
  'order.skirmish_screen.bandit.warlord',
  'order.skirmish_screen.dark_elf.schemer',
  'order.skirmish_screen.dark_elf.warlord',
  'order.skirmish_screen.goblin.schemer',
  'order.skirmish_screen.goblin.warlord',
  'order.slink_to_the_lair.beast.beastmaster',
  'order.slink_to_the_lair.beast.lurker',
  'order.spend_their_daylight.cultist.brute',
  'order.spend_their_daylight.cultist.warlord',
  'order.spend_their_daylight.cultist.zealot',
  'order.spend_their_daylight.orc.brute',
  'order.spend_their_daylight.orc.warlord',
  'order.spend_their_daylight.orc.zealot',
  'order.spend_their_daylight.zombie.brute',
  'order.spend_their_daylight.zombie.warlord',
  'order.spend_their_daylight.zombie.zealot',
  'order.spit_and_snare.dark_elf.beastmaster',
  'order.spit_and_snare.dark_elf.lurker',
  'order.spit_and_snare.gorgon.lurker',
  'order.spit_and_snare.spider.beastmaster',
  'order.spit_and_snare.spider.lurker',
  'order.spring_the_trap.bandit.lurker',
  'order.spring_the_trap.bandit.schemer',
  'order.spring_the_trap.gnoll.lurker',
  'order.spring_the_trap.gnoll.schemer',
  'order.spring_the_trap.goblin.lurker',
  'order.spring_the_trap.goblin.schemer',
  'order.spring_the_trap.lizardfolk.lurker',
  'order.spring_the_trap.lizardfolk.schemer',
  'order.spring_the_trap.mimic.lurker',
  'order.staked_goat.bandit.lurker',
  'order.staked_goat.bandit.schemer',
  'order.staked_goat.fey.lurker',
  'order.staked_goat.fey.schemer',
  'order.staked_goat.goblin.lurker',
  'order.staked_goat.goblin.schemer',
  'order.staked_goat.gorgon.lurker',
  'order.staked_goat.gorgon.schemer',
  'order.staked_goat.witch.schemer',
  'order.stamp_the_little_ones.cyclops.beastmaster',
  'order.stamp_the_little_ones.cyclops.brute',
  'order.stand_in_the_reeds.beast.beastmaster',
  'order.stand_in_the_reeds.beast.lurker',
  'order.stand_in_the_reeds.lizardfolk.beastmaster',
  'order.stand_in_the_reeds.lizardfolk.lurker',
  'order.stand_like_the_mountain.cyclops.brute',
  'order.stand_like_the_mountain.mountain_troll.brute',
  'order.stand_like_the_mountain.mountain_troll.lurker',
  'order.stand_like_the_mountain.mountain_troll.warlord',
  'order.stand_on_the_stones.cultist.brute',
  'order.stand_on_the_stones.cultist.warlord',
  'order.stand_on_the_stones.cultist.zealot',
  'order.stand_on_the_stones.mummy.warlord',
  'order.stand_on_the_stones.mummy.zealot',
  'order.stand_on_the_stones.skeleton.brute',
  'order.stand_on_the_stones.skeleton.warlord',
  'order.stand_on_the_stones.skeleton.zealot',
  'order.stand_on_the_stones.zombie.brute',
  'order.stand_on_the_stones.zombie.warlord',
  'order.stand_on_the_stones.zombie.zealot',
  'order.steady_the_line.bandit.warlord',
  'order.steady_the_line.orc.warlord',
  'order.steady_the_line.skeleton.warlord',
  'order.steady_the_line.soldier.warlord',
  'order.steppe_wheel.gnoll.beastmaster',
  'order.steppe_wheel.gnoll.warlord',
  'order.steppe_wheel.goblin.beastmaster',
  'order.steppe_wheel.goblin.warlord',
  'order.still_as_old_wood.ent.brute',
  'order.still_as_old_wood.ent.lurker',
  'order.still_as_old_wood.ent.zealot',
  'order.still_as_old_wood.fey.lurker',
  'order.still_as_old_wood.mimic.brute',
  'order.still_as_old_wood.mimic.lurker',
  'order.still_as_the_floor.mimic.lurker',
  'order.still_as_the_floor.ooze.lurker',
  'order.still_as_the_floor.sand_tentacles.lurker',
  'order.still_as_the_floor.spider.lurker',
  'order.still_as_the_floor.spider.schemer',
  'order.still_as_the_floor.tentacles.lurker',
  'order.still_water.beast.lurker',
  'order.still_water.ghost.hexer',
  'order.still_water.ghost.lurker',
  'order.still_water.lizardfolk.hexer',
  'order.still_water.lizardfolk.lurker',
  'order.still_water.spider.hexer',
  'order.still_water.spider.lurker',
  'order.still_water.zombie.hexer',
  'order.still_water.zombie.lurker',
  'order.strike_and_fade.black_dragon.brute',
  'order.strike_and_fade.black_dragon.lurker',
  'order.strike_and_fade.black_dragon.schemer',
  'order.strike_and_vanish.bandit.lurker',
  'order.strike_and_vanish.bandit.schemer',
  'order.strike_and_vanish.fey.lurker',
  'order.strike_and_vanish.fey.schemer',
  'order.strike_and_vanish.goblin.lurker',
  'order.strike_and_vanish.goblin.schemer',
  'order.strike_and_vanish.lizardfolk.lurker',
  'order.strike_and_vanish.lizardfolk.schemer',
  'order.strike_and_vanish.vampire.lurker',
  'order.strike_and_vanish.vampire.schemer',
  'order.swarm.elemental.brute',
  'order.swarm.gnoll.brute',
  'order.swarm.gnoll.warlord',
  'order.swarm.goblin.brute',
  'order.swarm.goblin.warlord',
  'order.swarm.vermin.brute',
  'order.swarm.zombie.brute',
  'order.swarm.zombie.warlord',
  'order.swarm_the_bleeding_one.maw_of_the_deep.brute',
  'order.swarm_the_bleeding_one.maw_of_the_deep.lurker',
  'order.swarm_the_cocooned.spider_queen.beastmaster',
  'order.swarm_the_cocooned.spider_queen.brute',
  'order.swarm_the_cocooned.spider_queen.lurker',
  'order.swarm_the_cocooned.vermin.brute',
  'order.swarm_the_cocooned.vermin.lurker',
  'order.take_the_heights.bandit.schemer',
  'order.take_the_heights.bandit.warlord',
  'order.take_the_heights.dark_elf.schemer',
  'order.take_the_heights.dark_elf.warlord',
  'order.take_the_heights.gnoll.schemer',
  'order.take_the_heights.gnoll.warlord',
  'order.take_the_heights.goblin.schemer',
  'order.take_the_heights.goblin.warlord',
  'order.take_the_one_who_strays.drake.beastmaster',
  'order.take_the_one_who_strays.drake.brute',
  'order.take_the_one_who_strays.great_eagle.beastmaster',
  'order.take_the_one_who_strays.great_eagle.brute',
  'order.take_the_rear.dark_elf.lurker',
  'order.take_the_rear.dark_elf.schemer',
  'order.take_the_rear.duergar.lurker',
  'order.take_the_rear.duergar.schemer',
  'order.take_the_rear.goblin.lurker',
  'order.take_the_rear.goblin.schemer',
  'order.take_the_rear.lizardfolk.lurker',
  'order.take_the_rear.lizardfolk.schemer',
  'order.take_the_straggler.winter_court.beastmaster',
  'order.take_the_straggler.yeti.beastmaster',
  'order.take_the_straggler.yeti.brute',
  'order.take_the_straggler.yeti.lurker',
  'order.the_alphas_charge.beast.beastmaster',
  'order.the_alphas_charge.beast.brute',
  'order.the_alphas_charge.minotaur.brute',
  'order.the_alphas_charge.orc.beastmaster',
  'order.the_alphas_charge.orc.brute',
  'order.the_alphas_charge.troll.beastmaster',
  'order.the_alphas_charge.troll.brute',
  'order.the_alphas_charge.wolf.beastmaster',
  'order.the_alphas_charge.wolf.brute',
  'order.the_blood_feast.vampire.beastmaster',
  'order.the_blood_feast.vampire.lurker',
  'order.the_blood_feast.vampire.schemer',
  'order.the_brood_swarms.beast.brute',
  'order.the_brood_swarms.beast.lurker',
  'order.the_brood_swarms.elemental.brute',
  'order.the_brood_swarms.ooze.brute',
  'order.the_brood_swarms.ooze.lurker',
  'order.the_brood_swarms.spider.brute',
  'order.the_brood_swarms.spider.lurker',
  'order.the_brood_swarms.zombie.brute',
  'order.the_brood_swarms.zombie.lurker',
  'order.the_circle_holds.cultist.hexer',
  'order.the_circle_holds.cultist.zealot',
  'order.the_circle_holds.skeleton.hexer',
  'order.the_circle_holds.skeleton.zealot',
  'order.the_circle_holds.witch.hexer',
  'order.the_circle_holds.witch.zealot',
  'order.the_cold_takes_the_weak.winter_court.beastmaster',
  'order.the_cold_takes_the_weak.yeti.beastmaster',
  'order.the_cold_takes_the_weak.yeti.brute',
  'order.the_cold_takes_the_weak.yeti.lurker',
  'order.the_drowned_rite.kraken.brute',
  'order.the_drowned_rite.kraken.lurker',
  'order.the_drowned_rite.kraken.zealot',
  'order.the_eye_sees_all.beholder.hexer',
  'order.the_eye_sees_all.beholder.schemer',
  'order.the_grave_calls.ghost.hexer',
  'order.the_grave_calls.ghost.zealot',
  'order.the_grave_calls.mummy.hexer',
  'order.the_grave_calls.mummy.zealot',
  'order.the_grave_calls.skeleton.hexer',
  'order.the_grave_calls.skeleton.zealot',
  'order.the_grave_calls.zombie.hexer',
  'order.the_grave_calls.zombie.zealot',
  'order.the_grudge_is_paid.duergar.lurker',
  'order.the_grudge_is_paid.duergar.schemer',
  'order.the_grudge_is_paid.duergar.warlord',
  'order.the_haunting.ghost.hexer',
  'order.the_haunting.ghost.lurker',
  'order.the_haunting.ghost.zealot',
  'order.the_hunger_rises.sandworm.brute',
  'order.the_hunger_rises.sandworm.lurker',
  'order.the_hunger_rises.vermin.brute',
  'order.the_hunger_rises.vermin.lurker',
  'order.the_hunger_wakes.maw_of_the_deep.brute',
  'order.the_hunger_wakes.maw_of_the_deep.lurker',
  'order.the_hungry_press.beast.brute',
  'order.the_hungry_press.elemental.brute',
  'order.the_hungry_press.ooze.brute',
  'order.the_hungry_press.zombie.brute',
  'order.the_kings_challenge.grim_giant.brute',
  'order.the_kings_challenge.grim_giant.hexer',
  'order.the_kings_challenge.grim_giant.warlord',
  'order.the_kings_challenge.minotaur.brute',
  'order.the_kings_challenge.minotaur.warlord',
  'order.the_long_hall.minotaur.brute',
  'order.the_long_hall.minotaur.warlord',
  'order.the_long_night.winter_court.beastmaster',
  'order.the_long_night.winter_court.hexer',
  'order.the_long_night.winter_court.schemer',
  'order.the_maelstrom.elemental.brute',
  'order.the_maelstrom.elemental.hexer',
  'order.the_many_eyes_watch.maw_of_the_deep.brute',
  'order.the_many_eyes_watch.maw_of_the_deep.lurker',
  'order.the_pack_drives.winter_court.beastmaster',
  'order.the_pack_drives.yeti.beastmaster',
  'order.the_pack_drives.yeti.brute',
  'order.the_pack_drives.yeti.lurker',
  'order.the_procession.cultist.beastmaster',
  'order.the_procession.cultist.zealot',
  'order.the_procession.skeleton.beastmaster',
  'order.the_procession.skeleton.zealot',
  'order.the_rearguard.duergar.warlord',
  'order.the_rearguard.lizardfolk.brute',
  'order.the_rearguard.lizardfolk.warlord',
  'order.the_rearguard.skeleton.brute',
  'order.the_rearguard.skeleton.warlord',
  'order.the_rearguard.troll.brute',
  'order.the_rearguard.troll.warlord',
  'order.the_ring_hunt.bandit.beastmaster',
  'order.the_ring_hunt.bandit.warlord',
  'order.the_ring_hunt.gnoll.beastmaster',
  'order.the_ring_hunt.gnoll.warlord',
  'order.the_ring_hunt.goblin.beastmaster',
  'order.the_ring_hunt.goblin.warlord',
  'order.the_ring_hunt.wolf.beastmaster',
  'order.the_ring_hunt.wolf.warlord',
  'order.the_shrouding.dark_elf.hexer',
  'order.the_shrouding.dark_elf.lurker',
  'order.the_shrouding.elemental.hexer',
  'order.the_shrouding.ghost.hexer',
  'order.the_shrouding.ghost.lurker',
  'order.the_shrouding.spider.hexer',
  'order.the_shrouding.spider.lurker',
  'order.the_shrouding.witch.hexer',
  'order.the_statue_garden.gorgon.hexer',
  'order.the_statue_garden.gorgon.lurker',
  'order.the_statue_garden.gorgon.schemer',
  'order.the_stone_curse.basilisk.brute',
  'order.the_stone_curse.basilisk.hexer',
  'order.the_stone_curse.basilisk.lurker',
  'order.the_stone_curse.beholder.hexer',
  'order.the_stone_curse.gorgon.hexer',
  'order.the_stone_curse.gorgon.lurker',
  'order.the_swarm_rises.vermin.brute',
  'order.the_swarm_rises.vermin.lurker',
  'order.the_trap_shuts.gnoll.beastmaster',
  'order.the_trap_shuts.gnoll.schemer',
  'order.the_trap_shuts.wolf.beastmaster',
  'order.the_twisted_wish.djinn.brute',
  'order.the_twisted_wish.djinn.hexer',
  'order.the_twisted_wish.djinn.schemer',
  'order.the_web_waits.beast.beastmaster',
  'order.the_web_waits.beast.lurker',
  'order.the_web_waits.lizardfolk.beastmaster',
  'order.the_web_waits.lizardfolk.lurker',
  'order.the_web_waits.spider.beastmaster',
  'order.the_web_waits.spider.lurker',
  'order.the_woods_close_in.ent.brute',
  'order.the_woods_close_in.ent.lurker',
  'order.the_woods_close_in.ent.zealot',
  'order.the_woods_close_in.fey.lurker',
  'order.tortoise.cultist.warlord',
  'order.tortoise.cultist.zealot',
  'order.tortoise.mummy.warlord',
  'order.tortoise.mummy.zealot',
  'order.tortoise.skeleton.warlord',
  'order.tortoise.skeleton.zealot',
  'order.tortoise.soldier.warlord',
  'order.tortoise.soldier.zealot',
  'order.troll_is_hungry.troll.hexer',
  'order.troll_is_hungry.troll.lurker',
  'order.tug_the_thread.beast.beastmaster',
  'order.tug_the_thread.beast.lurker',
  'order.tug_the_thread.spider.beastmaster',
  'order.tug_the_thread.spider.lurker',
  'order.tug_the_thread.spider.schemer',
  'order.turn_and_loose.beholder.schemer',
  'order.turn_and_loose.dark_elf.lurker',
  'order.turn_and_loose.dark_elf.schemer',
  'order.turn_and_loose.goblin.lurker',
  'order.turn_and_loose.goblin.schemer',
  'order.turn_the_champion.beast.beastmaster',
  'order.turn_the_champion.beast.brute',
  'order.turn_the_champion.cyclops.beastmaster',
  'order.turn_the_champion.cyclops.brute',
  'order.turn_the_champion.minotaur.brute',
  'order.turn_the_champion.troll.beastmaster',
  'order.turn_the_champion.troll.brute',
  'order.tusks_in_the_grass.orc.lurker',
  'order.tusks_in_the_grass.orc.warlord',
  'order.under_the_bridge.troll.beastmaster',
  'order.under_the_bridge.troll.lurker',
  'order.vanish_into_the_smoke.black_dragon.brute',
  'order.vanish_into_the_smoke.black_dragon.lurker',
  'order.vanish_into_the_smoke.black_dragon.schemer',
  'order.wait_beneath_the_surface.kraken.brute',
  'order.wait_beneath_the_surface.kraken.lurker',
  'order.wait_beneath_the_surface.kraken.zealot',
  'order.wait_on.great_eagle.beastmaster',
  'order.wait_on.great_eagle.brute',
  'order.wall_of_the_faithful.cultist.hexer',
  'order.wall_of_the_faithful.cultist.schemer',
  'order.wall_of_the_faithful.cultist.zealot',
  'order.wall_of_the_faithful.goblin.hexer',
  'order.wall_of_the_faithful.goblin.schemer',
  'order.wall_of_the_faithful.goblin.zealot',
  'order.wall_of_the_faithful.witch.hexer',
  'order.wall_of_the_faithful.witch.schemer',
  'order.wall_of_the_faithful.witch.zealot',
  'order.ward_the_front_rank.cultist.hexer',
  'order.ward_the_front_rank.cultist.warlord',
  'order.ward_the_front_rank.golem.hexer',
  'order.ward_the_front_rank.golem.warlord',
  'order.ward_the_front_rank.lizardfolk.hexer',
  'order.ward_the_front_rank.lizardfolk.warlord',
  'order.ward_the_front_rank.skeleton.hexer',
  'order.ward_the_front_rank.skeleton.warlord',
  'order.web_the_doorway.dark_elf.beastmaster',
  'order.web_the_doorway.dark_elf.lurker',
  'order.web_the_doorway.dark_elf.schemer',
  'order.web_the_doorway.spider.beastmaster',
  'order.web_the_doorway.spider.lurker',
  'order.web_the_doorway.spider.schemer',
  'order.web_the_ways.spider_queen.beastmaster',
  'order.web_the_ways.spider_queen.brute',
  'order.web_the_ways.spider_queen.lurker',
  'order.wings_over_the_field.dragon.brute',
  'order.wings_over_the_field.dragon.schemer',
  'order.wings_over_the_field.dragon.warlord',
  'order.wings_over_the_field.drake.brute',
  'order.witch_fire_volley.bandit.hexer',
  'order.witch_fire_volley.bandit.warlord',
  'order.witch_fire_volley.dark_elf.hexer',
  'order.witch_fire_volley.dark_elf.warlord',
  'order.witch_fire_volley.demon.hexer',
  'order.witch_fire_volley.elemental.hexer',
  'order.witch_fire_volley.goblin.hexer',
  'order.witch_fire_volley.goblin.warlord',
  'pet.bear_alert',
  'pet.bear_comfort',
  'pet.bear_happy',
  'pet.bear_play',
  'pet.bird_alert',
  'pet.bird_comfort',
  'pet.bird_happy',
  'pet.bird_play',
  'pet.cat_alert',
  'pet.cat_comfort',
  'pet.cat_happy',
  'pet.cat_play',
  'pet.critter_alert',
  'pet.critter_comfort',
  'pet.critter_happy',
  'pet.critter_play',
  'pet.splash',
  'pet.wolf_alert',
  'pet.wolf_comfort',
  'pet.wolf_happy',
  'pet.wolf_play',
  'ping.danger',
  'ping.go',
  'ping.help',
  'ping.hold',
  'ping.look',
  'place.camp',
  'place.fire',
  'place.shop',
  'place.smithy',
  'place.study',
  'place.tavern',
  'place.title',
  'place.town',
  'plan.clear',
  'plan.commit',
  'plan.place',
  'plan.select',
  'plan.struck',
  'plan.tick',
  'pulse.lock',
  'pulse.open',
  'pulse.pause',
  'pulse.ready',
  'pulse.resume',
  'pulse.unready',
  'push.bump',
  'push.impact',
  'song.cast',
  'song.dissonant',
  'song.finale',
  'song.mockery',
  'song.mockery_hit',
  'spell.acid_burst',
  'spell.acid_cast',
  'spell.acid_hit',
  'spell.acid_shoot',
  'spell.arcane_cast',
  'spell.arcane_hit',
  'spell.arcane_shoot',
  'spell.barkskin',
  'spell.blink',
  'spell.buff',
  'spell.burrow',
  'spell.consecrate',
  'spell.debuff',
  'spell.earth_burst',
  'spell.earth_cast',
  'spell.earth_hit',
  'spell.fire_burst',
  'spell.fire_cast',
  'spell.fire_hit',
  'spell.fire_shoot',
  'spell.force_dart',
  'spell.force_hit',
  'spell.frost_burst',
  'spell.frost_cast',
  'spell.frost_hit',
  'spell.frost_shoot',
  'spell.gale',
  'spell.heal',
  'spell.holy_cast',
  'spell.holy_chime',
  'spell.holy_hit',
  'spell.judgement',
  'spell.lightning_bolt',
  'spell.lightning_cast',
  'spell.lightning_hit',
  'spell.mark',
  'spell.nature',
  'spell.nature_cast',
  'spell.nature_hit',
  'spell.nature_shoot',
  'spell.necrotic_cast',
  'spell.necrotic_hit',
  'spell.overgrowth',
  'spell.paladin_radiance',
  'spell.paladin_steel',
  'spell.poison',
  'spell.potion',
  'spell.quagmire',
  'spell.radiant_bolt',
  'spell.radiant_burst',
  'spell.revive',
  'spell.shadow',
  'spell.smoke',
  'spell.summon',
  'spell.thunder_burst',
  'spell.thunder_cast',
  'spell.thunder_hit',
  'spell.upheaval',
  'spell.ward',
  'spell.web',
  'spell.wind_cast',
  'spell.wind_hit',
  'spell.wither',
  'stash.gold',
  'stash.open',
  'status.bleeding',
  'status.burning',
  'status.extinguish',
  'status.floundering',
  'status.freed',
  'status.guarded',
  'status.hidden',
  'status.rooted',
  'step.bones',
  'step.chain',
  'step.deep',
  'step.dirt',
  'step.ember',
  'step.grass',
  'step.gravel',
  'step.ice',
  'step.land_heavy',
  'step.leaves',
  'step.mud',
  'step.plate',
  'step.sand',
  'step.shallow',
  'step.slime',
  'step.snow',
  'step.stomp',
  'step.stone',
  'step.swim',
  'step.wood',
  'strike.backstab',
  'strike.backstab_glint',
  'swing.blade',
  'swing.heavy',
  'swing.light',
  'tentacle.burst',
  'tentacle.rumble',
  'tentacle.sand',
  'tentacle.sink',
  'throw.whoosh',
  'trap.alarm',
  'trap.blade',
  'trap.buzz',
  'trap.cackle',
  'trap.cage',
  'trap.chime',
  'trap.clang',
  'trap.click',
  'trap.crackle',
  'trap.crash',
  'trap.creak',
  'trap.crumble',
  'trap.darts',
  'trap.disarm',
  'trap.drain',
  'trap.found',
  'trap.gong',
  'trap.grind',
  'trap.hiss',
  'trap.laugh',
  'trap.lava',
  'trap.net',
  'trap.polymorph',
  'trap.pop',
  'trap.roar',
  'trap.roll',
  'trap.rumble',
  'trap.rush',
  'trap.spikes',
  'trap.splash',
  'trap.squawk',
  'trap.thunder',
  'trap.walls',
  'trap.warp',
  'trap.water_rise',
  'trap.whoosh',
  'ui.back',
  'ui.chat',
  'ui.chest',
  'ui.click',
  'ui.close',
  'ui.coins',
  'ui.coins_big',
  'ui.confirm',
  'ui.dice',
  'ui.equip_armour',
  'ui.equip_trinket',
  'ui.equip_weapon',
  'ui.error',
  'ui.forge',
  'ui.forged',
  'ui.gems',
  'ui.hover',
  'ui.item',
  'ui.leaves',
  'ui.levelup',
  'ui.loot',
  'ui.loot_rare',
  'ui.open',
  'ui.page',
  'ui.points',
  'ui.potion',
  'ui.retro',
  'ui.scroll',
  'ui.tab',
  'ui.title',
  'ui.toast',
  'ui.toggle',
  'ui.trade',
  'ui.transition',
  'ui.type',
  'ui.world_begins',
  'voice.basilisk_attack',
  'voice.basilisk_death',
  'voice.basilisk_hurt',
  'voice.basilisk_taunt',
  'voice.beast_attack',
  'voice.beast_death',
  'voice.beast_hurt',
  'voice.beast_taunt',
  'voice.bird_attack',
  'voice.bird_death',
  'voice.bird_hurt',
  'voice.bird_taunt',
  'voice.broodmother_attack',
  'voice.broodmother_death',
  'voice.broodmother_hurt',
  'voice.broodmother_taunt',
  'voice.brute_attack',
  'voice.brute_death',
  'voice.brute_hurt',
  'voice.brute_taunt',
  'voice.bull_attack',
  'voice.bull_death',
  'voice.bull_hurt',
  'voice.bull_taunt',
  'voice.cat_attack',
  'voice.cat_death',
  'voice.cat_hurt',
  'voice.cat_taunt',
  'voice.chest_attack',
  'voice.chest_death',
  'voice.chest_hurt',
  'voice.chest_taunt',
  'voice.construct_attack',
  'voice.construct_death',
  'voice.construct_hurt',
  'voice.construct_taunt',
  'voice.critter_attack',
  'voice.critter_death',
  'voice.critter_hurt',
  'voice.critter_taunt',
  'voice.dragon_attack',
  'voice.dragon_death',
  'voice.dragon_hurt',
  'voice.dragon_taunt',
  'voice.eagle_attack',
  'voice.eagle_death',
  'voice.eagle_hurt',
  'voice.eagle_taunt',
  'voice.fiend_attack',
  'voice.fiend_death',
  'voice.fiend_hurt',
  'voice.fiend_taunt',
  'voice.giant_attack',
  'voice.giant_death',
  'voice.giant_hurt',
  'voice.giant_taunt',
  'voice.hag_attack',
  'voice.hag_death',
  'voice.hag_hurt',
  'voice.hag_taunt',
  'voice.hound_attack',
  'voice.hound_death',
  'voice.hound_hurt',
  'voice.hound_taunt',
  'voice.insect_attack',
  'voice.insect_death',
  'voice.insect_hurt',
  'voice.insect_taunt',
  'voice.jotun_attack',
  'voice.jotun_death',
  'voice.jotun_hurt',
  'voice.jotun_taunt',
  'voice.kraken_attack',
  'voice.kraken_death',
  'voice.kraken_hurt',
  'voice.kraken_taunt',
  'voice.man_attack',
  'voice.man_death',
  'voice.man_exert',
  'voice.man_hurt',
  'voice.man_taunt',
  'voice.maw_attack',
  'voice.maw_death',
  'voice.maw_hurt',
  'voice.maw_taunt',
  'voice.orc_attack',
  'voice.orc_death',
  'voice.orc_hurt',
  'voice.orc_taunt',
  'voice.reptile_attack',
  'voice.reptile_death',
  'voice.reptile_hurt',
  'voice.reptile_taunt',
  'voice.slime_attack',
  'voice.slime_death',
  'voice.slime_hurt',
  'voice.slime_taunt',
  'voice.small_attack',
  'voice.small_death',
  'voice.small_hurt',
  'voice.small_taunt',
  'voice.spirit_attack',
  'voice.spirit_death',
  'voice.spirit_hurt',
  'voice.spirit_taunt',
  'voice.tentacle_attack',
  'voice.tentacle_death',
  'voice.tentacle_hurt',
  'voice.tentacle_taunt',
  'voice.treant_attack',
  'voice.treant_death',
  'voice.treant_hurt',
  'voice.treant_taunt',
  'voice.undead_attack',
  'voice.undead_death',
  'voice.undead_hurt',
  'voice.undead_taunt',
  'voice.vampire_attack',
  'voice.vampire_death',
  'voice.vampire_hurt',
  'voice.vampire_taunt',
  'voice.woman_attack',
  'voice.woman_death',
  'voice.woman_exert',
  'voice.woman_hurt',
  'voice.woman_taunt',
  'voice.worm_attack',
  'voice.worm_death',
  'voice.worm_hurt',
  'voice.worm_taunt',
  'voice.wyrm_attack',
  'voice.wyrm_death',
  'voice.wyrm_hurt',
  'voice.wyrm_taunt',
  'voice.yeti_attack',
  'voice.yeti_death',
  'voice.yeti_hurt',
  'voice.yeti_taunt',
  'voice.zombie_attack',
  'voice.zombie_death',
  'voice.zombie_hurt',
  'voice.zombie_taunt',
  'wild.bat',
  'wild.critter',
  'wild.crow',
  'wild.frog',
  'wild.hawk',
  'wild.insect',
  'wild.mouse',
  'wild.songbird',
  'wild.swallow',
  'wild.wings',
  'wx.blizzard',
  'wx.fog',
  'wx.gust',
  'wx.rain',
  'wx.storm',
  'wx.thunder',
  'wx.wind',
];
